import React, { useState, useEffect, useRef } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Col,
  Form,
  Row,
  Modal,
  Button,
  OverlayTrigger,
  Tooltip,
  Accordion,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import { useFilter } from "../../../../context/FilterContext";
import {
  POST_Amendment_GetInwardMaterialDetails,
  POST_Amendment_Save,
  POST_CancelTestSave,
  POST_CancelTest_GetInwardMaterialDetails,
  POST_ControlCenterInwardTPIDetailsSave,
  POST_ControlCenterScanCopyEmailSend,
  POST_DDLGetTestMasterByCompanyID,
  POST_GetControlCenterInvoiceEmailDetailList,
  POST_GetControlCenterInwardMaterialMachineCertificateEmailDetail,
  POST_GetControlCenterInwardStatistics,
  POST_GetControlCenterList,
  POST_GetControlCenterScanCopyEmailDetailList,
  POST_GetCustomerContactPersonDDL,
  POST_GetCustomerDDLList,
  POST_GetCustomerDDLListAJAX,
  POST_GetCustomerProjectList,
  POST_GetDDLTestMasterByDepartmentProductGroupMaterialType,
  POST_GetDepartmentDropDownList,
  POST_GetLabFormDownload,
  POST_GetMaterialInwardDetailByID,
  POST_GetMaterialInwardReTestDetailByID,
  POST_GetMaterialTypeDDLListByDepartment_ProductGroup,
  POST_GetSampleRequestFormDownload,
  POST_GetTestMethodDDL_ReferenceStandardDDL_TestMasterDetails_ByTestMasterID,
  POST_MaterialInwardDelete,
  POST_MaterialInwardReTestInsert,
  POST_ProductGroupDropDownListByDepartmentID,
  POST_ControlCenterMachineCertificateEmailSend,
  POST_Rewise_GetInwardMaterialDetails,
  POST_GetVoucherSeriesDDLList,
  POST_RewiseInwardMaterialSave,
  POST_GetTestParametersList,
  POST_GetMixDesignMasterDropDownListAll,
  POST_GetTestWiseDefineMoreRatesList,
  POST_GetReferenceStandardTestSubGroupDDL,
  POST_GetParametersPreferenceListBasedOnRefStandardTestSubGroup,
  POST_ControlCenterGetInwardTestDefineMoreRatesList,
  POST_ControlCenterInwardTestDefineMoreRatesSave,
} from "../../../helpers/url_helper";
import {
  cleanCsvString,
  convertTimeToDateTime,
  delete_Record,
  delete_RecordWithoutApi,
  errorMessage,
  infoMessage,
  successMessage,
  validateEmail,
  warningMessage,
} from "../CommonFunctions";
import { dataUrlToFileUsingFetch } from "../../../CustomControls/Utils";
import Webcam from "react-webcam";
import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";

const SamplePreparationAndTesting = () => {
  const { filter, updateFilter } = useFilter();

  const [showFilter, setShowFilter] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "sample-preparation-testing"
      ? filter?.CurrentPage
      : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "sample-preparation-testing"
      ? filter?.PageSize
      : 10
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "sample-preparation-testing" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "sample-preparation-testing"
      ? filter?.orderBy
      : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [customerProjectOptions, setCustomerProjectOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [productGroupOptions, setProductGroupOptions] = useState([]);
  const [materialTypeOptions, setMaterialTypeOptions] = useState([]);
  const [testOptions, setTestOptions] = useState([]);

  const webcamRef = useRef(null);

  const videoConstraints = {
    width: 600,
    height: 600,
    facingMode: "environment",
  };

  const currentDate = new Date();
  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      InwardNo:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.InwardNo
          : "",
      FromDate:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.FromDate
          : new Date(currentDate.setMonth(currentDate.getMonth() - 1)),
      ToDate:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.ToDate
          : new Date(),
      CustomerIDEncrypted:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.CustomerIDEncrypted
          : "",
      CustomerName:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.CustomerName
          : "",
      CustomerProjectIDEncrypted:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.CustomerProjectIDEncrypted
          : "",
      ProjectDetails:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.ProjectDetails
          : "",
      LetterRefNo:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.LetterRefNo
          : "",
      ProcessFormID:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.ProcessFormID
          : "",
      Status:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.Status
          : "",
      TCNo:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.TCNo
          : "",
      SampleDetail:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.SampleDetail
          : "",
      ULRNo:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.ULRNo
          : "",
      DepartmentIDEncrypted:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.DepartmentIDEncrypted
          : "",
      ProductGroupIDEncrypted:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.ProductGroupIDEncrypted
          : "",
      MaterialTypeIDEncrypted:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.MaterialTypeIDEncrypted
          : "",
      TestMasterIDEncrypted:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.TestMasterIDEncrypted
          : "",
      TestMethodIDEncrypted:
        filter && filter?.page == "sample-preparation-testing"
          ? filter?.TestMethodIDEncrypted
          : "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: {
      InwardNo,
      FromDate,
      ToDate,
      CustomerIDEncrypted,
      CustomerName,
      CustomerProjectIDEncrypted,
      ProjectDetails,
      LetterRefNo,
      ProcessFormID,
      Status,
      TCNo,
      SampleDetail,
      ULRNo,
      DepartmentIDEncrypted,
      ProductGroupIDEncrypted,
      MaterialTypeIDEncrypted,
      TestMasterIDEncrypted,
      TestMethodIDEncrypted,
    },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  const validationSchema = Yup.object().shape({});

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      controlCenterList: [],
      TotalInward: 0,
      TotalTC: 0,
      TotalTest: 0,
      TotalCustomer: 0,
      TotalDraft: 0,
      TotalCancelledTest: 0,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      controlCenterList,
      TotalInward,
      TotalTC,
      TotalTest,
      TotalCustomer,
      TotalDraft,
      TotalCancelledTest,
    },
  } = formik;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      InwardNo: "",
      FromDate: new Date(currentDate.setMonth(currentDate.getMonth() - 1)),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      ProjectDetails: "",
      LetterRefNo: "",
      ProcessFormID: "",
      Status: "",
      TCNo: "",
      SampleDetail: "",
      ULRNo: "",
      DepartmentIDEncrypted: "",
      ProductGroupIDEncrypted: "",
      MaterialTypeIDEncrypted: "",
      TestMasterIDEncrypted: "",
      TestMethodIDEncrypted: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const getCustomerDDL_AJAX = (inputValue) => {
    return post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const loadOptionsCustomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerProjectDDL = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: customerID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            }))
          );
          if (
            response?.CustomerProjectDDLList?.length > 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted
            ).length == 0
          ) {
            formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (CustomerIDEncrypted) {
      getCustomerProjectDDL(CustomerIDEncrypted);
    } else {
      setCustomerProjectOptions([]);
      formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
    }
  }, [CustomerIDEncrypted]);

  const getDepartmentDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item.DepartmentName,
              value: item.DepartmentIDEncrypted,
            }))
          );
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProductGroupDDL = async (departmentID) => {
    setIsLoading(true);
    await post(POST_ProductGroupDropDownListByDepartmentID, {
      DepartmentIDEncrypt: departmentID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProductGroupOptions(
            response?.ProductGroupDropDownList?.map((item) => ({
              label: item.ProductGroupName,
              value: item.ProductGroupIDEncrypt,
            }))
          );
          if (
            response?.ProductGroupDropDownList?.length > 0 &&
            ProductGroupIDEncrypted &&
            response?.ProductGroupDropDownList?.filter(
              (x) => x.ProductGroupIDEncrypt == ProductGroupIDEncrypted
            ).length == 0
          ) {
            formikFilter.setFieldValue("ProductGroupIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (DepartmentIDEncrypted) {
      getProductGroupDDL(DepartmentIDEncrypted);
    } else {
      setProductGroupOptions([]);
      formikFilter.setFieldValue("ProductGroupIDEncrypted", "");
    }
  }, [DepartmentIDEncrypted]);

  const getMaterialTypeDDL = async (departmentID, productGroupID) => {
    setIsLoading(true);
    await post(POST_GetMaterialTypeDDLListByDepartment_ProductGroup, {
      DepartmentIDEncrypted: departmentID,
      ProductGroupIDEncrypted: productGroupID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setMaterialTypeOptions(
            response?.MaterialTypeList?.map((item) => ({
              label: item.MaterialTypeName,
              value: item.MaterialTypeIDEncrypted,
            }))
          );
          if (
            response?.MaterialTypeList?.length > 0 &&
            MaterialTypeIDEncrypted &&
            response?.MaterialTypeList?.filter(
              (x) => x.MaterialTypeIDEncrypted == MaterialTypeIDEncrypted
            ).length == 0
          ) {
            formikFilter.setFieldValue("MaterialTypeIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (DepartmentIDEncrypted && ProductGroupIDEncrypted) {
      getMaterialTypeDDL(DepartmentIDEncrypted, ProductGroupIDEncrypted);
    } else {
      setMaterialTypeOptions([]);
      formikFilter.setFieldValue("MaterialTypeIDEncrypted", "");
    }
  }, [ProductGroupIDEncrypted]);

  const getTestDDL = async () => {
    //setIsLoading(true);
    await post(POST_DDLGetTestMasterByCompanyID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TestType: 1, // 0 - All, 1 - DT, 2 - NDT
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTestOptions(
            response?.List?.map((item) => ({
              label: item.TestName,
              value: item.TestMasterIDEncrypted,
            }))
          );
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "sample-preparation-testing",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      InwardNo: InwardNo,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerName: CustomerName,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      ProjectDetails: ProjectDetails,
      LetterRefNo: LetterRefNo,
      ProcessFormID: ProcessFormID ? ProcessFormID : "",
      Status: Status,
      TCNo: TCNo,
      SampleDetail: SampleDetail,
      ULRNo: ULRNo,
      DepartmentIDEncrypted: DepartmentIDEncrypted,
      ProductGroupIDEncrypted: ProductGroupIDEncrypted,
      MaterialTypeIDEncrypted: MaterialTypeIDEncrypted,
      TestMasterIDEncrypted: TestMasterIDEncrypted,
      TestMethodIDEncrypted: TestMethodIDEncrypted,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      InwardNo: InwardNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      ProjectDetails: ProjectDetails,
      LetterRefNo: LetterRefNo,
      ProcessFormID: ProcessFormID ? ProcessFormID : 0,
      //Status: Status,
      Status: Array.from(Status, (x) => x.value).join(","),
      TCNo: TCNo,
      SampleDetail: SampleDetail,
      ULRNo: ULRNo,
      DepartmentIDEncrypted: DepartmentIDEncrypted,
      ProductGroupIDEncrypted: ProductGroupIDEncrypted,
      MaterialTypeIDEncrypted: MaterialTypeIDEncrypted,
      TestMasterIDEncrypted: TestMasterIDEncrypted,
      TestMethodIDEncrypted: TestMethodIDEncrypted,
    };
    await post(POST_GetControlCenterList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        formik.setValues({
          controlCenterList: response?.controlCenterList?.map((item) => ({
            ...item,
            showDetail: false,
          })),
          TotalInward: response?.TotalInward,
          TotalTC: response?.TotalTC,
          TotalTest: response?.TotalTest,
          TotalCustomer: response?.TotalCustomer,
          TotalDraft: response?.TotalDraft,
          TotalCancelledTest: response?.TotalCancelledTest,
        });
        setIsLoading(false);
        if (page > 1 && response?.controlCenterList?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    //getProcessFormDDL();
    getDepartmentDDL();
    getTestDDL();
    //getTPICustomerDDL();
  }, []);

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const [showInwardStatisticsModal, setShowInwardStatisticsModal] =
    useState(false);
  const [listOfInwardStatistics, setListOfInwardStatistics] = useState([]);

  const getInwardStatistics = async (inwardID) => {
    setIsLoading(true);
    await post(POST_GetControlCenterInwardStatistics, {
      InwardIDEncrypted: inwardID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setListOfInwardStatistics(response?.ListOfInwardStatistics);
        } else {
          setListOfInwardStatistics([]);
        }
        setShowInwardStatisticsModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showContactPersonModal, setShowContactPersonModal] = useState(false);
  const [listOfContactPerson, setListOfContactPerson] = useState([]);

  const ViewContactPerson = (index) => {
    setListOfContactPerson(
      controlCenterList?.filter((x, i) => i == index)[0]?.ListOfContactPersons
    );
    setShowContactPersonModal(true);
  };

  const [showSendScanCopyModal, setShowSendScanCopyModal] = useState(false);
  const [sscContactPersonOptions, setsscContactPersonOptions] = useState([]);

  const validationSchemaSendScanCopy = Yup.object().shape({});

  const formikSendScanCopy = useFormik({
    validationSchemaSendScanCopy,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendScanCopy(values, formikHelpers),
    initialValues: {
      InwardIDEncrypted: "",
      InwardMaterialIDEncrypted: "",
      sscListOfProjectContactPerson: [],
      sscListOfCustomerContactPerson: [],
      sscListOfLetterRefDoc: [],
      sscListOfAdditionalContactPerson: [],
      sscAdditionalEmailID: "",
      sscCustomerIDEncrypted: "",
      sscCustomerName: "",
      sscCustomerContactPersonIDEncrypted: "",
      sscContactPerson: "",
      sscDesignation: "",
      sscMobileNo: "",
      sscEmailID: "",
      sscContactPersonID: "",
      AllTCNos: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      sscListOfProjectContactPerson,
      sscListOfCustomerContactPerson,
      sscListOfLetterRefDoc,
      sscListOfAdditionalContactPerson,
      sscCustomerIDEncrypted,
      sscCustomerName,
      sscCustomerContactPersonIDEncrypted,
      sscContactPerson,
      sscDesignation,
      sscMobileNo,
      sscEmailID,
      sscContactPersonID,
      AllTCNos,
    },
  } = formikSendScanCopy;

  const loadOptionsCustomer_SSC = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  useEffect(() => {
    if (sscCustomerIDEncrypted) {
      getCustomerContactPersonDDL_SSC(sscCustomerIDEncrypted);
    } else {
      setsscContactPersonOptions([]);
      formikSendScanCopy.setFieldValue(
        "sscCustomerContactPersonIDEncrypted",
        ""
      );
      formikSendScanCopy.setFieldValue("sscContactPerson", "");
      formikSendScanCopy.setFieldValue("sscDesignation", "");
      formikSendScanCopy.setFieldValue("sscMobileNo", "");
      formikSendScanCopy.setFieldValue("sscEmailID", "");
      formikSendScanCopy.setFieldValue("sscContactPersonID", "");
    }
  }, [sscCustomerIDEncrypted]);

  const getCustomerContactPersonDDL_SSC = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: customerID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setsscContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
              MobileNo: item.MobileNo,
              EmailID: item.EmailID,
              Designation: item.Designation,
              ContactPersonID: item.ContactPersonID,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        isLoading(false);
      });
  };

  const openSendScanCopyDialog = async (
    inwardID,
    inwardMaterialID = "",
    AllTCNos = ""
  ) => {
    setIsLoading(true);
    await post(POST_GetControlCenterScanCopyEmailDetailList, {
      InwardIDEncrypted: inwardID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendScanCopy.setValues({
            InwardIDEncrypted: inwardID,
            InwardMaterialIDEncrypted: inwardMaterialID,
            sscListOfProjectContactPerson: response?.ListOfContactPerson?.map(
              (x) => ({
                ...x,
                IsSelected: false,
                ModeType: x?.ModeDetail,
              })
            ),
            sscListOfCustomerContactPerson:
              response?.ListOfCustomerContactPerson?.map((x) => ({
                ...x,
                IsSelected: false,
              })),
            sscListOfLetterRefDoc: response?.ListOfLetterRefDoc?.map((x) => ({
              ...x,
              IsSelected: false,
              LetterRefImageFileName: x?.LetterRefImageFileName,
              // LetterRefImageFileName: x?.LetterRefImageFilePath
              //   ? (x?.LetterRefImageFilePath?.split("/"))[
              //       x?.LetterRefImageFilePath?.split("/").length - 1
              //     ]
              //   : "",
            })),
            sscListOfAdditionalContactPerson: [],
            sscAdditionalEmailID: "",
            sscCustomerIDEncrypted: "",
            sscCustomerName: "",
            sscCustomerContactPersonIDEncrypted: "",
            sscContactPerson: "",
            sscDesignation: "",
            sscMobileNo: "",
            sscEmailID: "",
            sscContactPersonID: "",
            AllTCNos: AllTCNos,
          });
        } else {
          formikSendScanCopy.resetForm();
        }
        setShowSendScanCopyModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const addAdditionalContactPerson_SSC = () => {
    if (sscCustomerIDEncrypted && sscCustomerContactPersonIDEncrypted) {
      if (
        sscListOfAdditionalContactPerson?.filter(
          (x) =>
            x?.CustomerContactPersonIDEncrypted ==
            sscCustomerContactPersonIDEncrypted
        )?.length == 0
      ) {
        formikSendScanCopy.setFieldValue("sscListOfAdditionalContactPerson", [
          ...sscListOfAdditionalContactPerson,
          {
            IsSelected: true,
            CustomerName: sscCustomerName,
            CustomerContactPersonIDEncrypted:
              sscCustomerContactPersonIDEncrypted,
            ContactPerson: sscContactPerson,
            Designation: sscDesignation,
            MobileNo: sscMobileNo,
            EmailID: sscEmailID,
            ContactPersonID: sscContactPersonID,
          },
        ]);
        formikSendScanCopy.setFieldValue(
          "sscCustomerContactPersonIDEncrypted",
          ""
        );
        formikSendScanCopy.setFieldValue("sscContactPerson", "");
        formikSendScanCopy.setFieldValue("sscDesignation", "");
        formikSendScanCopy.setFieldValue("sscMobileNo", "");
        formikSendScanCopy.setFieldValue("sscEmailID", "");
        formikSendScanCopy.setFieldValue("sscContactPersonID", "");
      } else {
        //show duplicate error
        warningMessage("Contact Person already exists!");
      }
    } else {
      if (!sscCustomerIDEncrypted) {
        formikSendScanCopy.setFieldError(
          "sscCustomerIDEncrypted",
          "Customer is required field"
        );
        formikSendScanCopy.setFieldTouched("sscCustomerIDEncrypted", true);
      }
      if (!sscCustomerContactPersonIDEncrypted) {
        formikSendScanCopy.setFieldError(
          "sscCustomerContactPersonIDEncrypted",
          "Contact Person is required field"
        );
        formikSendScanCopy.setFieldTouched(
          "sscCustomerContactPersonIDEncrypted",
          true
        );
      }
    }
  };

  const handleValidSubmitSendScanCopy = async (values) => {
    if (values?.InwardIDEncrypted) {
      let listOfAdditionalEmails = values?.sscAdditionalEmailID?.trim()
        ? cleanCsvString(values?.sscAdditionalEmailID)?.split(",")
        : [];
      if (
        values?.sscListOfProjectContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        values?.sscListOfCustomerContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        values?.sscListOfAdditionalContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        listOfAdditionalEmails?.length == 0
      ) {
        warningMessage(
          "Please select contact person or enter additional email to send!"
        );
      } else {
        if (
          listOfAdditionalEmails?.length > 0 &&
          listOfAdditionalEmails?.filter((x) => validateEmail(x) == null)
            ?.length > 0
        ) {
          formikSendScanCopy.setFieldError(
            "sscAdditionalEmailID",
            "Please check it contains invalid email address"
          );
          formikSendScanCopy.setFieldTouched("sscAdditionalEmailID", true);
        } else {
          setIsLoading(true);

          let emailCsv = "";
          Promise.all(
            values?.sscListOfProjectContactPerson
              ?.filter((x) => x.IsSelected == true)
              ?.map((x) => {
                emailCsv =
                  emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
              }),
            values?.sscListOfCustomerContactPerson
              ?.filter((x) => x.IsSelected == true)
              ?.map((x) => {
                emailCsv =
                  emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
              }),
            values?.sscListOfAdditionalContactPerson
              ?.filter((x) => x.IsSelected == true)
              ?.map((x) => {
                emailCsv =
                  emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
              }),
            listOfAdditionalEmails?.map((email) => {
              emailCsv = emailCsv + email + ":::" + 0 + ", ";
            }),
            (emailCsv = cleanCsvString(emailCsv))
          );

          let payload = {
            BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
            CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
            InwardIDEncrypted: values?.InwardIDEncrypted,
            InwardMaterialIDEncrypted: values?.InwardMaterialIDEncrypted ?? "",
            AllTCNos: values?.AllTCNos ?? "",
            CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
              ? AuthUser?.ReferenceIDEncrypt
              : "0",
            EmailIDs: emailCsv,
            ListOfLetterRefDoc: values?.sscListOfLetterRefDoc
              ?.filter((item) => item.IsSelected == true)
              ?.map((x) => ({
                InwardLetterRefImageIDEncrypted:
                  x?.InwardLetterRefImageIDEncrypted,
                AttachmentFilePath: x?.LetterRefImageFilePath,
              })),
          };

          await post(POST_ControlCenterScanCopyEmailSend, payload)
            .then((response) => {
              if (response?.IsSuccess) {
                successMessage(response?.Message);
                setShowSendScanCopyModal(false);
              } else {
                errorMessage(response?.Message);
              }
              setIsLoading(false);
            })
            .catch((error) => {
              console.log(error);
              setIsLoading(false);
            });
        }
      }
    } else {
      warningMessage("Something went wrong!");
    }
  };

  const [showSendInvoiceModal, setShowSendInvoiceModal] = useState(false);
  const [sInvContactPersonOptions, setsInvContactPersonOptions] = useState([]);

  const validationSchemaSendInvoice = Yup.object().shape({});

  const formikSendInvoice = useFormik({
    validationSchemaSendInvoice,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendInvoice(values, formikHelpers),
    initialValues: {
      InwardIDEncrypted: "",
      sInvListOfProjectContactPerson: [],
      sInvListOfLetterRefDoc: [],
      sInvListOfAdditionalContactPerson: [],
      sInvAdditionalEmailID: "",
      sInvCustomerIDEncrypted: "",
      sInvCustomerName: "",
      sInvCustomerContactPersonIDEncrypted: "",
      sInvContactPerson: "",
      sInvDesignation: "",
      sInvMobileNo: "",
      sInvEmailID: "",
      sInvContactPersonID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      sInvListOfProjectContactPerson,
      sInvListOfLetterRefDoc,
      sInvListOfAdditionalContactPerson,
      sInvCustomerIDEncrypted,
      sInvCustomerName,
      sInvCustomerContactPersonIDEncrypted,
      sInvContactPerson,
      sInvDesignation,
      sInvMobileNo,
      sInvEmailID,
      sInvContactPersonID,
    },
  } = formikSendInvoice;

  const loadOptionsCustomer_sInv = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  useEffect(() => {
    if (sInvCustomerIDEncrypted) {
      getCustomerContactPersonDDL_sInv(sInvCustomerIDEncrypted);
    } else {
      setsInvContactPersonOptions([]);
      formikSendInvoice.setFieldValue(
        "sInvCustomerContactPersonIDEncrypted",
        ""
      );
      formikSendInvoice.setFieldValue("sInvContactPerson", "");
      formikSendInvoice.setFieldValue("sInvDesignation", "");
      formikSendInvoice.setFieldValue("sInvMobileNo", "");
      formikSendInvoice.setFieldValue("sInvEmailID", "");
      formikSendInvoice.setFieldValue("sInvContactPersonID", "");
    }
  }, [sInvCustomerIDEncrypted]);

  const getCustomerContactPersonDDL_sInv = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: customerID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setsInvContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
              MobileNo: item.MobileNo,
              EmailID: item.EmailID,
              Designation: item.Designation,
              ContactPersonID: item.ContactPersonID,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        isLoading(false);
      });
  };

  const handleValidSubmitSendInvoice = (values) => {
    if (values?.InwardIDEncrypted) {
      let listOfAdditionalEmails = values?.sInvAdditionalEmailID?.trim()
        ? cleanCsvString(values?.sInvAdditionalEmailID)?.split(",")
        : [];
      if (
        values?.sInvListOfProjectContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        values?.sInvListOfAdditionalContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        listOfAdditionalEmails?.length == 0
      ) {
        warningMessage(
          "Please select contact person or enter additional email to send!"
        );
      } else {
        if (
          listOfAdditionalEmails?.length > 0 &&
          listOfAdditionalEmails?.filter((x) => validateEmail(x) == null)
            ?.length > 0
        ) {
          formikSendInvoice.setFieldError(
            "sInvAdditionalEmailID",
            "Please check it contains invalid email address"
          );
          formikSendInvoice.setFieldTouched("sInvAdditionalEmailID", true);
        } else {
          //call send Invoice api
          infoMessage("Coming Soon...");
          setShowSendInvoiceModal(false);
        }
      }
    } else {
      warningMessage("Something went wrong!");
    }
  };

  const openSendInvoiceDialog = async (inwardID) => {
    setIsLoading(true);
    await post(POST_GetControlCenterInvoiceEmailDetailList, {
      InwardIDEncrypted: inwardID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendInvoice.setValues({
            InwardIDEncrypted: inwardID,
            sInvListOfProjectContactPerson: response?.ListOfContactPerson?.map(
              (x) => ({
                ...x,
                IsSelected: false,
              })
            ),
            sInvListOfLetterRefDoc: response?.ListOfLetterRefDoc?.map((x) => ({
              ...x,
              IsSelected: false,
              LetterRefImageFileName: x?.LetterRefImageFileName,
              // LetterRefImageFileName: x?.LetterRefImageFilePath
              //   ? (x?.LetterRefImageFilePath?.split("/"))[
              //       x?.LetterRefImageFilePath?.split("/").length - 1
              //     ]
              //   : "",
            })),
            sInvListOfAdditionalContactPerson: [],
            sInvAdditionalEmailID: "",
            sInvCustomerIDEncrypted: "",
            sInvCustomerName: "",
            sInvCustomerContactPersonIDEncrypted: "",
            sInvContactPerson: "",
            sInvDesignation: "",
            sInvMobileNo: "",
            sInvEmailID: "",
            sInvContactPersonID: "",
          });
        } else {
          formikSendInvoice.resetForm();
        }
        setShowSendInvoiceModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const addAdditionalContactPerson_sInv = () => {
    if (sInvCustomerIDEncrypted && sInvCustomerContactPersonIDEncrypted) {
      if (
        sInvListOfAdditionalContactPerson?.filter(
          (x) =>
            x?.CustomerContactPersonIDEncrypted ==
            sInvCustomerContactPersonIDEncrypted
        )?.length == 0
      ) {
        formikSendInvoice.setFieldValue("sInvListOfAdditionalContactPerson", [
          ...sInvListOfAdditionalContactPerson,
          {
            IsSelected: true,
            CustomerName: sInvCustomerName,
            CustomerContactPersonIDEncrypted:
              sInvCustomerContactPersonIDEncrypted,
            ContactPerson: sInvContactPerson,
            Designation: sInvDesignation,
            MobileNo: sInvMobileNo,
            EmailID: sInvEmailID,
            ContactPersonID: sInvContactPersonID,
          },
        ]);
        formikSendInvoice.setFieldValue(
          "sInvCustomerContactPersonIDEncrypted",
          ""
        );
        formikSendInvoice.setFieldValue("sInvContactPerson", "");
        formikSendInvoice.setFieldValue("sInvDesignation", "");
        formikSendInvoice.setFieldValue("sInvMobileNo", "");
        formikSendInvoice.setFieldValue("sInvEmailID", "");
        formikSendInvoice.setFieldValue("sInvContactPersonID", "");
      } else {
        //show duplicate error
        warningMessage("Contact Person already exists!");
      }
    } else {
      if (!sInvCustomerIDEncrypted) {
        formikSendInvoice.setFieldError(
          "sInvCustomerIDEncrypted",
          "Customer is required field"
        );
        formikSendInvoice.setFieldTouched("sInvCustomerIDEncrypted", true);
      }
      if (!sInvCustomerContactPersonIDEncrypted) {
        formikSendInvoice.setFieldError(
          "sInvCustomerContactPersonIDEncrypted",
          "Contact Person is required field"
        );
        formikSendInvoice.setFieldTouched(
          "sInvCustomerContactPersonIDEncrypted",
          true
        );
      }
    }
  };

  const [showSendMachineCertificateModal, setShowSendMachineCertificateModal] =
    useState(false);
  const [smcContactPersonOptions, setSmcContactPersonOptions] = useState([]);

  const validationSchemaSendMachineCertificate = Yup.object().shape({});

  const formikSendMachineCertificate = useFormik({
    validationSchemaSendMachineCertificate,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendMachineCertificate(values, formikHelpers),
    initialValues: {
      InwardIDEncrypted: "",
      InwardMaterialIDEncrypted: "",
      smcListOfCustomerContactPerson: [],
      smcListOfMachineCertificate: [],
      smcListOfAdditionalContactPerson: [],
      smcAdditionalEmailID: "",
      smcCustomerIDEncrypted: "",
      smcCustomerName: "",
      smcCustomerContactPersonIDEncrypted: "",
      smcContactPerson: "",
      smcDesignation: "",
      smcMobileNo: "",
      smcEmailID: "",
      smcContactPersonID: "",
      smcInwardNo: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      smcListOfCustomerContactPerson,
      smcListOfMachineCertificate,
      smcListOfAdditionalContactPerson,
      smcCustomerIDEncrypted,
      smcCustomerName,
      smcCustomerContactPersonIDEncrypted,
      smcContactPerson,
      smcDesignation,
      smcMobileNo,
      smcEmailID,
      smcContactPersonID,
      smcInwardNo,
    },
  } = formikSendMachineCertificate;

  const loadOptionsCustomer_smc = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  useEffect(() => {
    if (smcCustomerIDEncrypted) {
      getCustomerContactPersonDDL_smc(smcCustomerIDEncrypted);
    } else {
      setSmcContactPersonOptions([]);
      formikSendMachineCertificate.setFieldValue(
        "smcCustomerContactPersonIDEncrypted",
        ""
      );
      formikSendMachineCertificate.setFieldValue("smcContactPerson", "");
      formikSendMachineCertificate.setFieldValue("smcDesignation", "");
      formikSendMachineCertificate.setFieldValue("smcMobileNo", "");
      formikSendMachineCertificate.setFieldValue("smcEmailID", "");
      formikSendMachineCertificate.setFieldValue("smcContactPersonID", "");
    }
  }, [smcCustomerIDEncrypted]);

  const getCustomerContactPersonDDL_smc = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: customerID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setSmcContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
              MobileNo: item.MobileNo,
              EmailID: item.EmailID,
              Designation: item.Designation,
              ContactPersonID: item.ContactPersonID,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        isLoading(false);
      });
  };

  const handleValidSubmitSendMachineCertificate = async (values) => {
    if (smcListOfMachineCertificate?.length == 0) {
      warningMessage("There is no machine certificate to send!");
    } else {
      if (
        smcListOfMachineCertificate?.filter((x) => x.IsSelected == true)
          ?.length == 0
      ) {
        warningMessage("Select machine certificate to send!");
      } else {
        if (values?.InwardIDEncrypted && values?.InwardMaterialIDEncrypted) {
          let listOfAdditionalEmails = values?.smcAdditionalEmailID?.trim()
            ? cleanCsvString(values?.smcAdditionalEmailID)?.split(",")
            : [];
          if (
            values?.smcListOfCustomerContactPerson?.filter(
              (x) => x.IsSelected == true
            )?.length == 0 &&
            values?.smcListOfAdditionalContactPerson?.filter(
              (x) => x.IsSelected == true
            )?.length == 0 &&
            listOfAdditionalEmails?.length == 0
          ) {
            warningMessage(
              "Please select contact person or enter additional email to send!"
            );
          } else {
            if (
              listOfAdditionalEmails?.length > 0 &&
              listOfAdditionalEmails?.filter((x) => validateEmail(x) == null)
                ?.length > 0
            ) {
              formikSendMachineCertificate.setFieldError(
                "smcAdditionalEmailID",
                "Please check it contains invalid email address"
              );
              formikSendMachineCertificate.setFieldTouched(
                "smcAdditionalEmailID",
                true
              );
            } else {
              //call send machine certificate api

              setIsLoading(true);

              let emailCsv = "";
              Promise.all(
                values?.smcListOfCustomerContactPerson
                  ?.filter((x) => x.IsSelected == true)
                  ?.map((x) => {
                    emailCsv =
                      emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
                  }),

                values?.smcListOfAdditionalContactPerson
                  ?.filter((x) => x.IsSelected == true)
                  ?.map((x) => {
                    emailCsv =
                      emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
                  }),

                listOfAdditionalEmails?.map((email) => {
                  emailCsv = emailCsv + email + ":::" + 0 + ", ";
                }),
                (emailCsv = cleanCsvString(emailCsv))
              );

              let payload = {
                BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
                CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
                InwardNo: values?.smcInwardNo,
                InwardIDEncrypted: values?.InwardIDEncrypted,
                InwardMaterialIDEncrypted:
                  values?.InwardMaterialIDEncrypted ?? "",
                CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
                  ? AuthUser?.ReferenceIDEncrypt
                  : "0",
                EmailIDs: emailCsv,
                ListOfMachineCertificate: values?.smcListOfMachineCertificate
                  ?.filter((item) => item.IsSelected == true)
                  ?.map((x) => ({
                    MachineIDEncrypted: x?.MachineIDEncrypted,
                    MachineCalibrationDocumentsIDEncrypted:
                      x?.MachineCalibrationDocumentsIDEncrypted,
                    AttachmentFilePath: x?.MachineCertificateFilePath,
                    TCNo: x?.TCNo,
                    MachineName: x?.MachineName,
                  })),
              };

              //console.log("payload", payload);
              //return;

              await post(POST_ControlCenterMachineCertificateEmailSend, payload)
                .then((response) => {
                  if (response?.IsSuccess) {
                    successMessage(response?.Message);
                    setShowSendMachineCertificateModal(false);
                  } else {
                    errorMessage(response?.Message);
                  }
                  setIsLoading(false);
                })
                .catch((error) => {
                  console.log(error);
                  setIsLoading(false);
                });

              // infoMessage("Coming Soon...");
              // setShowSendMachineCertificateModal(false);
            }
          }
        } else {
          warningMessage("Something went wrong!");
        }
      }
    }
  };

  const openSendMachineCertificateDialog = async (
    inwardID,
    inwardMaterialID,
    InwardNo
  ) => {
    setIsLoading(true);

    await post(
      POST_GetControlCenterInwardMaterialMachineCertificateEmailDetail,
      {
        InwardIDEncrypted: inwardID,
        InwardMaterialIDEncrypted: inwardMaterialID,
      }
    )
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendMachineCertificate.setValues({
            InwardIDEncrypted: inwardID,
            InwardMaterialIDEncrypted: inwardMaterialID,
            smcInwardNo: InwardNo,
            smcListOfCustomerContactPerson: response?.ListOfContactPersons?.map(
              (x) => ({
                ...x,
                IsSelected: false,
              })
            ),
            // smcListOfMachineCertificate: response?.ListOfLetterRefDoc?.map(
            smcListOfMachineCertificate: response?.ListOfMachine?.map((x) => ({
              ...x,
              IsSelected: true,
              MachineCertificateFilePath: x?.MachineCertificateFilePath,
              MachineCertificateFileName: x?.MachineCalibrationDocumentFileName,
              // MachineCertificateFileName: x?.MachineCertificateFilePath
              //   ? (x?.MachineCertificateFilePath?.split("/"))[
              //       x?.MachineCertificateFilePath?.split("/").length - 1
              //     ]
              //   : "",
            })),
            smcListOfAdditionalContactPerson: [],
            smcAdditionalEmailID: "",
            smcCustomerIDEncrypted: "",
            smcCustomerName: "",
            smcCustomerContactPersonIDEncrypted: "",
            smcContactPerson: "",
            smcDesignation: "",
            smcMobileNo: "",
            smcEmailID: "",
            smcContactPersonID: "",
          });
        } else {
          formikSendMachineCertificate.resetForm();
        }
        setShowSendMachineCertificateModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const addAdditionalContactPerson_smc = () => {
    if (smcCustomerIDEncrypted && smcCustomerContactPersonIDEncrypted) {
      if (
        smcListOfAdditionalContactPerson?.filter(
          (x) =>
            x?.CustomerContactPersonIDEncrypted ==
            smcCustomerContactPersonIDEncrypted
        )?.length == 0
      ) {
        formikSendMachineCertificate.setFieldValue(
          "smcListOfAdditionalContactPerson",
          [
            ...smcListOfAdditionalContactPerson,
            {
              IsSelected: true,
              CustomerName: smcCustomerName,
              CustomerContactPersonIDEncrypted:
                smcCustomerContactPersonIDEncrypted,
              ContactPerson: smcContactPerson,
              Designation: smcDesignation,
              MobileNo: smcMobileNo,
              EmailID: smcEmailID,
              ContactPersonID: smcContactPersonID,
            },
          ]
        );
        formikSendMachineCertificate.setFieldValue(
          "smcCustomerContactPersonIDEncrypted",
          ""
        );
        formikSendMachineCertificate.setFieldValue("smcContactPerson", "");
        formikSendMachineCertificate.setFieldValue("smcDesignation", "");
        formikSendMachineCertificate.setFieldValue("smcMobileNo", "");
        formikSendMachineCertificate.setFieldValue("smcEmailID", "");
        formikSendMachineCertificate.setFieldValue("smcContactPersonID", "");
      } else {
        //show duplicate error
        warningMessage("Contact Person already exists!");
      }
    } else {
      if (!smcCustomerIDEncrypted) {
        formikSendMachineCertificate.setFieldError(
          "smcCustomerIDEncrypted",
          "Customer is required field"
        );
        formikSendMachineCertificate.setFieldTouched(
          "smcCustomerIDEncrypted",
          true
        );
      }
      if (!smcCustomerContactPersonIDEncrypted) {
        formikSendMachineCertificate.setFieldError(
          "smcCustomerContactPersonIDEncrypted",
          "Contact Person is required field"
        );
        formikSendMachineCertificate.setFieldTouched(
          "smcCustomerContactPersonIDEncrypted",
          true
        );
      }
    }
  };

  const [showActionRedirectModal, setShowActionRedirectModal] = useState(false);

  const validationSchemaActionRedirect = Yup.object().shape({});

  const formikActionRedirect = useFormik({
    validationSchemaActionRedirect,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitActionRedirect(values, formikHelpers),
    initialValues: {
      RedirectToForm: "",
      ListOfRedirectTC: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      handleValidSubmitActionRedirect,
      RedirectToForm,
      ListOfRedirectTC,
    },
  } = formikActionRedirect;

  const openActionRedirectDialog = (redirectToForm, index) => {
    formikActionRedirect.setValues({
      RedirectToForm: redirectToForm,
      ListOfRedirectTC: controlCenterList[index]?.ListOfInwardMaterials,
    });
    setShowActionRedirectModal(true);
  };

  const SampleRequestFormDownload = async (inwardID) => {
    setIsLoading(true);
    await post(POST_GetSampleRequestFormDownload, {
      InwardIDEncrypted: inwardID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath, "_blank");
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const LabFormDownload = async (inwardID) => {
    setIsLoading(true);
    await post(POST_GetLabFormDownload, {
      InwardIDEncrypted: inwardID,
      PrintedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath, "_blank");
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showTPIVisitModal, setShowTPIVisitModal] = useState(false);
  const [tpiCustomerOptions, setTPICustomerOptions] = useState([]);
  const [tpiContactPersonOptions, setTPIContactPersonOptions] = useState([]);

  const getTPICustomerDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TPIFlag: 1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPICustomerOptions(
            response?.CustomerDDLList?.filter((x) => x.IsTPI == true)?.map(
              (item) => ({
                label: item.CustomerName,
                value: item.CustomerIDEncrypted,
              })
            )
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTPIContactPersonDDL = async (tpiID, customerProjectID) => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: tpiID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTPIContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
              Designation: item.Designation,
              MobileNo: item.MobileNo,
              EmailID: item.EmailID,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchemaTPIVisit = Yup.object().shape({});

  const formikTPIVisit = useFormik({
    validationSchemaTPIVisit,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTPIVisit(values, formikHelpers),
    initialValues: {
      tpiVisit: {},
      InwardIDEncrypted: "",
      TPIIDEncrypted: "",
      TPIName: "",
      TPIContactPersonIDEncrypted: "",
      TPIContactPersonName: "",
      TPIExpectedDate: "",
      TPIMobileNo: "",
      TPIEmailID: "",
      TPIDesignation: "",
      ListOfTPIDetails: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      tpiVisit,
      ListOfTPIDetails,
      TPIIDEncrypted,
      TPIName,
      TPIContactPersonIDEncrypted,
      TPIContactPersonName,
      TPIExpectedDate,
      TPIMobileNo,
      TPIEmailID,
      TPIDesignation,
    },
  } = formikTPIVisit;

  const getTPIVisitDetails = async (inwardID) => {
    setIsLoading(true);
    await post(POST_GetMaterialInwardDetailByID, {
      InwardIDEncrypted: inwardID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikTPIVisit.setValues({
            tpiVisit: response,
            InwardIDEncrypted: inwardID,
            ListOfTPIDetails: response?.ListOfTPIDetails?.map((x) => {
              return {
                ...x,
                TPIExpectedDate: x?.TPIExpectedDate
                  ? new Date(x?.TPIExpectedDate)
                  : "",
                displayTPIExpectedDate: x?.TPIExpectedDate,
                IsDeleted: false,
              };
            }),
          });
          setShowTPIVisitModal(true);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleValidSubmitTPIVisit = async (values) => {
    setIsLoading(true);
    let payload = {
      InwardIDEncrypted: values?.InwardIDEncrypted,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      SendEmailPermissions: AuthUser?.Permissions?.Email,
      ListOfTPIDetails_uddt: values?.ListOfTPIDetails?.map((x) => ({
        InwardTPIDetailIDEncrypted: x?.InwardTPIDetailIDEncrypted,
        TPIIDEncrypted: x?.TPIIDEncrypted,
        TPIContactPersonIDEncrypted: x?.TPIContactPersonIDEncrypted,
        TPIExpectedDate: x.TPIExpectedDate
          ? moment(x.TPIExpectedDate).format("YYYY-MM-DD").replace(/^\-/, "")
          : "",
        IsDeleted: x?.IsDeleted,
      })),
    };
    await post(POST_ControlCenterInwardTPIDetailsSave, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setShowTPIVisitModal(false);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const addNewTPI = () => {
    if (!TPIIDEncrypted || !TPIContactPersonIDEncrypted) {
      if (!TPIIDEncrypted) {
        formikTPIVisit.setFieldError("TPIIDEncrypted", "TPI is required field");
        formikTPIVisit.setFieldTouched("TPIIDEncrypted", true);
      }
      if (!TPIContactPersonIDEncrypted) {
        formikTPIVisit.setFieldError(
          "TPIContactPersonIDEncrypted",
          "TPI Contact Person is required field"
        );
        formikTPIVisit.setFieldTouched("TPIContactPersonIDEncrypted", true);
      }
    } else {
      if (
        ListOfTPIDetails?.filter(
          (x) =>
            x?.TPIIDEncrypted == TPIIDEncrypted &&
            x?.TPIContactPersonIDEncrypted == TPIContactPersonIDEncrypted &&
            x?.IsDeleted == false
        )?.length > 0
      ) {
        warningMessage("TPI detail already exists!");
      } else {
        formikTPIVisit.setFieldValue("ListOfTPIDetails", [
          ...ListOfTPIDetails,
          {
            InwardTPIDetailIDEncrypted: "",
            TPIIDEncrypted: TPIIDEncrypted,
            TPIContactPersonIDEncrypted: TPIContactPersonIDEncrypted,
            TPIName: TPIName,
            TPIContactPersonName: TPIContactPersonName,
            MobileNo: TPIMobileNo,
            EmailID: TPIEmailID,
            Designation: TPIDesignation,
            TPIExpectedDate: TPIExpectedDate ? new Date(TPIExpectedDate) : "",
            displayTPIExpectedDate: TPIExpectedDate
              ? moment(TPIExpectedDate).format("DD-MMM-yyyy")
              : "",
            IsDeleted: false,
          },
        ]);
        //setTPIContactPersonOptions([]);
        //formikTPIVisit.setFieldValue("TPIIDEncrypted", "");
        //formikTPIVisit.setFieldValue("TPIName", "");
        formikTPIVisit.setFieldValue("TPIContactPersonIDEncrypted", "");
        formikTPIVisit.setFieldValue("TPIContactPersonName", "");
        formikTPIVisit.setFieldValue("TPIDesignation", "");
        formikTPIVisit.setFieldValue("TPIMobileNo", "");
        formikTPIVisit.setFieldValue("TPIEmailID", "");
        formikTPIVisit.setFieldValue("TPIExpectedDate", "");
      }
    }
  };

  const deleteTPI = (i) => {
    if (ListOfTPIDetails[i]?.InwardTPIDetailIDEncrypted) {
      formikTPIVisit.setFieldValue(`ListOfTPIDetails[${i}].IsDeleted`, true);
    } else {
      formikTPIVisit.setFieldValue(
        "ListOfTPIDetails",
        ListOfTPIDetails?.filter((x, ix) => ix != i)
      );
    }
  };

  const [
    showReTestTransactionDetailsModel,
    setShowReTestTransactionDetailsModel,
  ] = useState(false);

  const [showReTestHistModal, setShowReTestHistModal] = useState(false);

  const getReTestTransactionDetails = async (inwardmaterialID) => {
    setIsLoading(true);

    await post(POST_GetMaterialInwardReTestDetailByID, {
      InwardMaterialIDEncrypted: inwardmaterialID,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikReTestTransactionDetails.setFieldValue(
            "InwardMaterialIDEncrypted",
            inwardmaterialID
          );
          formikReTestTransactionDetails.setFieldValue(
            "RetestInwardNo",
            response?.InwardNo
          );

          formikReTestTransactionDetails.setFieldValue(
            "ListOfReTestDetails",
            response?.ListOfTest
          );
          formikReTestTransactionDetails.setFieldValue(
            "ListOfReTestHistoryDetails",
            response?.ListOfReTestHistory
          );

          formikReTestTransactionDetails.setFieldValue(
            "RetestTCNo",
            response?.TCNo
          );
          formikReTestTransactionDetails.setFieldValue(
            "RetestSampleDetail",
            response?.SampleDetail
          );
          formikReTestTransactionDetails.setFieldValue(
            "RetestTCDate",
            response?.TCDate
          );
          formikReTestTransactionDetails.setFieldValue(
            "RetestSize",
            response?.Size
          );
          formikReTestTransactionDetails.setFieldValue(
            "RetestCondition",
            response?.Condition
          );
          // formikReTestTransactionDetails.setFieldValue(
          //   "RetestProductGroupName",
          //   response?.ProductGroupName
          // );
          // formikReTestTransactionDetails.setFieldValue(
          //   "RetestMaterialType",
          //   response?.MaterialTypeName
          // );

          setShowReTestTransactionDetailsModel(true);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    setIsLoading(false);
  };

  const validationSchemaReTestTransactionDetails = Yup.object().shape({});

  const formikReTestTransactionDetails = useFormik({
    validationSchemaReTestTransactionDetails,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitReTestTransactionDetails(values, formikHelpers),
    initialValues: {
      InwardMaterialIDEncrypted: "",
      ListOfReTestDetails: [],
      ListOfReTestHistoryDetails: [],
      RetestTCNo: "",
      RetestSampleDetail: "",
      RetestTCDate: "",
      RetestSize: "",
      RetestCondition: "",
      // RetestProductGroupName: "",
      // RetestMaterialType: "",
      RetestInwardNo: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      ListOfReTestDetails,
      ListOfReTestHistoryDetails,
      RetestTCNo,
      RetestSampleDetail,
      RetestTCDate,
      RetestSize,
      RetestCondition,
      // RetestProductGroupName,
      // RetestMaterialType,
      RetestInwardNo,
    },
  } = formikReTestTransactionDetails;

  const handleValidSubmitReTestTransactionDetails = async (values) => {
    if (
      values?.ListOfReTestDetails?.filter((x) => x.IsSelected == true)
        ?.length == 0
    ) {
      formikReTestTransactionDetails.setFieldError(
        "ListOfReTestDetails",
        "Test detail is required"
      );
      formikReTestTransactionDetails.setFieldTouched(
        "ListOfReTestDetails",
        true
      );
      return;
    }

    setIsLoading(true);

    let payload = {
      InwardMaterialIDEncrypt: values?.InwardMaterialIDEncrypted,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ListOfTest: values?.ListOfReTestDetails?.map((x) => ({
        InwardMaterialRetestDetailIDEncrypt:
          x?.InwardMaterialRetestDetailIDEncrypt,
        InwardMaterialTestDetailIDEncrypt: x?.InwardMaterialTestDetailIDEncrypt,
        RetestRemarks: x?.RetestRemarks,
        Chargeable: x?.Chargeable,
        IsSelected: x?.IsSelected,
      })),
    };
    await post(POST_MaterialInwardReTestInsert, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          getData();
          setShowReTestTransactionDetailsModel(false);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showAmendmentModal, setShowAmendmentModal] = useState(false);
  // const [unitOptions, setUnitOptions] = useState([]);
  const [showAmendmentHistModal, setShowAmendmentHistModal] = useState(false);

  // const amendmentNoOptions = [{ label: "Amd0001", value: 1 }];

  // const getUnitDDL = async () => {
  //   setIsLoading(true);
  //   post(POST_GetCategoryDropDownListByCategoryType, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //     CategoryType: 8, //Unit
  //     ParentCategoryID: 0,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setUnitOptions(
  //           response?.List?.map((item) => ({
  //             label: item.CategoryName,
  //             value: item.CategoryID,
  //           }))
  //         );
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const validationSchemaAmendment = Yup.object().shape({
    AmendmentRemarks: Yup.string()
      .trim()
      .required("Amendment Remarks is required field"),
    ListOfAmendmentMaterialTestDetails: Yup.array().required(
      "Amendment Test details is required"
    ),
  });

  const formikAmendment = useFormik({
    validationSchemaAmendment,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitAmendment(values, formikHelpers),
    initialValues: {
      amdInwardIDEncrypted: "",
      amdInwardMaterialIDEncrypted: "",
      amdInwardNo: "",
      amdInwardDate: "",
      amdTCNo: "",
      amdLetterRefNo: "",
      amdCustomerIDEncrypted: "",
      amdCustomerName: "",
      amdCustomerProjectIDEncrypted: "",
      amdCustomerProjectName: "",
      // amdDepartmentIDEncrypted: "",
      // amdDepartmenName: "",
      // amdProductGroupIDEncryted: "",
      // amdProductGroupName: "",
      // amdMaterialTypeIDEncrypted: "",
      // amdMaterialTypeName: "",
      amdSize: "",
      amdCondition: "",
      amdSampleDetail: "",
      amdProjectDetails: "",
      // amendmentDepartmentOptions: [],
      ListOfMaterialTestDetails: [],
      ListOfAmendmentMaterialTestDetails: [],
      AmendmentRemarks: "",
      ListOfAmendmentTestHistory: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      amdInwardNo,
      amdInwardDate,
      amdTCNo,
      amdLetterRefNo,
      amdCustomerName,
      amdCustomerProjectName,
      // amdDepartmenName,
      // amdProductGroupName,
      // amdProductGroupIDEncryted,
      // amdMaterialTypeName,
      // amdMaterialTypeIDEncrypted,
      amdSize,
      amdCondition,
      amdSampleDetail,
      amdProjectDetails,
      // amendmentDepartmentOptions,
      ListOfMaterialTestDetails,
      ListOfAmendmentMaterialTestDetails,
      ListOfAmendmentTestHistory,
    },
  } = formikAmendment;

  const handleValidSubmitAmendment = (values) => {
    let isValid = true;
    if (values?.AmendmentRemarks?.trim() == "") {
      formikAmendment.setFieldError(
        "AmendmentRemarks",
        "Amendment Remarks is required field"
      );
      formikAmendment.setFieldTouched("AmendmentRemarks", true);
      isValid = false;
    }
    if (
      values?.ListOfAmendmentMaterialTestDetails?.filter(
        (x) => x.IsDeleted == false
      )?.length == 0
    ) {
      formikAmendment.setFieldError(
        "ListOfAmendmentMaterialTestDetails",
        "Amendment Test detail is required"
      );
      formikAmendment.setFieldTouched(
        "ListOfAmendmentMaterialTestDetails",
        true
      );
      isValid = false;
    } else {
      Promise.all(
        values?.ListOfAmendmentMaterialTestDetails?.filter(
          (x) => x.IsDeleted == false
        )?.map((test) => {
          if (
            !test?.DepartmentIDEncrypted ||
            !test?.TestMasterIDEncrypted ||
            // !test?.TestMethodIDEncrypted ||
            //!test?.ReferenceStandardIDEncrypted ||
            !test?.TestCount ||
            !test?.BillingQty
            // ||
            // !test?.UnitID ||
            // !test?.Rate ||
            // !test?.TestNote?.trim()
          ) {
            isValid = false;
            formikAmendment.setFieldError(
              "ListOfAmendmentMaterialTestDetails",
              "Please fill all the above details of Test..."
            );
            formikAmendment.setFieldTouched(
              "ListOfAmendmentMaterialTestDetails",
              true
            );
          }
        })
      );
      if (isValid == true) {
        Promise.all(
          values?.ListOfAmendmentMaterialTestDetails?.filter(
            (x) => x.IsDeleted == false
          )?.map((test) => {
            if (parseInt(test?.TestCount) < parseInt(test?.BillingQty)) {
              isValid = false;
              formikAmendment.setFieldError(
                "ListOfAmendmentMaterialTestDetails",
                "Billing Qty must be less then or equal to Test Count..."
              );
              formikAmendment.setFieldTouched(
                "ListOfAmendmentMaterialTestDetails",
                true
              );
            }
          })
        );
      }
    }
    if (isValid == false) {
      return;
    } else {
      setIsLoading(true);

      let amendTestList = [],
        amendTestParametersList = [],
        amendTestDefineMoreRateList = [];

      Promise.all(
        values?.ListOfAmendmentMaterialTestDetails?.filter(
          (x) => x.IsDeleted == false
        )?.map((test, iTest) => {
          amendTestList.push({
            ...test,
            id_t: iTest + 1,
            ...test.TestMixDesignDetail,
          });

          test?.ListOfTestParameters?.filter((x) => x.IsSelected == true)?.map(
            (para, paraIndex) => {
              amendTestParametersList.push({ ...para, id_t: iTest + 1 });
            }
          );

          test?.ListOfDefineMoreRates?.filter((x) => x.IsSelected == true)?.map(
            (rate, rateIndex) => {
              amendTestDefineMoreRateList.push({ ...rate, id_t: iTest + 1 });
            }
          );
        })
      );

      let payload = {
        InwardIDEncrypted: values?.amdInwardIDEncrypted,
        InwardMaterialIDEncrypted: values?.amdInwardMaterialIDEncrypted,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
          ? AuthUser?.ReferenceIDEncrypt
          : "0",
        AmendmentRemarks: values?.AmendmentRemarks,
        // AmendmentTestList: values?.ListOfAmendmentMaterialTestDetails?.filter(
        //   (x) => x.IsDeleted == false
        // ),
        AmendmentTestList: amendTestList,
        ListOfTestParameters: amendTestParametersList,
        ExistingTestList: values?.ListOfMaterialTestDetails,
        ListOfDefineMoreRates: amendTestDefineMoreRateList,
      };

      post(POST_Amendment_Save, payload)
        .then((response) => {
          if (response?.IsSuccess) {
            successMessage(response?.Message);
            setIsLoading(false);
            setShowAmendmentModal(false);
            getData(currentPage, currentSizePerPage);
          } else {
            errorMessage(response?.Message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const initAmendmentMaterialTestDetail = {
    id: 0,
    InwardMaterialTestDetailIDEncrypted: "",
    DepartmentIDEncrypted: "",
    ProductGroupIDEncrypted: "",
    MaterialTypeIDEncrypted: "",
    TestMasterIDEncrypted: "",
    TestMethodIDEncrypted: "",
    ReferenceStandardIDEncrypted: "",
    RefStandardSubGroup: "",
    TestCount: "",
    BillingQty: "",
    UnitID: "0",
    Rate: "0.00",
    TestNote: "",
    productGroupOptions: [],
    materialTypeOptions: [],
    testOptions: [],
    testMethodOptions: [],
    referenceStandardOptions: [],
    refStandardSubGroupOptions: [],
    IsDeleted: false,
    IsCancel: false,
    ListOfTestParameters: [],
    ListOfDefineMoreRates: [],
    IsMixDesign: false,
    TestMixDesignDetail: {
      StipulationsProportioningIDEncrypted: "",
      // InwardIDEncrypted: "",
      // InwardMaterialIDEncrypted: "",
      // InwardMaterialTestDetailIDEncrypted: "",
      // TestMasterIDEncrypted: "",
      TypeofCementIDEncrypted: "",
      TypeofMineralAdmixtureIDEncrypted: "",
      MaximumNominalSizeofAggregateIDEncrypted: "",
      EnvironmentalExposureConditionsIDEncrypted: "",
      TypeofAggregateFineIDEncrypted: "",
      ChemicalAdmixtureTypeIDEncrypted: "",
      ChemicalAdmixtureBrandBatchandMarkIDEncrypted: "",
      GradeDesignation: "",
      MinimumCementContent: "",
      MaximumCementContent: "",
      MaximumWaterCementRatio: "",
      Workability: "",
      RetentionTime: "",
      TransportationTime: "",
      DegreeofSiteControl: "",
      TypeofAggregateFineCoarse: "",
      MethodofConcretePlacingIsChute_NonPumpable: false,
      MethodofConcretePlacingIsPumping: false,
    },
    IsMixDesignIncludedTest: false,
    MixDesignTestMasterIDEncrypted: "",
  };

  const InwardMaterialAmendment = (inwardMaterialID) => {
    formikAmendment.resetForm();
    // getUnitDDL();
    getInwardMaterialDetailsForAmendment(inwardMaterialID);
  };

  const getInwardMaterialDetailsForAmendment = async (inwardMaterialID) => {
    setIsLoading(true);
    await post(POST_Amendment_GetInwardMaterialDetails, {
      InwardMaterialIDEncrypted: inwardMaterialID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          // getTestDDLByDepartmentProductGroupMaterialType(
          //   response?.DepartmentIDEncrypted,
          //   response?.ProductGroupIDEncrypted,
          //   response?.MaterialTypeIDEncrypted
          // );
          // getDepartmentDDLByProductGroupAmendment(
          //   response?.ProductGroupIDEncrypted
          // );
          formikAmendment.setFieldValue(
            "amdInwardIDEncrypted",
            response?.InwardIDEncrypted
          );
          formikAmendment.setFieldValue(
            "amdInwardMaterialIDEncrypted",
            response?.InwardMaterialIDEncrypted
          );
          formikAmendment.setFieldValue("amdInwardNo", response?.InwardNo);
          formikAmendment.setFieldValue("amdInwardDate", response?.InwardDate);
          formikAmendment.setFieldValue("amdTCNo", response?.TCNo);
          formikAmendment.setFieldValue(
            "amdLetterRefNo",
            response?.LetterRefNo
          );
          formikAmendment.setFieldValue(
            "amdCustomerIDEncrypted",
            response?.CustomerIDEncrypted
          );
          formikAmendment.setFieldValue(
            "amdCustomerName",
            response?.CustomerName
          );
          formikAmendment.setFieldValue(
            "amdCustomerProjectIDEncrypted",
            response?.CustomerProjectIDEncrypted
          );
          formikAmendment.setFieldValue(
            "amdCustomerProjectName",
            response?.CustomerProjectName
          );
          // formikAmendment.setFieldValue(
          //   "amdDepartmentIDEncrypted",
          //   response?.DepartmentIDEncrypted
          // );
          // formikAmendment.setFieldValue(
          //   "amdDepartmenName",
          //   response?.DepartmentName
          // );
          // formikAmendment.setFieldValue(
          //   "amdProductGroupIDEncryted",
          //   response?.ProductGroupIDEncrypted
          // );
          // formikAmendment.setFieldValue(
          //   "amdProductGroupName",
          //   response?.ProductGroupName
          // );
          // formikAmendment.setFieldValue(
          //   "amdMaterialTypeIDEncrypted",
          //   response?.MaterialTypeIDEncrypted
          // );
          // formikAmendment.setFieldValue(
          //   "amdMaterialTypeName",
          //   response?.MaterialTypeName
          // );
          formikAmendment.setFieldValue("amdSize", response?.Size);
          formikAmendment.setFieldValue("amdCondition", response?.Condition);
          formikAmendment.setFieldValue(
            "amdSampleDetail",
            response?.SampleDetail
          );
          formikAmendment.setFieldValue(
            "amdProjectDetails",
            response?.ProjectDetails
          );
          formikAmendment.setFieldValue(
            "ListOfMaterialTestDetails",
            response?.ListOfTests
          );

          formikAmendment.setFieldValue(
            "ListOfAmendmentTestHistory",
            response?.ListOfAmendmentTestHistory
          );

          setShowAmendmentModal(true);
          setIsLoading(false);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTestDDLByDepartment = async (departmentID, index) => {
    if (departmentID) {
      setIsLoading(true);
      await post(POST_GetDDLTestMasterByDepartmentProductGroupMaterialType, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        DepartmentIDEncrypted: departmentID,
        ProductGroupIDEncrypted: "",
        MaterialTypeIDEncrypted: "",
        TestType: 1, // 0 - All, 1 - DT, 2 - NDT
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formikAmendment.setFieldValue(
              `ListOfAmendmentMaterialTestDetails[${index}].testOptions`,
              response?.List?.map((item) => ({
                label: item.TestName,
                value: item.TestMasterIDEncrypted,
                IsMixDesign: item.IsMixDesign,
              }))
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const getTestMethodDDL_RefStandardDDL_TestDetailsByTest = async (
    testID,
    tIndex,
    setDefault = true
  ) => {
    if (testID) {
      // let IsTestAlreadyExist = false;

      // Promise.all(
      //   ListOfAmendmentMaterialTestDetails?.map((item, idxt) => {
      //     if (
      //       item?.IsDeleted == false &&
      //       idxt != tIndex &&
      //       item?.TestMasterIDEncrypted === testID
      //     ) {
      //       IsTestAlreadyExist = true;
      //     }
      //   })
      // );
      // Promise.all(
      //   ListOfMaterialTestDetails?.filter((x) => x?.IsCancel == false)?.map(
      //     (item, idxt) => {
      //       if (item?.TestMasterIDEncrypted === testID && idxt != tIndex) {
      //         IsTestAlreadyExist = true;
      //       }
      //     }
      //   )
      // );

      // if (IsTestAlreadyExist) {
      //   formikAmendment.setFieldValue(
      //     `ListOfAmendmentMaterialTestDetails[${tIndex}].TestMasterIDEncrypted`,
      //     ""
      //   );
      //   warningMessage("Selected Test already Exist...!");
      //   return;
      // } else {
      setIsLoading(true);
      await post(
        POST_GetTestMethodDDL_ReferenceStandardDDL_TestMasterDetails_ByTestMasterID,
        {
          TestMasterIDEncrypted: testID,
          TranDate: amdInwardDate
            ? moment(amdInwardDate).format("YYYY-MM-DD").replace(/^\-/, "")
            : "",
        }
      )
        .then((response) => {
          if (response?.IsSuccess) {
            formikAmendment.setFieldValue(
              `ListOfAmendmentMaterialTestDetails[${tIndex}].testMethodOptions`,
              response?.TestMethodList?.map((item) => ({
                label: item.TestMethod,
                value: item.TestMethodIDEncrypted,
                IsExpiredTestMethod: item?.IsExpiredTestMethod,
              }))
            );
            formikAmendment.setFieldValue(
              `ListOfAmendmentMaterialTestDetails[${tIndex}].referenceStandardOptions`,
              response?.ReferenceStandardList?.map((item) => ({
                label: item.ReferenceStandard,
                value: item.ReferenceStandardIDEncrypted,
                IsExpiredReferenceStandard: item?.IsExpiredReferenceStandard,
              }))
            );
            formikAmendment.setFieldValue(
              `ListOfAmendmentMaterialTestDetails[${tIndex}].productGroupOptions`,
              [
                {
                  label: response?.ProductGroupName,
                  value: response?.ProductGroupIDEncrypted,
                },
              ]
            );
            formikAmendment.setFieldValue(
              `ListOfAmendmentMaterialTestDetails[${tIndex}].materialTypeOptions`,
              response?.MaterialTypeList?.map((item) => ({
                label: item.MaterialTypeName,
                value: item.MaterialTypeIDEncrypted,
              }))
            );

            if (setDefault) {
              if (
                response?.TestMethodList?.length == 1 &&
                response?.TestMethodList[0]?.IsExpiredTestMethod == false
              ) {
                formikAmendment.setFieldValue(
                  `ListOfAmendmentMaterialTestDetails[${tIndex}].TestMethodIDEncrypted`,
                  response?.TestMethodList[0].TestMethodIDEncrypted
                );
              }
              if (
                response?.ReferenceStandardList?.length == 1 &&
                response?.ReferenceStandardList[0]
                  ?.IsExpiredReferenceStandard == false
              ) {
                formikAmendment.setFieldValue(
                  `ListOfAmendmentMaterialTestDetails[${tIndex}].ReferenceStandardIDEncrypted`,
                  response?.ReferenceStandardList[0]
                    .ReferenceStandardIDEncrypted
                );
                getReferenceStandardTestSubGroupDDL(
                  response?.ReferenceStandardList[0]
                    ?.ReferenceStandardIDEncrypted,
                  testID,
                  tIndex
                );
              }
              formikAmendment.setFieldValue(
                `ListOfAmendmentMaterialTestDetails[${tIndex}].TestCount`,
                response?.DefaultTestCount
              );
              formikAmendment.setFieldValue(
                `ListOfAmendmentMaterialTestDetails[${tIndex}].ProductGroupIDEncrypted`,
                response?.ProductGroupIDEncrypted
              );
              if (response?.MaterialTypeList?.length == 1) {
                formikAmendment.setFieldValue(
                  `ListOfAmendmentMaterialTestDetails[${tIndex}].MaterialTypeIDEncrypted`,
                  response?.MaterialTypeList[0]?.MaterialTypeIDEncrypted
                );
              }
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
      // }
    } else {
      formikAmendment.setFieldValue(
        `ListOfAmendmentMaterialTestDetails[${tIndex}].testMethodOptions`,
        []
      );
      formikAmendment.setFieldValue(
        `ListOfAmendmentMaterialTestDetails[${tIndex}].referenceStandardOptions`,
        []
      );
      formikAmendment.setFieldValue(
        `ListOfAmendmentMaterialTestDetails[${tIndex}].refStandardSubGroupOptions`,
        []
      );
      formikAmendment.setFieldValue(
        `ListOfAmendmentMaterialTestDetails[${tIndex}].productGroupOptions`,
        []
      );
      formikAmendment.setFieldValue(
        `ListOfAmendmentMaterialTestDetails[${tIndex}].materialTypeOptions`,
        []
      );
    }
  };

  const AddNewAmendmentMaterialTestInformation = () => {
    formikAmendment.setFieldValue(`ListOfAmendmentMaterialTestDetails`, [
      ...ListOfAmendmentMaterialTestDetails,
      initAmendmentMaterialTestDetail,
    ]);

    // /*select the value when there is only one option while insert only*/
    // if (unitOptions?.length == 1) {
    //   let newIndex = ListOfAmendmentMaterialTestDetails?.length;
    //   formikAmendment.setFieldValue(
    //     `ListOfAmendmentMaterialTestDetails[${newIndex}].UnitID`,
    //     unitOptions[0].value
    //   );
    // }
  };

  const deleteAmendmentMaterialTestInformation = (tIndex) => {
    if (
      ListOfAmendmentMaterialTestDetails[tIndex]?.IsMixDesign == true &&
      ListOfAmendmentMaterialTestDetails[tIndex]?.TestMasterIDEncrypted
    ) {
      deleteMixDesignIncludedTest(
        ListOfAmendmentMaterialTestDetails[tIndex].TestMasterIDEncrypted,
        true
      );
    } else {
      if (
        ListOfAmendmentMaterialTestDetails[tIndex]
          ?.InwardMaterialTestDetailIDEncrypted
      ) {
        formikAmendment.setFieldValue(
          `ListOfAmendmentMaterialTestDetails[${tIndex}].IsDeleted`,
          true
        );
      } else {
        formikAmendment.setFieldValue(
          "ListOfAmendmentMaterialTestDetails",
          ListOfAmendmentMaterialTestDetails?.filter((x, idx) => idx != tIndex)
        );
      }
    }
  };

  const handleChangeAmendmentReferenceStandard = (
    testMasterID,
    indxTest,
    e
  ) => {
    if (e?.IsExpiredReferenceStandard == true) {
      warningMessage("Reference Standard is Expired..!");
    } else {
      formikAmendment.setFieldValue(
        `ListOfAmendmentMaterialTestDetails[${indxTest}].ReferenceStandardIDEncrypted`,
        e?.value ?? ""
      );
      formikAmendment.setFieldValue(
        `ListOfAmendmentMaterialTestDetails[${indxTest}].refStandardSubGroupOptions`,
        []
      );
      formikAmendment.setFieldValue(
        `ListOfAmendmentMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
        ""
      );
      getReferenceStandardTestSubGroupDDL(
        e?.value ?? "",
        testMasterID,
        indxTest
      );
    }
  };

  const getReferenceStandardTestSubGroupDDL = async (
    referenceStandardID,
    testMasterID,
    indxTest
  ) => {
    setIsLoading(true);
    await post(POST_GetReferenceStandardTestSubGroupDDL, {
      ReferenceStandardIDEncrypted: referenceStandardID,
      TestMasterIDEncrypted: testMasterID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikAmendment.setFieldValue(
            `ListOfAmendmentMaterialTestDetails[${indxTest}].refStandardSubGroupOptions`,
            response?.SubGroupList?.map((item) => ({
              label: item?.SubGroup,
              value: item?.SubGroup,
            }))
          );
          /*select the value when there is only one option*/
          if (response?.SubGroupList?.length == 1) {
            formikAmendment.setFieldValue(
              `ListOfAmendmentMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
              response?.SubGroupList[0].SubGroup
            );
            getParameterPreferenceBasedOnRefStandardTestMap(
              response?.SubGroupList[0].SubGroup,
              referenceStandardID,
              testMasterID,
              indxTest
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getParameterPreferenceBasedOnRefStandardTestMap = async (
    refStandardSubGroup,
    referenceStandardID,
    testMasterID,
    indxTest
  ) => {
    if (
      AuthUser?.Permissions?.ParameterPreferenceLoadBasedOnRefStandardTestMap ==
      true
    ) {
      setIsLoading(true);
      await post(
        POST_GetParametersPreferenceListBasedOnRefStandardTestSubGroup,
        {
          TestMasterIDEncrypted: testMasterID,
          ReferenceStandardIDEncrypted: referenceStandardID,
          RefStandardSubGroup: refStandardSubGroup,
          BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
          CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
          CustomerIDEncrypted: formikAmendment?.values?.amdCustomerIDEncrypted,
          InwardMaterialTestDetailIDEncrypted:
            ListOfAmendmentMaterialTestDetails[indxTest]
              .InwardMaterialTestDetailIDEncrypted,
        }
      )
        .then((response) => {
          if (response?.IsSuccess) {
            /* set the list if any of the parameters is selected from the list based on preference */
            if (
              response?.ParametersList?.filter((x) => x.IsSelected == true)
                ?.length > 0
            ) {
              formikAmendment.setFieldValue(
                `ListOfAmendmentMaterialTestDetails[${indxTest}].ListOfTestParameters`,
                response?.ParametersList
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const handleChangeAmendmentRefStandardSubGroup = (
    referenceStandardID,
    testMasterID,
    indxTest,
    e
  ) => {
    formikAmendment.setFieldValue(
      `ListOfAmendmentMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
      e?.value ?? ""
    );
    getParameterPreferenceBasedOnRefStandardTestMap(
      e?.value ?? "",
      referenceStandardID,
      testMasterID,
      indxTest
    );
  };

  const [showCancelTestModal, setShowCancelTestModal] = useState(false);

  const InwardMaterialCancelTest = (inwardMaterialID) => {
    formikCancelTest.resetForm();
    getInwardMaterialDetailsForCancelTest(inwardMaterialID);
  };

  const getInwardMaterialDetailsForCancelTest = async (inwardMaterialID) => {
    setIsLoading(true);
    await post(POST_CancelTest_GetInwardMaterialDetails, {
      InwardMaterialIDEncrypted: inwardMaterialID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikCancelTest.setFieldValue(
            "cancelTestInwardIDEncrypted",
            response?.InwardIDEncrypted
          );
          formikCancelTest.setFieldValue(
            "cancelTestInwardMaterialIDEncrypted",
            response?.InwardMaterialIDEncrypted
          );
          formikCancelTest.setFieldValue(
            "cancelTestInwardNo",
            response?.InwardNo
          );
          formikCancelTest.setFieldValue(
            "cancelTestInwardDate",
            response?.InwardDate
          );
          formikCancelTest.setFieldValue("cancelTestTCNo", response?.TCNo);
          formikCancelTest.setFieldValue(
            "cancelTestLetterRefNo",
            response?.LetterRefNo
          );
          formikCancelTest.setFieldValue(
            "cancelTestCustomerIDEncrypted",
            response?.CustomerIDEncrypted
          );
          formikCancelTest.setFieldValue(
            "cancelTestCustomerName",
            response?.CustomerName
          );
          formikCancelTest.setFieldValue(
            "cancelTestCustomerProjectIDEncrypted",
            response?.CustomerProjectIDEncrypted
          );
          formikCancelTest.setFieldValue(
            "cancelTestCustomerProjectName",
            response?.CustomerProjectName
          );
          // formikCancelTest.setFieldValue(
          //   "cancelTestDepartmentIDEncrypted",
          //   response?.DepartmentIDEncrypted
          // );
          // formikCancelTest.setFieldValue(
          //   "cancelTestDepartmenName",
          //   response?.DepartmentName
          // );
          // formikCancelTest.setFieldValue(
          //   "cancelTestProductGroupIDEncryted",
          //   response?.ProductGroupIDEncrypted
          // );
          // formikCancelTest.setFieldValue(
          //   "cancelTestProductGroupName",
          //   response?.ProductGroupName
          // );
          // formikCancelTest.setFieldValue(
          //   "cancelTestMaterialTypeIDEncrypted",
          //   response?.MaterialTypeIDEncrypted
          // );
          // formikCancelTest.setFieldValue(
          //   "cancelTestMaterialTypeName",
          //   response?.MaterialTypeName
          // );
          formikCancelTest.setFieldValue("cancelTestSize", response?.Size);
          formikCancelTest.setFieldValue(
            "cancelTestCondition",
            response?.Condition
          );
          formikCancelTest.setFieldValue(
            "cancelTestSampleDetail",
            response?.SampleDetail
          );
          formikCancelTest.setFieldValue(
            "cancelTestProjectDetails",
            response?.ProjectDetails
          );

          formikCancelTest.setFieldValue(
            "ListOfCancelTestMaterialTestDetails",
            response?.ListOfTests?.map((x) => {
              return {
                ...x,
                IsSelected: false,
              };
            })
          );

          setShowCancelTestModal(true);
          setIsLoading(false);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchemaCancelTest = Yup.object().shape({
    CancelRemarks: Yup.string().required("Cancel Remarks is required field"),
  });

  const formikCancelTest = useFormik({
    validationSchemaCancelTest,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitCancelTest(values, formikHelpers),
    initialValues: {
      cancelTestInwardIDEncrypted: "",
      cancelTestInwardMaterialIDEncrypted: "",
      cancelTestInwardNo: "",
      cancelTestInwardDate: "",
      cancelTestTCNo: "",
      cancelTestLetterRefNo: "",
      cancelTestCustomerIDEncrypted: "",
      cancelTestCustomerName: "",
      cancelTestCustomerProjectIDEncrypted: "",
      cancelTestCustomerProjectName: "",
      // cancelTestDepartmentIDEncrypted: "",
      // cancelTestDepartmenName: "",
      // cancelTestProductGroupIDEncryted: "",
      // cancelTestProductGroupName: "",
      // cancelTestMaterialTypeIDEncrypted: "",
      // cancelTestMaterialTypeName: "",
      cancelTestSize: "",
      cancelTestCondition: "",
      cancelTestSampleDetail: "",
      cancelTestProjectDetails: "",
      ListOfCancelTestMaterialTestDetails: [],
      CancelRemarks: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      cancelTestInwardNo,
      cancelTestInwardDate,
      cancelTestTCNo,
      cancelTestLetterRefNo,
      cancelTestCustomerName,
      cancelTestCustomerProjectName,
      // cancelTestDepartmenName,
      // cancelTestProductGroupName,
      // cancelTestMaterialTypeName,
      cancelTestSize,
      cancelTestCondition,
      cancelTestSampleDetail,
      cancelTestProjectDetails,
      ListOfCancelTestMaterialTestDetails,
    },
  } = formikCancelTest;

  const handleValidSubmitCancelTest = (values) => {
    let isValid = true;
    //console.log("Details", values);

    if (values?.CancelRemarks?.trim() == "") {
      formikCancelTest.setFieldError(
        "CancelRemarks",
        "Cancel Remarks is required field"
      );
      formikCancelTest.setFieldTouched("CancelRemarks", true);
      isValid = false;
    }

    if (
      values?.ListOfCancelTestMaterialTestDetails?.filter(
        (x) => x.IsSelected == true
      )?.length == 0
    ) {
      formikCancelTest.setFieldError(
        "ListOfCancelTestMaterialTestDetails",
        "Select atleast one Test to Cancel"
      );

      formikCancelTest.setFieldTouched(
        "ListOfCancelTestMaterialTestDetails",
        true
      );
      isValid = false;
    }

    if (isValid == false) {
      return;
    } else {
      setIsLoading(true);

      let payload = {
        InwardIDEncrypted: values?.cancelTestInwardIDEncrypted,
        InwardMaterialIDEncrypted: values?.cancelTestInwardMaterialIDEncrypted,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt
          ? AuthUser?.ReferenceIDEncrypt
          : "0",
        CancelRemarks: values?.CancelRemarks,
        InwardMaterialTestDetailIDs:
          values?.ListOfCancelTestMaterialTestDetails?.filter(
            (e) => e.IsSelected == true
          ).length > 0
            ? Array.from(
                values?.ListOfCancelTestMaterialTestDetails?.filter(
                  (e) => e.IsSelected == true
                ),
                (x) => x.InwardMaterialTestDetailIDEncrypted
              ).join(",")
            : "",
      };

      post(POST_CancelTestSave, payload)
        .then((response) => {
          if (response?.IsSuccess) {
            successMessage(response?.Message);
            setIsLoading(false);
            setShowCancelTestModal(false);
            getData(currentPage, currentSizePerPage);
          } else {
            errorMessage(response?.Message);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const [showInwardMaterialRewiseModal, setShowInwardMaterialRewiseModal] =
    useState(false);
  const [showRewiseLetterRefDocModal, setShowRewiseLetterRefDocModal] =
    useState(false);

  const [rewiseNoOptions, setRewiseNoOptions] = useState([]);
  const [showRewiseHistModal, setShowRewiseHistModal] = useState(false);
  const [showRewiseHistDetailModal, setShowRewiseHistDetailModal] =
    useState(false);

  const InwardMaterialRewise = (inwardMaterialID) => {
    formikInwardMaterialRewise.resetForm();
    getInwardMaterialDetailsForRewise(inwardMaterialID);
  };

  const getInwardMaterialDetailsForRewise = async (inwardMaterialID) => {
    setIsLoading(true);
    await post(POST_Rewise_GetInwardMaterialDetails, {
      InwardMaterialIDEncrypted: inwardMaterialID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikInwardMaterialRewise.setValues({
            RewiseInwardIDEncrypted: response?.InwardIDEncrypted,
            RewiseInwardMaterialIDEncrypted:
              response?.InwardMaterialIDEncrypted,
            RewiseInwardNo: response?.InwardNo,
            RewiseInwardDate: response?.InwardDate,
            RewiseTCNo: response?.TCNo,
            RewiseLetterRefNo: response?.LetterRefNo,
            RewiseCustomerName: response?.CustomerName,
            RewiseCustomerProjectName: response?.CustomerProjectName,
            RewiseProductGroupName: response?.ProductGroupName,
            RewiseMaterialTypeName: response?.MaterialTypeName,
            RewiseSize: response?.Size,
            RewiseCondition: response?.Condition,
            RewiseSampleDetail: response?.SampleDetail,
            RewiseProjectDetails: response?.ProjectDetails,
            RewiseTypeList: response?.ListOfRewiseType?.map((x) => {
              return {
                ...x,
                IsSelected: false,
              };
            }),
            RewiseLetterRefImagesList: response?.ListOfLetterRefImages?.map(
              (x) => {
                return {
                  ...x,
                  LetterRefImageFile: "",
                  viewFile: "",
                  LetterRefImageFileName: x?.LetterRefImageFileName,
                  LetterRefImageFilePath: x?.LetterRefImageFilePath,
                  IsDeleted: false,
                };
              }
            ),

            ListOfRewiseHist: response?.ListOfRewise,
            RewiseCount: response?.RewiseCount,
            RewiseRemarks: "",
            RewiseDate: new Date(),
            RewiseNo: "",
          });
          getRewiseNoDDL();
          setShowInwardMaterialRewiseModal(true);
          setIsLoading(false);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadRewiseLetterRefDoc = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];

      if (file) {
        formikInwardMaterialRewise.setFieldValue("RewiseLetterRefImagesList", [
          ...RewiseLetterRefImagesList,
          {
            InwardLetterRefImageIDEncrypted: "",
            LetterRefImageFile: file,
            viewFile: URL.createObjectURL(file),
            LetterRefImageFileName: file?.name,
            LetterRefImageFilePath: "",
            IsDeleted: false,
          },
        ]);
      }
    }
  };

  const deleteRewiseLetterRefDoc = (i) => {
    if (RewiseLetterRefImagesList[i]?.InwardLetterRefImageIDEncrypted) {
      formikInwardMaterialRewise.setFieldValue(
        `RewiseLetterRefImagesList[${i}].IsDeleted`,
        true
      );
    } else {
      formikInwardMaterialRewise.setFieldValue(
        "RewiseLetterRefImagesList",
        RewiseLetterRefImagesList?.filter((x, ix) => ix != i)
      );
    }
  };

  const validationSchemaInwardMaterialRewise = Yup.object().shape({
    //RewiseRemarks: Yup.string().required("Rewise Remarks is required field"),
    // RewiseDate: Yup.string().required("Rewise Date is required field"),
  });

  const formikInwardMaterialRewise = useFormik({
    validationSchemaInwardMaterialRewise,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitInwardMaterialRewise(values, formikHelpers),
    initialValues: {
      RewiseInwardIDEncrypted: "",
      RewiseInwardMaterialIDEncrypted: "",
      RewiseInwardNo: "",
      RewiseInwardDate: "",
      RewiseTCNo: "",
      RewiseLetterRefNo: "",
      RewiseCustomerIDEncrypted: "",
      RewiseCustomerName: "",
      RewiseCustomerProjectIDEncrypted: "",
      RewiseCustomerProjectName: "",
      RewiseDepartmentIDEncrypted: "",
      RewiseProductGroupIDEncryted: "",
      RewiseProductGroupName: "",
      RewiseMaterialTypeIDEncrypted: "",
      RewiseMaterialTypeName: "",
      RewiseSize: "",
      RewiseCondition: "",
      RewiseSampleDetail: "",
      RewiseProjectDetails: "",
      RewiseTypeList: [],
      RewiseLetterRefImagesList: [],
      RewiseRemarks: "",
      RewiseFileUpload: "",
      RewiseDate: new Date(),
      RewiseNo: "",
      ListOfRewiseHist: [],
      ListOfRewiseHistDetails: [],
      RewiseCount: 0,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      RewiseInwardIDEncrypted,
      RewiseInwardMaterialIDEncrypted,
      RewiseInwardNo,
      RewiseInwardDate,
      RewiseTCNo,
      RewiseLetterRefNo,
      RewiseCustomerName,
      RewiseCustomerProjectName,
      RewiseProductGroupName,
      RewiseMaterialTypeName,
      RewiseSize,
      RewiseCondition,
      RewiseSampleDetail,
      RewiseProjectDetails,
      RewiseTypeList,
      RewiseFileUpload,
      RewiseLetterRefImagesList,
      RewiseNo,
      RewiseDate,
      ListOfRewiseHist,
      ListOfRewiseHistDetails,
      RewiseCount,
    },
  } = formikInwardMaterialRewise;

  const handleValidSubmitInwardMaterialRewise = (values) => {
    let isValid = true;

    if (values?.RewiseNo?.trim() == "") {
      formikInwardMaterialRewise.setFieldError(
        "RewiseNo",
        "Revise No is required field"
      );
      formikInwardMaterialRewise.setFieldTouched("RewiseNo", true);
      isValid = false;
    }
    if (values?.RewiseRemarks?.trim() == "") {
      formikInwardMaterialRewise.setFieldError(
        "RewiseRemarks",
        "Revise Remarks is required field"
      );
      formikInwardMaterialRewise.setFieldTouched("RewiseRemarks", true);
      isValid = false;
    }

    if (values?.RewiseDate == "") {
      formikInwardMaterialRewise.setFieldError(
        "RewiseDate",
        "Revise Date is required field"
      );
      formikInwardMaterialRewise.setFieldTouched("RewiseDate", true);
      isValid = false;
    }

    // if (values?.RewiseDate == undefined) {
    //   formikInwardMaterialRewise.setFieldError(
    //     "RewiseDate",
    //     "Revise Date is required field"
    //   );
    //   formikInwardMaterialRewise.setFieldTouched("RewiseDate", true);
    //   isValid = false;
    // }

    if (
      values?.RewiseTypeList?.filter((x) => x.IsSelected == true)?.length == 0
    ) {
      formikInwardMaterialRewise.setFieldError(
        "RewiseTypeList",
        "Select atleast one Revise Type"
      );

      formikInwardMaterialRewise.setFieldTouched("RewiseTypeList", true);
      isValid = false;
    }

    if (
      values?.RewiseTypeList?.filter(
        (x) => x.IsSelected == true && x?.NewValues == ""
      )?.length > 0
    ) {
      formikInwardMaterialRewise.setFieldError(
        "RewiseTypeList",
        "Please Enter New Values to Selected Revise Type"
      );

      formikInwardMaterialRewise.setFieldTouched("RewiseTypeList", true);
      isValid = false;
    }

    if (isValid == false) {
      return;
    } else {
      setIsLoading(true);
      let formData = new FormData();
      formData.append("InwardDate", values?.RewiseInwardDate);
      formData.append("InwardIDEncrypted", values?.RewiseInwardIDEncrypted);
      formData.append(
        "InwardMaterialIDEncrypted",
        values?.RewiseInwardMaterialIDEncrypted
      );
      formData.append("RewiseNoEncrypted", values?.RewiseNo);
      formData.append("RewiseRemarks", values?.RewiseRemarks);
      formData.append("RewiseFileUpload", RewiseFileUpload ?? "");

      formData.append(
        "RewiseDate",
        values?.RewiseDate
          ? moment(values?.RewiseDate).format("YYYY-MM-DD").replace(/^\-/, "")
          : ""
      );

      Promise.all(
        values?.RewiseTypeList?.map((x, i) => {
          formData.append(
            `RewiseTypeList[${i}].InwardIDEncrypted`,
            x?.InwardIDEncrypted
          );
          formData.append(
            `RewiseTypeList[${i}].InwardMaterialIDEncrypted`,
            x?.InwardMaterialIDEncrypted
          );
          formData.append(`RewiseTypeList[${i}].RewiseType`, x?.RewiseType);
          formData.append(`RewiseTypeList[${i}].RewiseTypeID`, x?.RewiseTypeID);
          formData.append(
            `RewiseTypeList[${i}].OldValues`,
            x?.OldValues ? x?.OldValues : ""
          );
          formData.append(
            `RewiseTypeList[${i}].NewValues`,
            x?.NewValues ? x?.NewValues : ""
          );
          formData.append(`RewiseTypeList[${i}].IsSelected`, x?.IsSelected);
        })
      );

      Promise.all(
        values?.RewiseLetterRefImagesList?.map((x, i) => {
          formData.append(
            `RewiseLetterRefImagesList[${i}].InwardLetterRefImageIDEncrypted`,
            x?.InwardLetterRefImageIDEncrypted
          );
          formData.append(
            `RewiseLetterRefImagesList[${i}].LetterRefImageFile`,
            x?.LetterRefImageFile
          );
          formData.append(
            `RewiseLetterRefImagesList[${i}].LetterRefImageFilePath`,
            x?.LetterRefImageFilePath
          );
          formData.append(
            `RewiseLetterRefImagesList[${i}].IsDeleted`,
            x?.IsDeleted
          );
        })
      );

      formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
      formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
      formData.append(
        "CreatedByEncrypted",
        AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
      );

      postFormData(POST_RewiseInwardMaterialSave, formData)
        .then((response) => {
          setIsLoading(true);
          if (response?.IsSuccess) {
            successMessage(response?.Message);
            setTimeout(() => {
              setShowInwardMaterialRewiseModal(false);
            }, 1000);
            getData(currentPage, currentSizePerPage);
            setIsLoading(false);
          } else {
            errorMessage(response?.Message);
            setIsLoading(false);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const getRewiseNoDDL = async () => {
    setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 11, // 1 = Rewise
      TranDate: RewiseDate
        ? moment(RewiseDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setRewiseNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item.VoucherSeries,
              value: item.VoucherSeriesIDEncrypt,
            }))
          );

          /*select the value when there is only one option while insert only*/
          if (response?.VoucherSeriesList?.length == 1) {
            formikInwardMaterialRewise.setFieldValue(
              "RewiseNo",
              response?.VoucherSeriesList[0].VoucherSeriesIDEncrypt
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadRewiseFile = (e) => {
    formikInwardMaterialRewise.setFieldValue("RewiseFileUpload", "");
    if (e.target.files[0]) {
      const file = e.target.files[0];
      // var pattern = /(doc|docx|pdf)$/;

      if (file) {
        formikInwardMaterialRewise.setFieldValue("RewiseFileUpload", file);
      } else {
        formikInwardMaterialRewise.setFieldValue("RewiseFileUpload", "");
      }
    }
  };

  const [letterRefDocPhoto, setLetterRefDocPhoto] = useState(null);
  const [letterRefDocPhotoFile, setLetterRefDocPhotoFile] = useState(null);
  const [
    openWebCamModalLetterRefDocImage,
    setOpenWebCamModalLetterRefDocImage,
  ] = useState(false);

  const [letterRefDocPhotoFileName, setLetterRefDocPhotoFileName] = useState();

  const addLetterRefDocFile = () => {
    formikInwardMaterialRewise.setFieldValue("RewiseLetterRefImagesList", [
      ...RewiseLetterRefImagesList,
      {
        InwardLetterRefImageIDEncrypted: "",
        LetterRefImageFile: letterRefDocPhotoFile,
        viewFile: URL.createObjectURL(letterRefDocPhotoFile),
        LetterRefImageFileName: letterRefDocPhotoFileName,
        LetterRefImageFilePath: "",
        IsDeleted: false,
      },
    ]);

    setLetterRefDocPhoto(null);
    setLetterRefDocPhotoFile(null);
  };

  const captureLetterRefDocPhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();

    if (imageSrc !== null) {
      setLetterRefDocPhoto(imageSrc);
      const outputFileLetterRefDocPhotoCapture = await dataUrlToFileUsingFetch(
        imageSrc,
        "output.png",
        "image/png"
      );
      setLetterRefDocPhotoFile(outputFileLetterRefDocPhotoCapture);
      const fileName = outputFileLetterRefDocPhotoCapture.name;
      setLetterRefDocPhotoFileName(fileName);
    } else {
      warningMessage("Webcam device not found.");
    }
    setOpenWebCamModalLetterRefDocImage(false);
  }, [webcamRef]);

  const onUserMedia = (e) => {
    console.log(e);
  };
  const getInwardMaterialTestParametersList = async (
    inwardMaterialTestDetailID,
    testMasterID,
    tIndex
  ) => {
    setIsLoading(true);
    await post(POST_GetTestParametersList, {
      TestMasterIDEncrypted: testMasterID,
      CustomerIDEncrypted: formikAmendment?.values?.amdCustomerIDEncrypted,
      InwardMaterialTestDetailIDEncrypted: inwardMaterialTestDetailID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikAmendment.setFieldValue(
            `ListOfAmendmentMaterialTestDetails[${tIndex}].ListOfTestParameters`,
            response?.ParametersList?.filter((x) => x.IsSelected == true)
              ?.length > 0
              ? response?.ParametersList
              : response?.ParametersList?.map((para) => ({
                  ...para,
                  IsSelected: true,
                }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showTestParametersModal, setShowTestParametersModal] = useState(false);

  const validationTestParameters = Yup.object().shape({});

  const formikTestPrameters = useFormik({
    validationSchema: validationTestParameters,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestParameters(values, formikHelpers),
    initialValues: {
      ParametersTestName: "",
      ParametersList: [],
      testIndexPara: 0,
    },
    validateOnBlur: false,
  });

  const {
    values: { ParametersTestName, ParametersList },
  } = formikTestPrameters;

  const handleValidSubmitTestParameters = (values) => {
    formikAmendment.setFieldValue(
      `ListOfAmendmentMaterialTestDetails[${values?.testIndexPara}].ListOfTestParameters`,
      values?.ParametersList
    );
    setShowTestParametersModal(false);
  };

  const [listOfLetterRefDoc, setListOfLetterRefDoc] = useState([]);
  const [showLetterRefDocModal, setShowLetterRefDocModal] = useState(false);

  const getListOfLetterRefDoc = async (listLetterRefNoDoc) => {
    setListOfLetterRefDoc([]);
    if (listLetterRefNoDoc) {
      setListOfLetterRefDoc(listLetterRefNoDoc);
      setShowLetterRefDocModal(true);
    }
  };

  const handleChangeAmendmentTestMaster = (indx, indxTest, e, itemTest) => {
    const path = `ListOfAmendmentMaterialTestDetails[${indxTest}]`;
    let mixDesignTest = false;
    if (itemTest.IsMixDesign == true) {
      mixDesignTest = true;
      setSelectedMixDesignTestID(itemTest.TestMasterIDEncrypted);
    }

    if (e && e?.value) {
      if (e?.value !== itemTest?.TestMasterIDEncrypted) {
        let IsTestAlreadyExist = false;
        Promise.all(
          ListOfAmendmentMaterialTestDetails?.map((item, idxt) => {
            if (
              item?.IsDeleted == false &&
              idxt != indxTest &&
              item?.TestMasterIDEncrypted === e?.value
            ) {
              IsTestAlreadyExist = true;
            }
          })
        );
        Promise.all(
          ListOfMaterialTestDetails?.filter((x) => x?.IsCancel == false)?.map(
            (item, idxt) => {
              if (item?.TestMasterIDEncrypted === e?.value) {
                IsTestAlreadyExist = true;
              }
            }
          )
        );

        formikAmendment.setFieldValue(`${path}.ListOfTestParameters`, []);
        formikAmendment.setFieldValue(`${path}.IsMixDesign`, false);
        formikAmendment.setFieldValue(
          `${path}.TestMixDesignDetail`,
          initAmendmentMaterialTestDetail.TestMixDesignDetail
        );
        formikAmendment.setFieldValue(`${path}.TestMethodIDEncrypted`, "");
        formikAmendment.setFieldValue(
          `${path}.ReferenceStandardIDEncrypted`,
          ""
        );
        formikAmendment.setFieldValue(`${path}.referenceStandardOptions`, []);
        formikAmendment.setFieldValue(`${path}.RefStandardSubGroup`, "");
        formikAmendment.setFieldValue(`${path}.refStandardSubGroupOptions`, []);
        formikAmendment.setFieldValue(`${path}.ProductGroupIDEncrypted`, "");
        formikAmendment.setFieldValue(`${path}.MaterialTypeIDEncrypted`, "");
        if (IsTestAlreadyExist) {
          formikAmendment.setFieldValue(`${path}.TestMasterIDEncrypted`, "");
          warningMessage("Selected Test already Exist...!");
          return;
        } else {
          formikAmendment.setFieldValue(
            `${path}.TestMasterIDEncrypted`,
            e?.value
          );
          if (e?.IsMixDesign == true) {
            formikMixDesignTestDetails.resetForm();
            formikMixDesignTestDetails.setFieldValue(
              "MixDesignTestName",
              e?.label
            );
            formikMixDesignTestDetails.setFieldValue("tcIndex", indx);
            formikMixDesignTestDetails.setFieldValue("testIndex", indxTest);
            getMixDesignMasterDDLAll(e?.value ?? "");
            setShowMixDesignTestDetailModal(true);
          }
          formikAmendment.setFieldValue(`${path}.IsMixDesign`, e?.IsMixDesign);
          getInwardMaterialTestParametersList(
            itemTest?.InwardMaterialTestDetailIDEncrypted,
            e?.value,
            indxTest
          );
          getInwardMaterialDefineMoreRatesList(
            itemTest?.InwardMaterialTestDetailIDEncrypted,
            e?.value,
            indx,
            indxTest
          );
          getTestMethodDDL_RefStandardDDL_TestDetailsByTest(e?.value, indxTest);
        }
      }
    } else {
      formikAmendment.setFieldValue(`${path}.ListOfTestParameters`, []);
      formikAmendment.setFieldValue(`${path}.IsMixDesign`, false);
      formikAmendment.setFieldValue(
        `${path}.TestMixDesignDetail`,
        initAmendmentMaterialTestDetail.TestMixDesignDetail
      );
      formikAmendment.setFieldValue(`${path}.TestMasterIDEncrypted`, "");
      formikAmendment.setFieldValue(`${path}.TestMethodIDEncrypted`, "");
      formikAmendment.setFieldValue(`${path}.ReferenceStandardIDEncrypted`, "");
      formikAmendment.setFieldValue(`${path}.referenceStandardOptions`, []);
      formikAmendment.setFieldValue(`${path}.RefStandardSubGroup`, "");
      formikAmendment.setFieldValue(`${path}.refStandardSubGroupOptions`, []);
      formikAmendment.setFieldValue(`${path}.ProductGroupIDEncrypted`, "");
      formikAmendment.setFieldValue(`${path}.MaterialTypeIDEncrypted`, "");
    }

    if (mixDesignTest == true) {
      setDeleteMixDesignIncludedTestActionStatus(true);
    }
  };

  const [showMixDesignTestDetailModal, setShowMixDesignTestDetailModal] =
    useState(false);

  const validationMixDesignTestDetail = Yup.object().shape({
    GradeDesignation: Yup.string().required(
      "Grade Designation is required field"
    ),
  });

  const formikMixDesignTestDetails = useFormik({
    validationSchema: validationMixDesignTestDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitMixDesignTestDetail(values, formikHelpers),
    initialValues: {
      MixDesignTestName: "",
      StipulationsProportioningIDEncrypted: "",
      TypeofCementIDEncrypted: "",
      TypeofMineralAdmixtureIDEncrypted: "",
      MaximumNominalSizeofAggregateIDEncrypted: "",
      EnvironmentalExposureConditionsIDEncrypted: "",
      TypeofAggregateFineIDEncrypted: "",
      ChemicalAdmixtureTypeIDEncrypted: "",
      ChemicalAdmixtureBrandBatchandMarkIDEncrypted: "",
      GradeDesignation: "",
      MinimumCementContent: "",
      MaximumCementContent: "450",
      MaximumWaterCementRatio: "",
      Workability: "",
      RetentionTime: "",
      TransportationTime: "",
      DegreeofSiteControl: "Good",
      TypeofAggregateFineCoarse: "Crushed angular aggregate",
      MethodofConcretePlacingIsChute_NonPumpable: false,
      MethodofConcretePlacingIsPumping: false,
      optionsTypeOfCement: [],
      optionsTypeOfMineralAdmixture: [],
      optionsMaximumNominalSizeofAggregate: [],
      optionsEnvironmentralExposureConditions: [],
      optionsTypeOfAggregateFine: [],
      optionsChemicalAdmixtureType: [],
      optionsChemicalAdmixtureBrandBatchMarkId: [],
      ListOfMixDesignIncludedTest: [],
      tcIndex: 0,
      testIndex: 0,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      MixDesignTestName,
      optionsTypeOfCement,
      optionsTypeOfMineralAdmixture,
      optionsMaximumNominalSizeofAggregate,
      optionsEnvironmentralExposureConditions,
      optionsTypeOfAggregateFine,
      optionsChemicalAdmixtureType,
      optionsChemicalAdmixtureBrandBatchMarkId,
      MethodofConcretePlacingIsChute_NonPumpable,
      MethodofConcretePlacingIsPumping,
    },
  } = formikMixDesignTestDetails;

  const [mixDesignTestAddingAction, setMixDesignTestAddingAction] =
    useState(false);
  const [countOfNewAddedIncludedTest, setCountOfNewAddedIncludedTest] =
    useState(0);

  useEffect(() => {
    if (mixDesignTestAddingAction == true) {
      let totalTests = ListOfAmendmentMaterialTestDetails.length;
      if (countOfNewAddedIncludedTest > 0) {
        let startIndex = totalTests - countOfNewAddedIncludedTest;
        let endIndex = startIndex + countOfNewAddedIncludedTest - 1;

        if (startIndex > 0) {
          for (let i = startIndex; i <= endIndex; i++) {
            getInwardMaterialTestParametersList(
              ListOfAmendmentMaterialTestDetails[i]
                ?.InwardMaterialTestDetailIDEncrypted,
              ListOfAmendmentMaterialTestDetails[i]?.TestMasterIDEncrypted,
              i
            );
            getInwardMaterialDefineMoreRatesList(
              ListOfAmendmentMaterialTestDetails[i]
                ?.InwardMaterialTestDetailIDEncrypted,
              ListOfAmendmentMaterialTestDetails[i]?.TestMasterIDEncrypted,
              0,
              i
            );
            getTestMethodDDL_RefStandardDDL_TestDetailsByTest(
              ListOfAmendmentMaterialTestDetails[i]?.TestMasterIDEncrypted,
              i
            );
          }
        }
      }
      setMixDesignTestAddingAction(false);
    }
  }, [mixDesignTestAddingAction]);

  const handleValidSubmitMixDesignTestDetail = (values) => {
    let existingListOfMaterialTestDetails = ListOfMaterialTestDetails;
    let existingListOfAmendmentMaterialTestDetails =
      ListOfAmendmentMaterialTestDetails;

    existingListOfAmendmentMaterialTestDetails[
      values.testIndex
    ].TestMixDesignDetail = {
      StipulationsProportioningIDEncrypted:
        values?.StipulationsProportioningIDEncrypted,
      TypeofCementIDEncrypted: values?.TypeofCementIDEncrypted,
      TypeofMineralAdmixtureIDEncrypted:
        values?.TypeofMineralAdmixtureIDEncrypted,
      MaximumNominalSizeofAggregateIDEncrypted:
        values?.MaximumNominalSizeofAggregateIDEncrypted,
      EnvironmentalExposureConditionsIDEncrypted:
        values?.EnvironmentalExposureConditionsIDEncrypted,
      TypeofAggregateFineIDEncrypted: values?.TypeofAggregateFineIDEncrypted,
      ChemicalAdmixtureTypeIDEncrypted:
        values?.ChemicalAdmixtureTypeIDEncrypted,
      ChemicalAdmixtureBrandBatchandMarkIDEncrypted:
        values?.ChemicalAdmixtureBrandBatchandMarkIDEncrypted,
      GradeDesignation: values?.GradeDesignation,
      MinimumCementContent: values?.MinimumCementContent
        ? values?.MinimumCementContent.toString()
        : "",
      MaximumCementContent: values?.MaximumCementContent
        ? values?.MaximumCementContent.toString()
        : "",
      MaximumWaterCementRatio: values?.MaximumWaterCementRatio
        ? values?.MaximumWaterCementRatio.toString()
        : "",
      Workability: values?.Workability,
      RetentionTime:
        values?.RetentionTime != ""
          ? moment(values?.RetentionTime, "HH:mm:ss")
              .format("HH:mm")
              .replace(/^\-/, "")
          : "",
      TransportationTime:
        values?.TransportationTime != ""
          ? moment(values?.TransportationTime, "HH:mm:ss")
              .format("HH:mm")
              .replace(/^\-/, "")
          : "",
      DegreeofSiteControl: values?.DegreeofSiteControl,
      TypeofAggregateFineCoarse: values?.TypeofAggregateFineCoarse,
      MethodofConcretePlacingIsChute_NonPumpable:
        values?.MethodofConcretePlacingIsChute_NonPumpable,
      MethodofConcretePlacingIsPumping:
        values?.MethodofConcretePlacingIsPumping,
    };

    let includedTestTobeAddList = [];
    values?.ListOfMixDesignIncludedTest?.map((x) => {
      if (
        ListOfAmendmentMaterialTestDetails.filter(
          (test) =>
            test.TestMasterIDEncrypted == x.TestMasterIDEncrypted &&
            test.IsDeleted == false &&
            test.IsCancel == false
        ).length == 0 &&
        ListOfMaterialTestDetails.filter(
          (test) =>
            test.TestMasterIDEncrypted == x.TestMasterIDEncrypted &&
            //test.IsDeleted == false &&
            test.IsCancel == false
        ).length == 0
      ) {
        includedTestTobeAddList.push({
          ...initAmendmentMaterialTestDetail,
          DepartmentIDEncrypted:
            ListOfAmendmentMaterialTestDetails[values.testIndex]
              .DepartmentIDEncrypted,
          testOptions:
            ListOfAmendmentMaterialTestDetails[values.testIndex].testOptions,
          TestMasterIDEncrypted: x.TestMasterIDEncrypted,
          IsMixDesignIncludedTest: true,
          MixDesignTestMasterIDEncrypted:
            ListOfAmendmentMaterialTestDetails[values.testIndex]
              .TestMasterIDEncrypted,
        });
      } else {
        if (
          ListOfAmendmentMaterialTestDetails.filter(
            (test) =>
              test.TestMasterIDEncrypted == x.TestMasterIDEncrypted &&
              test.IsDeleted == false &&
              test.IsCancel == false
          ).length > 0
        ) {
          let testIndexExisting = ListOfAmendmentMaterialTestDetails.findIndex(
            (test) =>
              test.TestMasterIDEncrypted == x.TestMasterIDEncrypted &&
              test.IsDeleted == false &&
              test.IsCancel == false
          );
          existingListOfAmendmentMaterialTestDetails[
            testIndexExisting
          ].IsMixDesignIncludedTest = true;
          existingListOfAmendmentMaterialTestDetails[
            testIndexExisting
          ].MixDesignTestMasterIDEncrypted =
            ListOfAmendmentMaterialTestDetails[
              values.testIndex
            ].TestMasterIDEncrypted;
        } else {
          let testIndexExisting = ListOfMaterialTestDetails.findIndex(
            (test) =>
              test.TestMasterIDEncrypted == x.TestMasterIDEncrypted &&
              //test.IsDeleted == false &&
              test.IsCancel == false
          );
          existingListOfMaterialTestDetails[
            testIndexExisting
          ].IsMixDesignIncludedTest = true;
          existingListOfMaterialTestDetails[
            testIndexExisting
          ].MixDesignTestMasterIDEncrypted =
            ListOfAmendmentMaterialTestDetails[
              values.testIndex
            ].TestMasterIDEncrypted;
        }
      }
    });

    setCountOfNewAddedIncludedTest(includedTestTobeAddList.length);
    if (includedTestTobeAddList.length > 0) {
      formikAmendment.setFieldValue(`ListOfAmendmentMaterialTestDetails`, [
        ...existingListOfAmendmentMaterialTestDetails,
        ...includedTestTobeAddList,
      ]);
      formikAmendment.setFieldValue(
        `ListOfMaterialTestDetails`,
        existingListOfMaterialTestDetails
      );
      setMixDesignTestAddingAction(true);
    } else {
      formikAmendment.setFieldValue(
        `ListOfAmendmentMaterialTestDetails`,
        existingListOfAmendmentMaterialTestDetails
      );
    }

    setShowMixDesignTestDetailModal(false);
  };

  const getMixDesignMasterDDLAll = async (testMasterID) => {
    setIsLoading(true);
    await post(POST_GetMixDesignMasterDropDownListAll, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TestMasterIDEncrypted: testMasterID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikMixDesignTestDetails.setFieldValue(
            "optionsTypeOfCement",
            response.TypeofCementList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsTypeOfMineralAdmixture",
            response.TypeofMineralAdmixtureList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsMaximumNominalSizeofAggregate",
            response.MaximumNominalSizeofAggregateList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsEnvironmentralExposureConditions",
            response.EnvironmentalExposureConditionsList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsTypeOfAggregateFine",
            response.TypeofAggregateFineList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsChemicalAdmixtureType",
            response.ChemicalAdmixtureTypeList
          );
          formikMixDesignTestDetails.setFieldValue(
            "optionsChemicalAdmixtureBrandBatchMarkId",
            response.ChemicalAdmixtureBrandBatchandIDMarkList
          );
          formikMixDesignTestDetails.setFieldValue(
            "ListOfMixDesignIncludedTest",
            response.ListOfMixDesignIncludedTest
          );
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOnClickMixDesignDetail = (indx, indxTest, item, itemTest) => {
    formikMixDesignTestDetails.resetForm();
    let testName = itemTest?.testOptions.filter(
      (x) => x.value == itemTest.TestMasterIDEncrypted
    )[0]?.label;
    let mdDetail = itemTest?.TestMixDesignDetail;
    formikMixDesignTestDetails.setFieldValue("MixDesignTestName", testName);
    formikMixDesignTestDetails.setFieldValue("tcIndex", indx);
    formikMixDesignTestDetails.setFieldValue("testIndex", indxTest);
    formikMixDesignTestDetails.setFieldValue(
      "StipulationsProportioningIDEncrypted",
      mdDetail?.StipulationsProportioningIDEncrypted
    );
    formikMixDesignTestDetails.setFieldValue(
      "TypeofCementIDEncrypted",
      mdDetail?.TypeofCementIDEncrypted
    );
    formikMixDesignTestDetails.setFieldValue(
      "TypeofMineralAdmixtureIDEncrypted",
      mdDetail?.TypeofMineralAdmixtureIDEncrypted
    );
    formikMixDesignTestDetails.setFieldValue(
      "MaximumNominalSizeofAggregateIDEncrypted",
      mdDetail?.MaximumNominalSizeofAggregateIDEncrypted
    );
    formikMixDesignTestDetails.setFieldValue(
      "EnvironmentalExposureConditionsIDEncrypted",
      mdDetail?.EnvironmentalExposureConditionsIDEncrypted
    );
    formikMixDesignTestDetails.setFieldValue(
      "TypeofAggregateFineIDEncrypted",
      mdDetail?.TypeofAggregateFineIDEncrypted
    );
    formikMixDesignTestDetails.setFieldValue(
      "ChemicalAdmixtureTypeIDEncrypted",
      mdDetail?.ChemicalAdmixtureTypeIDEncrypted
    );
    formikMixDesignTestDetails.setFieldValue(
      "ChemicalAdmixtureBrandBatchandMarkIDEncrypted",
      mdDetail?.ChemicalAdmixtureBrandBatchandMarkIDEncrypted
    );
    formikMixDesignTestDetails.setFieldValue(
      "GradeDesignation",
      mdDetail?.GradeDesignation
    );
    formikMixDesignTestDetails.setFieldValue(
      "MinimumCementContent",
      mdDetail?.MinimumCementContent
    );
    formikMixDesignTestDetails.setFieldValue(
      "MaximumCementContent",
      mdDetail?.MaximumCementContent == ""
        ? "450"
        : mdDetail?.MaximumCementContent
    );
    formikMixDesignTestDetails.setFieldValue(
      "MaximumWaterCementRatio",
      mdDetail?.MaximumWaterCementRatio
    );
    formikMixDesignTestDetails.setFieldValue(
      "Workability",
      mdDetail?.Workability
    );
    formikMixDesignTestDetails.setFieldValue(
      "RetentionTime",
      mdDetail?.RetentionTime != ""
        ? convertTimeToDateTime(mdDetail?.RetentionTime)
        : ""
    );
    formikMixDesignTestDetails.setFieldValue(
      "TransportationTime",
      mdDetail?.TransportationTime != ""
        ? convertTimeToDateTime(mdDetail?.TransportationTime)
        : ""
    );
    formikMixDesignTestDetails.setFieldValue(
      "DegreeofSiteControl",
      mdDetail?.DegreeofSiteControl == ""
        ? "Good"
        : mdDetail?.DegreeofSiteControl
    );
    formikMixDesignTestDetails.setFieldValue(
      "TypeofAggregateFineCoarse",
      mdDetail?.TypeofAggregateFineCoarse == ""
        ? "Crushed angular aggregate"
        : mdDetail?.TypeofAggregateFineCoarse
    );
    formikMixDesignTestDetails.setFieldValue(
      "MethodofConcretePlacingIsChute_NonPumpable",
      mdDetail?.MethodofConcretePlacingIsChute_NonPumpable
    );
    formikMixDesignTestDetails.setFieldValue(
      "MethodofConcretePlacingIsPumping",
      mdDetail?.MethodofConcretePlacingIsPumping
    );
    getMixDesignMasterDDLAll(itemTest.TestMasterIDEncrypted);
    setShowMixDesignTestDetailModal(true);
  };

  const [selectedMixDesignTestID, setSelectedMixDesignTestID] = useState("");
  const [
    deleteMixDesignIncludedTestActionStatus,
    setDeleteMixDesignIncludedTestActionStatus,
  ] = useState(false);

  useEffect(() => {
    if (deleteMixDesignIncludedTestActionStatus == true) {
      deleteMixDesignIncludedTest(selectedMixDesignTestID);
      setDeleteMixDesignIncludedTestActionStatus(false);
    }
  }, [deleteMixDesignIncludedTestActionStatus]);

  const deleteMixDesignIncludedTest = (
    mixDesignTestID,
    deleteMixDesignTestAlso = false
  ) => {
    let newListOfMaterialTestDetails = [];
    Promise.all(
      ListOfAmendmentMaterialTestDetails?.map((test, tIx) => {
        if (test?.InwardMaterialTestDetailIDEncrypted) {
          if (test.MixDesignTestMasterIDEncrypted == mixDesignTestID) {
            newListOfMaterialTestDetails.push({ ...test, IsDeleted: true });
          } else {
            if (test.TestMasterIDEncrypted == mixDesignTestID) {
              if (deleteMixDesignTestAlso == true) {
                newListOfMaterialTestDetails.push({ ...test, IsDeleted: true });
              } else {
                newListOfMaterialTestDetails.push({ ...test });
              }
            } else {
              newListOfMaterialTestDetails.push({ ...test });
            }
          }
        } else {
          if (test.MixDesignTestMasterIDEncrypted != mixDesignTestID) {
            if (test.TestMasterIDEncrypted == mixDesignTestID) {
              if (deleteMixDesignTestAlso == false) {
                newListOfMaterialTestDetails.push({ ...test });
              }
            } else {
              newListOfMaterialTestDetails.push({ ...test });
            }
          }
        }
      })
    );
    formikAmendment.setFieldValue(
      "ListOfAmendmentMaterialTestDetails",
      newListOfMaterialTestDetails
    );
  };

  const [showDefineMoreRatesModal, setShowDefineMoreRatesModal] =
    useState(false);

  const getInwardMaterialDefineMoreRatesList = async (
    inwardMaterialTestDetailID,
    testMasterID,
    mIndex,
    tIndex
  ) => {
    setIsLoading(true);
    await post(POST_GetTestWiseDefineMoreRatesList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TestMasterIDEncrypted: testMasterID,
      InwardMaterialTestDetailIDEncrypted: inwardMaterialTestDetailID,
      CustomerIDEncrypted: CustomerIDEncrypted,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikAmendment.setFieldValue(
            `ListOfAmendmentMaterialTestDetails[${tIndex}].ListOfDefineMoreRates`,
            response?.ListOfDefineMoreRates?.filter((x) => x.IsSelected == true)
              ?.length > 0
              ? response?.ListOfDefineMoreRates
              : response?.ListOfDefineMoreRates?.map((para) => ({
                  ...para,
                  IsSelected: para?.IsSelected,
                }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOnClickDefineMoreRatesSelection = async (
    indxTest,
    itemTest,
    testmasterid,
    TestDetailID
  ) => {
    formikDefineMoreRates.setFieldValue(
      "MoreTestRatesList",
      itemTest?.ListOfDefineMoreRates
    );

    formikDefineMoreRates.setFieldValue("testIndexPara", indxTest);
    formikDefineMoreRates.setFieldValue("testmasterid", testmasterid);
    formikDefineMoreRates.setFieldValue("TestDetailID", TestDetailID);

    setShowDefineMoreRatesModal(true);
  };

  const validationSchemaDefineMoreRates = Yup.object().shape({});

  const formikDefineMoreRates = useFormik({
    validationSchema: validationSchemaDefineMoreRates,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitDefineMoreRates(values, formikHelpers),
    initialValues: {
      MoreTestRatesList: [],
      testIndexPara: 0,
      FristtimeClickbtn: false,
      testmasterid: "",
      TestDetailID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { MoreTestRatesList },
  } = formikDefineMoreRates;

  const handleValidSubmitDefineMoreRates = (values) => {
    formikAmendment.setFieldValue(
      `ListOfAmendmentMaterialTestDetails[${values?.testIndexPara}].ListOfDefineMoreRates`,
      values?.MoreTestRatesList?.map((itemsubRate) => ({
        InwardMaterialTestDetailIDEncrypted: values?.TestDetailID,
        TestMasterIDEncrypted: values?.testmasterid,
        RateType: itemsubRate?.RateType,
        RateTypeName: itemsubRate?.RateTypeName,
        IsSelected: itemsubRate?.IsSelected,
      }))
    );
    setShowDefineMoreRatesModal(false);
  };

  const [
    showInwardTestDefineMoreRateModal,
    setShowInwardTestDefineMoreRateModal,
  ] = useState(false);
  const [
    showInwardTestDefineMoreRateSelectionModal,
    setShowInwardTestDefineMoreRateSelectionModal,
  ] = useState(false);

  const validationSchemaInwardTestDefineMoreRates = Yup.object().shape({});

  const formikInwardTestDefineMoreRates = useFormik({
    validationSchema: validationSchemaInwardTestDefineMoreRates,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitInwardTestDefineMoreRates(values, formikHelpers),
    initialValues: {
      InwardIDEncrypted: "",
      InwardNo: "",
      InwardDate: "",
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectName: "",
      InwardMaterialList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikInwardTestDefineMoreRates;

  const handleValidSubmitInwardTestDefineMoreRates = async (values) => {
    setIsLoading(true);
    await post(POST_ControlCenterInwardTestDefineMoreRatesSave, {
      InwardIDEncrypted: values?.InwardIDEncrypted,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      InwardMaterialList: values?.InwardMaterialList,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setShowInwardTestDefineMoreRateModal(false);
        } else {
          errorMessage("Something went wrong!");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const InwardTestDefineMoreRate = async (inwardID, inwardMaterialID) => {
    setIsLoading(true);
    await post(POST_ControlCenterGetInwardTestDefineMoreRatesList, {
      InwardIDEncrypted: inwardID,
      InwardMaterialIDEncrypted: inwardMaterialID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikInwardTestDefineMoreRates.setValues({ ...response });
          setShowInwardTestDefineMoreRateModal(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchemaInwardTestDefineMoreRateSelection = Yup.object().shape(
    {}
  );

  const formikInwardTestDefineMoreRateSelection = useFormik({
    validationSchema: validationSchemaInwardTestDefineMoreRateSelection,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitDefineMoreRatesSelection(values, formikHelpers),
    initialValues: {
      MoreTestRateSelectionList: [],
      tcIndex: 0,
      testIndex: 0,
      testmasterid: "",
      TestDetailID: "",
      TestName: "",
      BasedOnMeasurementValue: "",
      BasedOnHrsValue: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { MoreTestRateSelectionList },
  } = formikInwardTestDefineMoreRateSelection;

  const handleOnClickInwardTestDefineMoreRatesSelection = async (
    tcIndex,
    testIndex,
    RateTypeList,
    testmasterid,
    TestDetailID,
    testName
  ) => {
    formikInwardTestDefineMoreRateSelection.setFieldValue(
      "MoreTestRateSelectionList",
      RateTypeList
    );

    formikInwardTestDefineMoreRateSelection.setFieldValue("tcIndex", tcIndex);
    formikInwardTestDefineMoreRateSelection.setFieldValue(
      "testIndex",
      testIndex
    );
    formikInwardTestDefineMoreRateSelection.setFieldValue(
      "testmasterid",
      testmasterid
    );
    formikInwardTestDefineMoreRateSelection.setFieldValue("TestName", testName);

    formikInwardTestDefineMoreRateSelection.setFieldValue(
      "TestDetailID",
      TestDetailID
    );

    const measurement = RateTypeList?.filter(
      (e) =>
        e?.IsSelected === true &&
        e?.InwardMaterialTestDetailIDEncrypted === TestDetailID &&
        e?.RateType === 4
    )?.[0];

    const hrs = RateTypeList?.filter(
      (e) =>
        e?.IsSelected === true &&
        e?.InwardMaterialTestDetailIDEncrypted === TestDetailID &&
        e?.RateType === 7
    )?.[0];

    formikInwardTestDefineMoreRateSelection.setFieldValue(
      "BasedOnMeasurementValue",
      measurement?.BasedOnMeasurementValue || ""
    );
    formikInwardTestDefineMoreRateSelection.setFieldValue(
      "BasedOnHrsValue",
      hrs?.BasedOnHrsValue || ""
    );

    setShowInwardTestDefineMoreRateSelectionModal(true);
  };

  const handleValidSubmitDefineMoreRatesSelection = (values) => {
    if (AuthUser?.Permissions?.Account == 1) {
      if (
        MoreTestRateSelectionList?.filter(
          (e) => e?.IsSelected == true && e?.RateType == 4 //Based On Measurement
        )?.length > 0
      ) {
        if (values?.BasedOnMeasurementValue == "") {
          formikInwardTestDefineMoreRateSelection.setFieldError(
            "BasedOnMeasurementValue",
            "Based On Measurement Value is required field..."
          );
          formikInwardTestDefineMoreRateSelection.setFieldTouched(
            "BasedOnMeasurementValue",
            true
          );
          return;
        }
      }

      if (
        MoreTestRateSelectionList?.filter(
          (e) => e?.IsSelected == true && e?.RateType == 7 //Based On Hrs
        )?.length > 0 &&
        values?.BasedOnHrsValue == ""
      ) {
        formikInwardTestDefineMoreRateSelection.setFieldError(
          "BasedOnHrsValue",
          "Based On HrsValue is required field..."
        );
        formikInwardTestDefineMoreRateSelection.setFieldTouched(
          "BasedOnHrsValue",
          true
        );
        return;
      }
    }

    formikInwardTestDefineMoreRates.setFieldValue(
      `InwardMaterialList[${values?.tcIndex}].TestDetailList[${values?.testIndex}].DefineMoreRateList`,
      values?.MoreTestRateSelectionList?.map((itemsubRate) => ({
        InwardMaterialTestDetailIDEncrypted: values?.TestDetailID,
        TestMasterIDEncrypted: values?.testmasterid,
        RateType: itemsubRate?.RateType,
        RateTypeName: itemsubRate?.RateTypeName,
        IsSelected: itemsubRate?.IsSelected,
        BasedOnMeasurementValue:
          itemsubRate?.RateType == 4
            ? values?.BasedOnMeasurementValue.toString()
            : "",
        BasedOnHrsValue:
          itemsubRate?.RateType == 7 ? values?.BasedOnHrsValue.toString() : "",
      }))
    );
    setShowInwardTestDefineMoreRateSelectionModal(false);
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Sample Preparation & Testing</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i
                      className="fa fa-window-restore me-2"
                      aria-hidden="true"
                    ></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {/* <Link
                    className="btn btn-primary light btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link> */}
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 88 && x?.IsAdd)
                    ?.length > 0 ? (
                    <Link
                      to="/add-sample-preparation-and-testing"
                      // className="btn btn-primary btn-sm"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add Sample
                      Preparation & Testing
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter && (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Inward No"
                              name="InwardNo"
                              placeholder={"Search Inward No"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <label>Inward Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              loadOptionsFn={loadOptionsCustomer}
                              component={CustomSelectAsync}
                              title={CustomerName}
                              labelFieldName="CustomerName"
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Project"
                              name="CustomerProjectIDEncrypted"
                              placeholder={"Select Project"}
                              options={customerProjectOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                              menuStyles={{
                                position: "absolute",
                                right: 0,
                              }}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Work Detail"
                              name="ProjectDetails"
                              placeholder={"Search Work Detail"}
                              component={CustomInput}
                              maxLength={2000}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Letter Ref No"
                              name="LetterRefNo"
                              placeholder={"Search Letter Ref No"}
                              component={CustomInput}
                            />
                          </Col>
                        </Row>
                        <hr className="mt-1 mb-1"></hr>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="TC No"
                              name="TCNo"
                              placeholder={"Search TC No"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Sample Detail"
                              name="SampleDetail"
                              placeholder={"Search Sample Detail"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="ULR No"
                              name="ULRNo"
                              placeholder={"Search ULR No"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Department"
                              name="DepartmentIDEncrypted"
                              placeholder={"Select Department"}
                              options={departmentOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Material Group"
                              name="ProductGroupIDEncrypted"
                              placeholder={"Select Material Group"}
                              options={productGroupOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Material Type"
                              name="MaterialTypeIDEncrypted"
                              placeholder={"Select Material Type"}
                              options={materialTypeOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Test"
                              name="TestMasterIDEncrypted"
                              placeholder={"Select Test"}
                              options={testOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <div className="mb-2">
                              <label className="mb-1">&nbsp;</label>
                              <div>
                                <button
                                  type="button"
                                  // className="btn btn-primary btn-sm mb-1"
                                  className="btn btn-primary btn-sm mb-1 me-2"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Search
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                )}
                <div className="d-flex">
                  <div style={{ width: showFilter ? "90%" : "100%" }}>
                    <div className="bootstrap-badge pt-2">
                      <label
                        className="me-1 badge-primary badge p-1"
                        style={{ color: "#ffffff", minWidth: "100px" }}
                      >
                        Inward : {TotalInward}
                      </label>
                      <label
                        className="me-1 badge-info badge p-1"
                        style={{ color: "#ffffff", minWidth: "100px" }}
                      >
                        Draft : {TotalDraft}
                      </label>
                      <label
                        className="me-1 badge-success badge p-1"
                        style={{ color: "#ffffff", minWidth: "100px" }}
                      >
                        TC : {TotalTC}
                      </label>
                      <label
                        className="me-1 badge-dark badge p-1"
                        style={{ color: "#ffffff", minWidth: "100px" }}
                      >
                        Test : {TotalTest}
                      </label>
                      <label
                        className="me-1 badge-warning badge p-1"
                        style={{ color: "#ffffff", minWidth: "100px" }}
                      >
                        Customer : {TotalCustomer}
                      </label>
                      {/* <label
                        className="me-1 badge-warning badge p-1"
                        style={{ color: "#ffffff", minWidth: "100px" }}
                      >
                        Cancelled TC : {TotalCancelledTC}
                      </label> */}
                      <label
                        className="me-1 badge-danger badge p-1"
                        style={{ color: "#ffffff", minWidth: "100px" }}
                      >
                        Cancelled Test : {TotalCancelledTest}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <div
                    id="SamplePreparationAndTesting-tbl_wrapper"
                    className="dataTables_wrapper no-footer mt-1"
                  >
                    <table
                      id="SamplePreparationAndTesting-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              width: "6%",
                            }}
                          ></th>
                          <th
                            style={{
                              width: "12%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("InwardDate");
                            }}
                          >
                            Inward No | Date{" "}
                            <span className="ml-1">
                              {sortBy == "InwardDate" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          <th
                            style={{
                              width: "29%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("CustomerName");
                            }}
                          >
                            Customer{" "}
                            <span className="ml-1">
                              {sortBy == "CustomerName" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          <th
                            style={{
                              width: "30%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("ProjectName");
                            }}
                          >
                            Project{" "}
                            <span className="ml-1">
                              {sortBy == "ProjectName" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          <th
                            style={{
                              width: "10%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleClickSorting("LetterRefNo");
                            }}
                          >
                            Letter Ref No{" "}
                            <span className="ml-1">
                              {sortBy == "LetterRefNo" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          <th
                            style={{
                              width: "8%",
                            }}
                          ></th>
                        </tr>
                      </thead>
                      <tbody>
                        {controlCenterList?.length > 0 ? (
                          controlCenterList?.map((item, indx) => (
                            <>
                              <tr
                                // className={
                                //   item?.InwardCurrentStatus == 1
                                //     ? "inward-draft-bg"
                                //     : ""
                                // }
                                key={indx}
                              >
                                <td
                                  rowSpan={item.showDetail == true ? 4 : 3}
                                  style={{
                                    verticalAlign: "top",
                                    whiteSpace: "normal",
                                    minWidth: "90px",
                                  }}
                                  className="p-1 ps-0 pe-0"
                                >
                                  {AuthUser?.UserType !== 1 ||
                                  formsList?.filter(
                                    (x) => x?.FormID == 88 && x?.IsEdit
                                  )?.length > 0 ? (
                                    <Link
                                      to={
                                        item?.IsHold == true
                                          ? "#"
                                          : `/edit-sample-preparation-and-testing/${window.btoa(
                                              item.InwardIDEncrypted
                                            )}`
                                      }
                                      // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                      className="icon-box icon-box-md ms-1 mb-1"
                                      title="Edit"
                                      disabled={item?.IsHold}
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                  {item?.InwardCurrentStatus < 3 ? (
                                    <>
                                      {AuthUser?.UserType !== 1 ||
                                      formsList?.filter(
                                        (x) => x?.FormID == 88 && x?.IsDelete
                                      )?.length > 0 ? (
                                        <Link
                                          to="#"
                                          // className="icon-box icon-box-md bg-danger-light ms-1 mb-1"
                                          className="icon-box icon-box-md ms-1 mb-1"
                                          title="Delete"
                                          onClick={() => {
                                            if (item?.IsHold == false) {
                                              delete_Record(
                                                POST_MaterialInwardDelete,
                                                {
                                                  InwardIDEncrypted:
                                                    item.InwardIDEncrypted,
                                                  ModifiedByEncrypted:
                                                    AuthUser?.ReferenceIDEncrypt
                                                      ? AuthUser?.ReferenceIDEncrypt
                                                      : "0",
                                                },
                                                setIsLoading,
                                                fnCallback,
                                                item.InwardNo
                                              );
                                            }
                                          }}
                                          disabled={item?.IsHold}
                                        >
                                          {SVGICON.DeleteDanger}
                                        </Link>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {AuthUser?.UserType !== 1 ||
                                      formsList?.filter(
                                        (x) => x?.FormID == 88 && x?.IsRead
                                      )?.length > 0 ? (
                                        <Link
                                          className="icon-box icon-box-md ms-1 mb-1"
                                          title="View Sample Preparation & Testing"
                                          to={`/view-sample-preparation-and-testing/${window.btoa(
                                            item.InwardIDEncrypted
                                          )}`}
                                        >
                                          {SVGICON.View}
                                        </Link>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  )}

                                  {item?.InwardCurrentStatus > 1 ? (
                                    <>
                                      {item?.InwardCurrentStatus >= 4 ? (
                                        <>
                                          {/* <Link
                                          to="#"
                                          // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                          className="icon-box icon-box-md ms-1 mb-1"
                                          title="Sample Request Form"
                                          onClick={() => {
                                            SampleRequestFormDownload(
                                              item?.InwardIDEncrypted
                                            );
                                          }}
                                        >
                                          {SVGICON.NoteText}
                                        </Link> */}
                                          <Link
                                            to="#"
                                            // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                            className="icon-box icon-box-md ms-1 mb-1"
                                            title="Lab Form"
                                            onClick={() => {
                                              LabFormDownload(
                                                item?.InwardIDEncrypted
                                              );
                                            }}
                                          >
                                            {SVGICON.Reports}
                                          </Link>
                                        </>
                                      ) : (
                                        ""
                                      )}

                                      <Link
                                        to="#"
                                        // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                        className="icon-box icon-box-md ms-1 mb-1"
                                        title="Statistics"
                                        onClick={() => {
                                          getInwardStatistics(
                                            item?.InwardIDEncrypted
                                          );
                                        }}
                                      >
                                        {SVGICON.Project}
                                      </Link>
                                      <Link
                                        to="#"
                                        // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                        className="icon-box icon-box-md ms-1 mb-1"
                                        title="View Contact Persons"
                                        onClick={() => {
                                          ViewContactPerson(indx);
                                        }}
                                      >
                                        {SVGICON.ContactPerson}
                                      </Link>
                                      <Link
                                        to="#"
                                        // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                        className="icon-box icon-box-md ms-1 mb-1"
                                        title="Print Invoice"
                                        onClick={() => {
                                          if (item?.IsHold == false) {
                                            // window.open("", "_blank");
                                            infoMessage("Coming Soon...");
                                          }
                                        }}
                                        style={{ display: "none" }} //remove display:none after form developed
                                        disabled={item?.IsHold}
                                      >
                                        {SVGICON.Printer}
                                      </Link>
                                      <Link
                                        to="#"
                                        // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                        className="icon-box icon-box-md ms-1 mb-1"
                                        title="Send Invoice"
                                        onClick={() => {
                                          if (item?.IsHold == false) {
                                            openSendInvoiceDialog(
                                              item?.InwardIDEncrypted
                                            );
                                          }
                                        }}
                                        style={{ display: "none" }} //remove display:none after form developed
                                        disabled={item?.IsHold}
                                      >
                                        {SVGICON.SendEmail}
                                      </Link>
                                      {item?.ListOfInwardMaterials?.filter(
                                        (x) => x.TotalTestReportingDone > 0
                                      )?.length > 0 &&
                                        (AuthUser?.UserType !== 1 ||
                                          formsList?.filter(
                                            (x) =>
                                              x?.FormID == 88 &&
                                              (x?.IsAdd || x?.IsEdit)
                                          )?.length > 0) &&
                                        AuthUser?.Permissions?.UploadScanCopy ==
                                          1 &&
                                        item?.UploadScanCopyActionStatus >
                                          1 && (
                                          <Link
                                            to="#"
                                            // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                            className="icon-box icon-box-md ms-1 mb-1"
                                            title="Send Scan Copy"
                                            onClick={() => {
                                              if (item?.IsHold == false) {
                                                openSendScanCopyDialog(
                                                  item?.InwardIDEncrypted,
                                                  "",
                                                  item?.TCNos
                                                );
                                              }
                                            }}
                                            disabled={item?.IsHold}
                                          >
                                            {SVGICON.SendFile}
                                          </Link>
                                        )}

                                      {/* {item?.InwardCurrentStatus >= 4 &&
                                      (AuthUser?.UserType !== 1 ||
                                        formsList?.filter(
                                          (x) => x?.FormID == 88 && x?.IsAdd
                                        )?.length > 0) ? (
                                        <Link
                                          to={`/copy-material-inward/${window.btoa(
                                            item.InwardIDEncrypted
                                          )}`}
                                          // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                          className="icon-box icon-box-md ms-1 mb-1"
                                          title="Copy Inward"
                                        >
                                          {SVGICON.Copy}
                                        </Link>
                                      ) : (
                                        ""
                                      )} */}

                                      {/* {item?.InwardCurrentStatus >= 4 &&
                                      item?.InwardCurrentStatus != 6 &&
                                      item?.InwardCurrentStatus != 7 &&
                                      (AuthUser?.UserType !== 1 ||
                                        AuthUser?.Permissions?.IsInwardAdmin ==
                                          true) ? (
                                        <Link
                                          to={
                                            item?.IsHold == true
                                              ? "#"
                                              : `/edit-material-inward-header-detail/${window.btoa(
                                                  item.InwardIDEncrypted
                                                )}`
                                          }
                                          // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                          className="icon-box icon-box-md ms-1 mb-1"
                                          title="Edit Header Detail"
                                          disabled={item?.IsHold}
                                        >
                                          {SVGICON.EditSquareDanger}
                                        </Link>
                                      ) : (
                                        ""
                                      )} */}

                                      {/* {item?.InwardCurrentStatus >= 4 &&
                                      item?.InwardCurrentStatus != 6 &&
                                      item?.InwardCurrentStatus != 7 &&
                                      (AuthUser?.UserType !== 1 ||
                                        AuthUser?.Permissions?.IsInwardAdmin ==
                                          true) ? (
                                        <Link
                                          to="#"
                                          className="icon-box icon-box-md ms-1 mb-1"
                                          title={
                                            item?.IsHold == true
                                              ? "Unhold"
                                              : "Hold"
                                          }
                                          onClick={(e) => {
                                            holdUnholdInwardShowDialog(
                                              true,
                                              item?.InwardNo,
                                              item?.InwardIDEncrypted,
                                              "",
                                              "",
                                              !item?.IsHold
                                            );
                                          }}
                                        >
                                          {item?.IsHold == true
                                            ? SVGICON.Play
                                            : SVGICON.Pause}
                                        </Link>
                                      ) : (
                                        ""
                                      )} */}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                    verticalAlign: "top",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `controlCenterList[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {item.InwardNo ? (
                                    item.InwardNo
                                  ) : (
                                    <b>Draft Saved</b>
                                  )}{" "}
                                  {" | "} <label>{item.InwardDate}</label>
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                    verticalAlign: "top",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `controlCenterList[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {item.CustomerName}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                    verticalAlign: "top",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `controlCenterList[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {item.ProjectName}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                    verticalAlign: "top",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `controlCenterList[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {item.LetterRefNo} &nbsp;{" "}
                                  {item?.ListOfLetterRefDoc?.length > 0 ? (
                                    <Link
                                      to="#"
                                      title="Letter Ref Doc"
                                      className="text-primary"
                                      onClick={() => {
                                        getListOfLetterRefDoc(
                                          item?.ListOfLetterRefDoc
                                        );
                                      }}
                                    >
                                      View File
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                {item?.InwardCurrentStatus > 1 &&
                                item?.InwardCurrentStatus != 7 ? (
                                  <td
                                    rowSpan={3}
                                    style={{
                                      textAlign: "left",
                                      verticalAlign: "top",
                                      whiteSpace: "normal",
                                      minWidth: "100px",
                                    }}
                                    className="p-1 ps-0 pe-0"
                                  >
                                    {/* {AuthUser?.UserType !== 1 ||
                                    formsList?.filter(
                                      (x) => x?.FormID == 32 && x?.IsAdd
                                    )?.length > 0 ? (
                                      <Link
                                        to={
                                          item?.IsHold == true
                                            ? "#"
                                            : item?.AllowTCAllocationEdit == 0
                                            ? ""
                                            : `/tc-test-allocation/${window.btoa(
                                                item.InwardIDEncrypted
                                              )}`
                                        }
                                        className={`btn btn-outline-${
                                          item?.TCAllocationActionStatus == 2
                                            ? "success"
                                            : item?.TCAllocationActionStatus ==
                                              3
                                            ? "warning"
                                            : "danger"
                                        } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                        title={
                                          item?.AllowTCAllocationEdit == 0
                                            ? "TC Allocated"
                                            : "Go to TC Allocation"
                                        }
                                        style={{
                                          cursor:
                                            item?.AllowTCAllocationEdit == 0
                                              ? "not-allowed"
                                              : "pointer",
                                        }}
                                        disabled={item?.IsHold}
                                      >
                                        TC
                                      </Link>
                                    ) : (
                                      ""
                                    )} */}
                                    {/* {item?.TCAllocationActionStatus == 2 ? (
                                      <>
                                        {(AuthUser?.UserType !== 1 ||
                                          AuthUser?.Permissions
                                            ?.IsInwardApprover == true) &&
                                        AuthUser?.Permissions
                                          ?.ApprovalWorkflow == 1 &&
                                        AuthUser?.Permissions
                                          ?.InwardApprovalRequired == true ? (
                                          <Link
                                            to={
                                              item?.IsHold == true
                                                ? "#"
                                                : `/add-inward-approval/${window.btoa(
                                                    item.InwardIDEncrypted
                                                  )}`
                                            }
                                            className={`btn btn-outline-${
                                              item?.InwardApprovedActionStatus ==
                                              2
                                                ? "success"
                                                : item?.InwardApprovedActionStatus ==
                                                  3
                                                ? "warning"
                                                : "danger"
                                            } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                            title="Go to Inward Approved"
                                            disabled={item?.IsHold}
                                          >
                                            IA
                                          </Link>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )} */}
                                    {/* {item?.InwardApprovedActionStatus > 1 ? (
                                      <>
                                        {item?.JobWorkActionStatus > 0 &&
                                        AuthUser?.Permissions?.Machining == 1 &&
                                        (AuthUser?.UserType !== 1 ||
                                          formsList?.filter(
                                            (x) => x?.FormID == 28 && x?.IsAdd
                                          )?.length > 0) ? (
                                          <Link
                                            to={
                                              item?.IsHold == true
                                                ? "#"
                                                : "/add-machining-outward"
                                            }
                                            className={`btn btn-outline-${
                                              item?.JobWorkActionStatus == 2
                                                ? "success"
                                                : item?.JobWorkActionStatus == 3
                                                ? "warning"
                                                : "danger"
                                            } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                            title="Go to Machining Outward"
                                          >
                                            MO
                                          </Link>
                                        ) : (
                                          item?.JobWorkActionStatus > 0 &&
                                          AuthUser?.Permissions?.Machining ==
                                            1 && (
                                            <Link
                                              to="#"
                                              className={`btn btn-outline-${
                                                item?.JobWorkActionStatus == 2
                                                  ? "success"
                                                  : item?.JobWorkActionStatus ==
                                                    3
                                                  ? "warning"
                                                  : "danger"
                                              } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                              title="Go to Machining Outward"
                                              disabled={true}
                                            >
                                              MO
                                            </Link>
                                          )
                                        )}
                                        {item?.TestingActionStatus > 0 &&
                                        (AuthUser?.UserType !== 1 ||
                                          formsList?.filter(
                                            (x) => x?.FormID == 33 && x?.IsAdd
                                          )?.length > 0) ? (
                                          <Link
                                            to="#"
                                            className={`btn btn-outline-${
                                              item?.TestingActionStatus == 2
                                                ? "success"
                                                : item?.TestingActionStatus == 3
                                                ? "warning"
                                                : "danger"
                                            } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                            title="Go to Testing"
                                            onClick={(e) => {
                                              if (item?.IsHold == false) {
                                                openActionRedirectDialog(
                                                  "Testing",
                                                  indx
                                                );
                                              }
                                            }}
                                            disabled={item?.IsHold}
                                          >
                                            T
                                          </Link>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )} */}

                                    {item?.ReportingActionStatus > 0 &&
                                      (AuthUser?.UserType !== 1 ||
                                        formsList?.filter(
                                          (x) => x?.FormID == 34 && x?.IsAdd
                                        )?.length > 0) && (
                                        <Link
                                          to="#"
                                          className={`btn btn-outline-${
                                            item?.ReportingActionStatus == 2
                                              ? "success"
                                              : item?.ReportingActionStatus == 3
                                              ? "warning"
                                              : "danger"
                                          } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                          title="Go to Reporting"
                                          onClick={(e) => {
                                            if (item?.IsHold == false) {
                                              openActionRedirectDialog(
                                                "Reporting",
                                                indx
                                              );
                                            }
                                          }}
                                          disabled={item?.IsHold}
                                        >
                                          R
                                        </Link>
                                      )}
                                    {item?.ReportingActionStatus > 1 &&
                                      (AuthUser?.UserType !== 1 ||
                                        formsList?.filter(
                                          (x) => x?.FormID == 37 && x?.IsAdd
                                        )?.length > 0) &&
                                      AuthUser?.Permissions?.UploadScanCopy ==
                                        1 && (
                                        <Link
                                          to="#"
                                          className={`btn btn-outline-${
                                            item?.UploadScanCopyActionStatus ==
                                            2
                                              ? "success"
                                              : item?.UploadScanCopyActionStatus ==
                                                3
                                              ? "warning"
                                              : "danger"
                                          } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                          title="Go to Upload Scan Copy"
                                          onClick={(e) => {
                                            if (item?.IsHold == false) {
                                              openActionRedirectDialog(
                                                "Upload Scan Copy",
                                                indx
                                              );
                                            }
                                          }}
                                          disabled={item?.IsHold}
                                        >
                                          US
                                        </Link>
                                      )}
                                    <Link
                                      to="#"
                                      className={`btn btn-outline-${
                                        item?.PerformaInvoiceActionStatus == 2
                                          ? "success"
                                          : item?.PerformaInvoiceActionStatus ==
                                            3
                                          ? "warning"
                                          : "danger"
                                      } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                      title="Go to Proforma Inv"
                                      onClick={() => {
                                        infoMessage("Coming Soon...");
                                      }}
                                      style={{ display: "none" }} //remove display:none after form developed
                                      disabled={item?.IsHold}
                                    >
                                      PI
                                    </Link>
                                    <Link
                                      to="#"
                                      className={`btn btn-outline-${
                                        item?.InvoiceActionStatus == 2
                                          ? "success"
                                          : item?.InvoiceActionStatus == 3
                                          ? "warning"
                                          : "danger"
                                      } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                      title="Go to Invoice"
                                      onClick={() => {
                                        infoMessage("Coming Soon...");
                                      }}
                                      style={{ display: "none" }} //remove display:none after form developed
                                      disabled={item?.IsHold}
                                    >
                                      I
                                    </Link>
                                    {item?.ReportingActionStatus > 1 &&
                                    AuthUser?.Permissions?.DispatchReport ==
                                      1 &&
                                    (AuthUser?.UserType !== 1 ||
                                      formsList?.filter(
                                        (x) => x?.FormID == 35 && x?.IsAdd
                                      )?.length > 0) ? (
                                      <Link
                                        to={
                                          item?.IsHold == true
                                            ? "#"
                                            : `/add-report-dispatch/${window.btoa(
                                                item.InwardIDEncrypted
                                              )}/${window.btoa("0")}`
                                        }
                                        className={`btn btn-outline-${
                                          item?.DispatchReportActionStatus == 2
                                            ? "success"
                                            : item?.DispatchReportActionStatus ==
                                              3
                                            ? "warning"
                                            : "danger"
                                        } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                        title="Go to Dispatch Report"
                                        disabled={item?.IsHold}
                                        // onClick={(e) => {
                                        //   openActionRedirectDialog(
                                        //     "Dispatch Report",
                                        //     indx
                                        //   );
                                        // }}
                                      >
                                        DR
                                      </Link>
                                    ) : (
                                      ""
                                    )}
                                    {item?.TCAllocationActionStatus == 2 &&
                                    item?.DispatchMaterialActionStatus > 0 &&
                                    AuthUser?.Permissions?.DispatchMaterial ==
                                      1 &&
                                    (AuthUser?.UserType !== 1 ||
                                      formsList?.filter(
                                        (x) => x?.FormID == 36 && x?.IsAdd
                                      )?.length > 0) ? (
                                      <Link
                                        to={
                                          item?.IsHold == true
                                            ? "#"
                                            : `/add-material-dispatch/${window.btoa(
                                                item.InwardIDEncrypted
                                              )}/${window.btoa("0")}`
                                        }
                                        className={`btn btn-outline-${
                                          item?.DispatchMaterialActionStatus ==
                                          2
                                            ? "success"
                                            : item?.DispatchMaterialActionStatus ==
                                              3
                                            ? "warning"
                                            : "danger"
                                        } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                        title="Go to Dispatch Material"
                                        disabled={item?.IsHold}
                                      >
                                        DM
                                      </Link>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                ) : (
                                  <td
                                    rowSpan={3}
                                    style={{
                                      textAlign: "left",
                                      verticalAlign: "top",
                                      whiteSpace: "normal",
                                      minWidth: "100px",
                                    }}
                                    className="p-1 ps-0 pe-0"
                                  ></td>
                                )}
                              </tr>
                              <tr
                                key={`${indx}.1`}
                                // className={
                                //   item?.InwardCurrentStatus == 1
                                //     ? "inward-draft-bg"
                                //     : ""
                                // }
                              >
                                <td
                                  colSpan={4}
                                  style={{
                                    textAlign: "left",
                                    verticalAlign: "top",
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `controlCenterList[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="pt-0 pb-0"
                                >
                                  <div className="d-flex">
                                    <label
                                      className="text-secondary"
                                      style={{
                                        textAlign: "left",
                                        minWidth: "45px",
                                      }}
                                    >
                                      TC No: &nbsp;
                                    </label>
                                    <div style={{ textAlign: "left" }}>
                                      {item?.TCNos}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr
                                key={`${indx}.2`}
                                // className={
                                //   item?.InwardCurrentStatus == 1
                                //     ? "inward-draft-bg"
                                //     : ""
                                // }
                              >
                                <td
                                  colSpan={4}
                                  style={{
                                    textAlign: "left",
                                    verticalAlign: "top",
                                    whiteSpace: "normal",
                                    cursor: item.TCNos ? "pointer" : "default",
                                  }}
                                  onClick={() => {
                                    formik.setFieldValue(
                                      `controlCenterList[${indx}].showDetail`,
                                      item.TCNos ? !item.showDetail : false
                                    );
                                  }}
                                  className="pt-0 pb-0"
                                >
                                  <div className="d-flex">
                                    <label
                                      className="text-secondary"
                                      style={{
                                        // textAlign: "left",
                                        minWidth: "80px",
                                      }}
                                    >
                                      Work Detail: &nbsp;
                                    </label>
                                    <div style={{ textAlign: "left" }}>
                                      {item.ProjectDetails}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr
                                key={`${indx}.3`}
                                style={{
                                  display:
                                    item.showDetail == true ? "" : "none",
                                }}
                              >
                                <td
                                  colSpan={5}
                                  style={{
                                    textAlign: "left",
                                    verticalAlign: "top",
                                  }}
                                  className="p-0"
                                >
                                  <table
                                    className="table dataTable no-footer mb-0"
                                    style={{
                                      border: "1px solid var(--rgba-primary-3)",
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          style={{
                                            width: "6%",
                                          }}
                                          className="pt-1 pb-1 newPara"
                                        ></th>
                                        <th
                                          style={{ width: "14%" }}
                                          className="pt-1 pb-1 newPara"
                                        >
                                          TC No
                                        </th>
                                        <th
                                          style={{ width: "35%" }}
                                          className="pt-1 pb-1 newPara"
                                        >
                                          Sample Detail
                                        </th>
                                        <th
                                          style={{ width: "20%" }}
                                          className="pt-1 pb-1 newPara"
                                        >
                                          Condition
                                        </th>
                                        <th
                                          style={{ width: "20%" }}
                                          className="pt-1 pb-1 newPara"
                                        >
                                          Size
                                        </th>
                                        <th
                                          style={{
                                            width: "5%",
                                          }}
                                          className="pt-1 pb-1 newPara"
                                        ></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item?.ListOfInwardMaterials?.length >
                                      0 ? (
                                        item?.ListOfInwardMaterials?.map(
                                          (m, mIndex) => (
                                            <>
                                              <tr key={mIndex}>
                                                <td
                                                  // rowSpan={3}
                                                  rowSpan={2}
                                                  style={{
                                                    whiteSpace: "normal",
                                                    verticalAlign: "top",
                                                    minWidth: "65px",
                                                  }}
                                                  className="border-left-0 border-bottom-0 p-1 ps-0 pe-0"
                                                >
                                                  {/* {item?.IsTPIRequired ==
                                                    true &&
                                                    item?.InwardCurrentStatus >=
                                                      5 &&
                                                    item?.InwardCurrentStatus !=
                                                      7 &&
                                                    (AuthUser?.UserType !== 1 ||
                                                      formsList?.filter(
                                                        (x) =>
                                                          x?.FormID == 88 &&
                                                          (x?.IsAdd ||
                                                            x?.IsEdit)
                                                      )?.length > 0) && (
                                                      <Link
                                                        to="#"
                                                        // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                                        className="icon-box icon-box-md ms-1 mb-1"
                                                        title="TPI Visit"
                                                        onClick={(e) => {
                                                          if (
                                                            item?.IsHold ==
                                                            false
                                                          ) {
                                                            getTPIVisitDetails(
                                                              item?.InwardIDEncrypted
                                                            );
                                                          }
                                                        }}
                                                        disabled={item?.IsHold}
                                                      >
                                                        {SVGICON.ThirdParty}
                                                      </Link>
                                                    )} */}
                                                  {m?.tcTestingActionStatus >
                                                    1 &&
                                                    (AuthUser?.UserType !== 1 ||
                                                      formsList?.filter(
                                                        (x) =>
                                                          x?.FormID == 88 &&
                                                          (x?.IsAdd ||
                                                            x?.IsEdit)
                                                      )?.length > 0) &&
                                                    AuthUser?.Permissions
                                                      ?.MachineMaintenance ==
                                                      1 &&
                                                    AuthUser?.Permissions
                                                      ?.Email == 1 && (
                                                      <Link
                                                        to="#"
                                                        // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                                        className="icon-box icon-box-md ms-1 mb-1"
                                                        title="Send Machine Certificate"
                                                        onClick={() => {
                                                          if (
                                                            m?.IsHold == false
                                                          ) {
                                                            openSendMachineCertificateDialog(
                                                              item?.InwardIDEncrypted,
                                                              m?.InwardMaterialIDEncrypted,
                                                              item?.InwardNo
                                                            );
                                                          }
                                                        }}
                                                        disabled={m?.IsHold}
                                                      >
                                                        {SVGICON.Certificate}
                                                      </Link>
                                                    )}
                                                  {m?.tcUploadScanCopyActionStatus >
                                                    1 && (
                                                    <>
                                                      {AuthUser?.Permissions
                                                        ?.UploadScanCopy == 1 &&
                                                        m?.tcUploadScanCopyActionStatus >
                                                          1 &&
                                                        m?.ScanCopyFilePath && (
                                                          <Link
                                                            to="#"
                                                            // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                                            className="icon-box icon-box-md ms-1 mb-1"
                                                            title="Show Scan Copy"
                                                            onClick={() => {
                                                              if (
                                                                m?.IsHold ==
                                                                false
                                                              ) {
                                                                window.open(
                                                                  m?.ScanCopyFilePath,
                                                                  "_blank"
                                                                );
                                                              }
                                                            }}
                                                            disabled={m?.IsHold}
                                                          >
                                                            {SVGICON.PDF}
                                                          </Link>
                                                        )}
                                                      {(AuthUser?.UserType !==
                                                        1 ||
                                                        formsList?.filter(
                                                          (x) =>
                                                            x?.FormID == 88 &&
                                                            (x?.IsAdd ||
                                                              x?.IsEdit)
                                                        )?.length > 0) &&
                                                      AuthUser?.Permissions
                                                        ?.UploadScanCopy == 1 &&
                                                      m?.tcUploadScanCopyActionStatus >
                                                        1 ? (
                                                        <Link
                                                          to="#"
                                                          // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                                          className="icon-box icon-box-md ms-1 mb-1"
                                                          title="Send Scan Copy"
                                                          onClick={() => {
                                                            if (
                                                              m?.IsHold == false
                                                            ) {
                                                              openSendScanCopyDialog(
                                                                item?.InwardIDEncrypted,
                                                                m?.InwardMaterialIDEncrypted
                                                              );
                                                            }
                                                          }}
                                                          disabled={m?.IsHold}
                                                        >
                                                          {SVGICON.SendFile}
                                                        </Link>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </>
                                                  )}
                                                  {/* {m.tcReportingActionStatus >
                                                  1 ? (
                                                    <>
                                                      {AuthUser?.UserType !==
                                                        1 ||
                                                      formsList?.filter(
                                                        (x) =>
                                                          x?.FormID == 33 &&
                                                          x?.IsEdit
                                                      )?.length > 0 ? (
                                                        <Link
                                                          to="#"
                                                          // className={`btn btn-outline-primary btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                                          className="icon-box icon-box-md ms-1 mb-1"
                                                          title="Re-Test"
                                                          onClick={() => {
                                                            if (
                                                              m?.IsHold == false
                                                            ) {
                                                              getReTestTransactionDetails(
                                                                m.InwardMaterialIDEncrypted
                                                              );
                                                            }
                                                          }}
                                                          disabled={m?.IsHold}
                                                        >
                                                          {SVGICON.Repeat}
                                                        </Link>
                                                      ) : (
                                                        ""
                                                      )}
                                                      {AuthUser?.UserType !==
                                                        1 ||
                                                      formsList?.filter(
                                                        (x) =>
                                                          x?.FormID == 32 &&
                                                          x?.IsEdit
                                                      )?.length > 0 ? (
                                                        <Link
                                                          to="#"
                                                          // className={`btn btn-outline-primary btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                                          className="icon-box icon-box-md ms-1 mb-1"
                                                          title="Amendment"
                                                          onClick={() => {
                                                            if (
                                                              m?.IsHold == false
                                                            ) {
                                                              InwardMaterialAmendment(
                                                                m.InwardMaterialIDEncrypted
                                                              );
                                                            }
                                                          }}
                                                          disabled={m?.IsHold}
                                                        >
                                                          {SVGICON.Add}
                                                        </Link>
                                                      ) : (
                                                        ""
                                                      )}
                                                      {AuthUser?.UserType !==
                                                        1 ||
                                                      formsList?.filter(
                                                        (x) =>
                                                          x?.FormID == 88 &&
                                                          x?.IsEdit
                                                      )?.length > 0 ? (
                                                        <Link
                                                          to="#"
                                                          // className={`btn btn-outline-primary btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                                          className="icon-box icon-box-md ms-1 mb-1"
                                                          title="Revise"
                                                          onClick={() => {
                                                            if (
                                                              m?.IsHold == false
                                                            ) {
                                                              InwardMaterialRewise(
                                                                m?.InwardMaterialIDEncrypted
                                                              );
                                                            }
                                                          }}
                                                          disabled={m?.IsHold}
                                                        >
                                                          {SVGICON.Rewind}
                                                        </Link>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </>
                                                  ) : (
                                                    ""
                                                  )} */}

                                                  {item?.InwardApprovedActionStatus >
                                                    1 &&
                                                  (AuthUser?.UserType !== 1 ||
                                                    formsList?.filter(
                                                      (x) =>
                                                        x?.FormID == 88 &&
                                                        x?.IsEdit
                                                    )?.length > 0) ? (
                                                    <Link
                                                      to="#"
                                                      // className={`btn btn-outline-primary btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                                      className="icon-box icon-box-md ms-1 mb-1"
                                                      title="Cancel Test"
                                                      onClick={() => {
                                                        if (
                                                          m?.IsHold == false
                                                        ) {
                                                          InwardMaterialCancelTest(
                                                            m.InwardMaterialIDEncrypted
                                                          );
                                                        }
                                                      }}
                                                      disabled={m?.IsHold}
                                                    >
                                                      {/* CT */}
                                                      {SVGICON.Cancel}
                                                    </Link>
                                                  ) : (
                                                    ""
                                                  )}

                                                  {/* {item?.InwardCurrentStatus >=
                                                    4 &&
                                                  item?.InwardCurrentStatus !=
                                                    6 &&
                                                  item?.InwardCurrentStatus !=
                                                    7 &&
                                                  (AuthUser?.UserType !== 1 ||
                                                    AuthUser?.Permissions
                                                      ?.IsInwardAdmin ==
                                                      true) ? (
                                                    <Link
                                                      to="#"
                                                      // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                                      className="icon-box icon-box-md ms-1 mb-1"
                                                      title={
                                                        m?.IsHold == true
                                                          ? "Unhold"
                                                          : "Hold"
                                                      }
                                                      onClick={(e) => {
                                                        holdUnholdInwardShowDialog(
                                                          false,
                                                          item?.InwardNo,
                                                          item?.InwardIDEncrypted,
                                                          m?.TCNo,
                                                          m?.InwardMaterialIDEncrypted,
                                                          !m?.IsHold
                                                        );
                                                      }}
                                                    >
                                                      {m?.IsHold == true
                                                        ? SVGICON.Play
                                                        : SVGICON.Pause}
                                                    </Link>
                                                  ) : (
                                                    ""
                                                  )} */}

                                                  {AuthUser?.Permissions
                                                    ?.Account == 1 &&
                                                    item?.InwardCurrentStatus >=
                                                      5 &&
                                                    item?.InwardCurrentStatus !=
                                                      6 &&
                                                    item?.InwardCurrentStatus !=
                                                      7 &&
                                                    (AuthUser?.UserType !== 1 ||
                                                      formsList?.filter(
                                                        (x) =>
                                                          x?.FormID == 88 &&
                                                          x?.IsEdit
                                                      )?.length > 0) && (
                                                      <Link
                                                        to="#"
                                                        // className={`btn btn-outline-primary btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                                        className="icon-box icon-box-md ms-1 mb-1"
                                                        title="Define More Rate Selection"
                                                        onClick={() => {
                                                          if (
                                                            m?.IsHold == false
                                                          ) {
                                                            InwardTestDefineMoreRate(
                                                              item?.InwardIDEncrypted,
                                                              m?.InwardMaterialIDEncrypted
                                                            );
                                                          }
                                                        }}
                                                        disabled={m?.IsHold}
                                                      >
                                                        {SVGICON.Rates}
                                                      </Link>
                                                    )}
                                                </td>
                                                <td
                                                  style={{
                                                    whiteSpace: "normal",
                                                    verticalAlign: "top",
                                                  }}
                                                  className="border-bottom-0 pb-0"
                                                >
                                                  {m.TCNo}{" "}
                                                  {m?.IsHold ? (
                                                    <>
                                                      <b>[Hold]</b>
                                                      <OverlayTrigger
                                                        trigger={[
                                                          "hover",
                                                          "focus",
                                                        ]}
                                                        key={mIndex}
                                                        responsive={true}
                                                        overlay={
                                                          <Tooltip className="toltip-popover">
                                                            <strong className="p-1">
                                                              {m?.HoldReason}
                                                            </strong>
                                                          </Tooltip>
                                                        }
                                                      >
                                                        <span>
                                                          <i
                                                            className="fa fa-info-circle"
                                                            style={{
                                                              cursor: "pointer",
                                                              color: "#9698ab",
                                                            }}
                                                          ></i>
                                                        </span>
                                                      </OverlayTrigger>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                                <td
                                                  style={{
                                                    whiteSpace: "normal",
                                                    verticalAlign: "top",
                                                  }}
                                                  className="border-bottom-0 pb-0"
                                                >
                                                  {m.SampleDetail}
                                                </td>
                                                <td
                                                  style={{
                                                    whiteSpace: "normal",
                                                    verticalAlign: "top",
                                                  }}
                                                  className="border-bottom-0 pb-0"
                                                >
                                                  {m.Condition}
                                                </td>
                                                <td
                                                  style={{
                                                    whiteSpace: "normal",
                                                    verticalAlign: "top",
                                                  }}
                                                  className="border-bottom-0 pb-0"
                                                >
                                                  {m.Size}
                                                </td>
                                                <td
                                                  // rowSpan={3}
                                                  rowSpan={2}
                                                  style={{
                                                    textAlign: "left",
                                                    verticalAlign: "top",
                                                    whiteSpace: "normal",
                                                    minWidth: "128px",
                                                    borderRight:
                                                      "1px solid var(--rgba-primary-3)",
                                                  }}
                                                  className="border-bottom-0 p-1 ps-0 pe-0"
                                                >
                                                  {/* {item?.InwardApprovedActionStatus >
                                                    1 &&
                                                  m?.tcJobWorkActionStatus >
                                                    0 &&
                                                  AuthUser?.Permissions
                                                    ?.Machining == 1 &&
                                                  (AuthUser?.UserType !== 1 ||
                                                    formsList?.filter(
                                                      (x) =>
                                                        x?.FormID == 28 &&
                                                        x?.IsAdd
                                                    )?.length > 0) ? (
                                                    <Link
                                                      to={`${
                                                        m?.IsHold == false
                                                          ? "/add-machining-outward"
                                                          : "#"
                                                      }`}
                                                      className={`btn btn-outline-${
                                                        m?.tcJobWorkActionStatus ==
                                                        2
                                                          ? "success"
                                                          : m?.tcJobWorkActionStatus ==
                                                            3
                                                          ? "warning"
                                                          : "danger"
                                                      } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                                      title="Go to Machining Outward"
                                                      disabled={m?.IsHold}
                                                    >
                                                      MO
                                                    </Link>
                                                  ) : (
                                                    item?.InwardApprovedActionStatus >
                                                      1 &&
                                                    m?.tcJobWorkActionStatus >
                                                      0 &&
                                                    AuthUser?.Permissions
                                                      ?.Machining == 1 && (
                                                      <Link
                                                        to="#"
                                                        className={`btn btn-outline-${
                                                          m?.tcJobWorkActionStatus ==
                                                          2
                                                            ? "success"
                                                            : m?.tcJobWorkActionStatus ==
                                                              3
                                                            ? "warning"
                                                            : "danger"
                                                        } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                                        title="Go to Machining Outward"
                                                        disabled={true}
                                                      >
                                                        MO
                                                      </Link>
                                                    )
                                                  )} */}
                                                  {/* {item?.InwardApprovedActionStatus >
                                                  1 ? (
                                                    <>
                                                      {m?.tcTestingActionStatus >
                                                        0 &&
                                                      (AuthUser?.UserType !==
                                                        1 ||
                                                        formsList?.filter(
                                                          (x) =>
                                                            x?.FormID == 33 &&
                                                            x?.IsAdd
                                                        )?.length > 0) ? (
                                                        <Link
                                                          to={
                                                            m?.IsHold == true
                                                              ? "#"
                                                              : `/testing/${window.btoa(
                                                                  m.InwardMaterialIDEncrypted
                                                                )}`
                                                          }
                                                          className={`btn btn-outline-${
                                                            m?.tcTestingActionStatus ==
                                                            2
                                                              ? "success"
                                                              : m?.tcTestingActionStatus ==
                                                                3
                                                              ? "warning"
                                                              : "danger"
                                                          } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                                          title="Go to Testing"
                                                          disabled={m?.IsHold}
                                                        >
                                                          T
                                                        </Link>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </>
                                                  ) : (
                                                    ""
                                                  )} */}
                                                  {m?.tcReportingActionStatus >
                                                    0 &&
                                                    (AuthUser?.UserType !== 1 ||
                                                      formsList?.filter(
                                                        (x) =>
                                                          x?.FormID == 34 &&
                                                          x?.IsAdd
                                                      )?.length > 0) && (
                                                      <Link
                                                        to={
                                                          m?.IsHold == true
                                                            ? "#"
                                                            : `/add-report-printing/${window.btoa(
                                                                m.InwardMaterialIDEncrypted
                                                              )}`
                                                        }
                                                        className={`btn btn-outline-${
                                                          m?.tcReportingActionStatus ==
                                                          2
                                                            ? "success"
                                                            : m?.tcReportingActionStatus ==
                                                              3
                                                            ? "warning"
                                                            : "danger"
                                                        } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                                        title="Go to Reporting"
                                                        disabled={m?.IsHold}
                                                      >
                                                        R
                                                      </Link>
                                                    )}
                                                  {m?.tcReportingActionStatus >
                                                    1 &&
                                                    (AuthUser?.UserType !== 1 ||
                                                      formsList?.filter(
                                                        (x) =>
                                                          x?.FormID == 37 &&
                                                          x?.IsAdd
                                                      )?.length > 0) &&
                                                    AuthUser?.Permissions
                                                      ?.UploadScanCopy == 1 && (
                                                      <Link
                                                        to={
                                                          m?.IsHold == true
                                                            ? "#"
                                                            : `/edit-upload-scan-copy/${window.btoa(
                                                                item.InwardIDEncrypted
                                                              )}`
                                                        }
                                                        className={`btn btn-outline-${
                                                          m?.tcUploadScanCopyActionStatus ==
                                                          2
                                                            ? "success"
                                                            : m?.tcUploadScanCopyActionStatus ==
                                                              3
                                                            ? "warning"
                                                            : "danger"
                                                        } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                                        title="Go to Upload Scan Copy"
                                                        disabled={m?.IsHold}
                                                      >
                                                        US
                                                      </Link>
                                                    )}
                                                  {m?.tcReportingActionStatus >
                                                    1 &&
                                                  AuthUser?.Permissions
                                                    ?.DispatchReport == 1 &&
                                                  (AuthUser?.UserType !== 1 ||
                                                    formsList?.filter(
                                                      (x) =>
                                                        x?.FormID == 35 &&
                                                        x?.IsAdd
                                                    )?.length > 0) ? (
                                                    <Link
                                                      to={
                                                        m?.IsHold == true
                                                          ? "#"
                                                          : m?.ReportDispatchIDEncrypted
                                                          ? `/edit-report-dispatch/${window.btoa(
                                                              m?.ReportDispatchIDEncrypted
                                                            )}`
                                                          : `/add-report-dispatch/${window.btoa(
                                                              m?.InwardIDEncrypted
                                                            )}/${window.btoa(
                                                              m?.InwardMaterialIDEncrypted
                                                            )}`
                                                      }
                                                      className={`btn btn-outline-${
                                                        m?.tcDispatchReportActionStatus ==
                                                        2
                                                          ? "success"
                                                          : m?.tcDispatchReportActionStatus ==
                                                            3
                                                          ? "warning"
                                                          : "danger"
                                                      } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                                      title="Go to Dispatch Report"
                                                      disabled={m?.IsHold}
                                                    >
                                                      DR
                                                    </Link>
                                                  ) : (
                                                    ""
                                                  )}

                                                  {item?.TCAllocationActionStatus ==
                                                    2 &&
                                                  m?.tcDispatchMaterialActionStatus >
                                                    0 &&
                                                  AuthUser?.Permissions
                                                    ?.DispatchMaterial == 1 &&
                                                  (AuthUser?.UserType !== 1 ||
                                                    formsList?.filter(
                                                      (x) =>
                                                        x?.FormID == 36 &&
                                                        x?.IsAdd
                                                    )?.length > 0) ? (
                                                    <Link
                                                      to={
                                                        m?.IsHold == true
                                                          ? "#"
                                                          : m?.MaterialDispatchIDEncrypted
                                                          ? `/edit-material-dispatch/${window.btoa(
                                                              m?.MaterialDispatchIDEncrypted
                                                            )}`
                                                          : `/add-material-dispatch/${window.btoa(
                                                              m?.InwardIDEncrypted
                                                            )}/${window.btoa(
                                                              m?.InwardMaterialIDEncrypted
                                                            )}`
                                                      }
                                                      className={`btn btn-outline-${
                                                        m?.tcDispatchMaterialActionStatus ==
                                                        2
                                                          ? "success"
                                                          : m?.tcDispatchMaterialActionStatus ==
                                                            3
                                                          ? "warning"
                                                          : "danger"
                                                      } btn-xxs btn-w-fix ps-2 pe-2 ms-1 mb-1`}
                                                      title="Go to Dispatch Material"
                                                      disabled={m?.IsHold}
                                                    >
                                                      DM
                                                    </Link>
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                              </tr>
                                              <tr
                                                key={`${mIndex}.1`}
                                                style={{
                                                  display:
                                                    item.showDetail == true
                                                      ? ""
                                                      : "none",
                                                }}
                                              >
                                                <td
                                                  colSpan={4}
                                                  style={{
                                                    textAlign: "left",
                                                    whiteSpace: "normal",
                                                    verticalAlign: "top",
                                                  }}
                                                  className="pt-0 pb-0"
                                                >
                                                  <div className="d-flex">
                                                    <label
                                                      className="text-secondary"
                                                      style={{
                                                        // textAlign: "left",
                                                        minWidth: "70px",
                                                      }}
                                                    >
                                                      Test Name: &nbsp;
                                                    </label>
                                                    <div
                                                      style={{
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      {m.TestNames}
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            </>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={8}
                                            style={{
                                              textAlign: "left",
                                            }}
                                          >
                                            <div>{"No Record Found..."}</div>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr className="border-0 p-0">
                                <td colSpan={6} className="p-0">
                                  <hr className="m-0 customHR"></hr>
                                </td>
                              </tr>
                            </>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={6} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <hr className="mt-0 mb-1"></hr>
                    <div className="d-sm-flex text-center justify-content-between align-items-center">
                      <CustomSizePerPage
                        getData={getData}
                        currentSizePerPage={currentSizePerPage}
                      />
                      <div className="dataTables_info">
                        Showing{" "}
                        {recordCount > 0
                          ? (currentPage - 1) * currentSizePerPage + 1
                          : 0}{" "}
                        to{" "}
                        {recordCount > currentPage * currentSizePerPage
                          ? currentPage * currentSizePerPage
                          : recordCount}{" "}
                        of {recordCount} entries
                      </div>
                      <CustomPaginationButtons
                        totalPages={recordCount / currentSizePerPage}
                        currentPage={currentPage}
                        currentSizePerPage={currentSizePerPage}
                        getData={getData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
      <Modal
        className="fade"
        show={showInwardStatisticsModal}
        onHide={setShowInwardStatisticsModal}
        size="xl"
        dialogClassName="fullWidthModal"
      >
        <Spin size="large" spinning={isLoading} tip={"Loading..."}>
          <Modal.Header>
            <Modal.Title>Inward Statistics</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowInwardStatisticsModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div
              className="table-responsive active-projects style-1 shorting"
              style={{ maxHeight: "450px" }}
            >
              <div
                id="InwardStatistics-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="InwardStatistics-tbl"
                  className="table dataTable no-footer"
                >
                  <thead className="fixedheader">
                    <tr>
                      <th>Sr No.</th>
                      <th>Inward No</th>
                      <th>TC No</th>
                      <th>Test Name</th>
                      <th>Inward</th>
                      {/* {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                      AuthUser?.Permissions?.InwardApprovalRequired == true ? (
                        <th>Inward Approved</th>
                      ) : (
                        ""
                      )} */}
                      <th>Testing</th>
                      {/* {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                      AuthUser?.Permissions?.InwardApprovalRequired == true ? (
                        <th>Testing Approved</th>
                      ) : (
                        ""
                      )} */}
                      <th style={{ textAlign: "left" }}>Printing</th>
                      {/* <th>Proforma Invoice</th> */}
                      {/* <th>Invoice</th> */}
                      {AuthUser?.Permissions?.DispatchReport == 1 && (
                        <th style={{ textAlign: "left" }}>Dispatch Report</th>
                      )}
                      {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                        <th style={{ textAlign: "left" }}>Dispatch Material</th>
                      ) : (
                        ""
                      )}
                      {/* <th style={{ textAlign: "left" }}>
                        Re-Test / Amendment / Revise
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {listOfInwardStatistics?.length > 0 ? (
                      listOfInwardStatistics?.map((item, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{item?.InwardNo}</td>
                          <td>
                            {item?.TCNo}{" "}
                            {item?.IsHold ? (
                              <React.Fragment>
                                <b>[Hold]</b>
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  key={idx}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        {item?.HoldReason}
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    <i
                                      className="fa fa-info-circle"
                                      style={{
                                        cursor: "pointer",
                                        color: "#9698ab",
                                      }}
                                    ></i>
                                  </span>
                                </OverlayTrigger>
                              </React.Fragment>
                            ) : (
                              ""
                            )}
                          </td>
                          <td>
                            {item?.ListOfTests?.map((t) => (
                              <>
                                {t.TestName}
                                <br></br>
                              </>
                            ))}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item?.IsInwardDone ? (
                              <span style={{ color: "green" }}>
                                Done {" on "}
                                {item?.InwardDoneDate}
                                {" by "} {item?.InwardDoneBy}
                              </span>
                            ) : (
                              <span style={{ color: "red" }}>Pending</span>
                            )}
                          </td>
                          {/* {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                          AuthUser?.Permissions?.InwardApprovalRequired ==
                            true ? (
                            <td style={{ textAlign: "center" }}>
                              {item?.IsInwardApproved ? (
                                <span style={{ color: "green" }}>
                                  Done {" on "}
                                  {item?.InwardApprovedDate}
                                  {" by "} {item?.InwardApprovedBy}
                                </span>
                              ) : (
                                <span style={{ color: "red" }}>
                                  {item?.InwardCurrentStatus == 6
                                    ? "Revise & Rectify"
                                    : item?.InwardCurrentStatus == 7
                                    ? "Rejected"
                                    : "Pending"}
                                </span>
                              )}
                            </td>
                          ) : (
                            ""
                          )} */}
                          <td>
                            {item?.ListOfTests?.map((t, tIdx) => (
                              <React.Fragment key={`${tIdx}_t`}>
                                {t?.TestName} {" - "}
                                {t?.IsCancel == true ? (
                                  <span style={{ color: "red" }}>
                                    Cancelled
                                  </span>
                                ) : t?.IsTestingDone ? (
                                  <span style={{ color: "green" }}>
                                    Done {" on "}
                                    {t?.TestingDoneDate}
                                    {" by "} {t?.TestingDoneBy}
                                  </span>
                                ) : (
                                  <span style={{ color: "red" }}>Pending</span>
                                )}
                                <br></br>
                              </React.Fragment>
                            ))}
                          </td>

                          {/* {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                          AuthUser?.Permissions?.InwardApprovalRequired ==
                            true ? (
                            <td>
                              {item?.ListOfTests?.map((t) => (
                                <>
                                  {t?.TestName} {" - "}
                                  {t?.IsCancel == true ? (
                                    <span style={{ color: "red" }}>
                                      Cancelled
                                    </span>
                                  ) : t?.IsTestingApproved ? (
                                    <span style={{ color: "green" }}>
                                      Done {" on "}
                                      {t?.TestingApprovedDate}
                                      {" by "} {t?.TestingApprovedBy}
                                    </span>
                                  ) : (
                                    <span style={{ color: "red" }}>
                                      Pending
                                    </span>
                                  )}
                                  <br></br>
                                </>
                              ))}
                            </td>
                          ) : (
                            ""
                          )} */}

                          <td style={{ textAlign: "left" }}>
                            {item?.IsPrintingDone ? (
                              <span style={{ color: "green" }}>
                                Done {" on "}
                                {item?.PrintingDoneDate}
                                {" by "} {item?.PrintingDoneBy}
                              </span>
                            ) : (
                              <span style={{ color: "red" }}>Pending</span>
                            )}
                          </td>
                          {/* <td style={{ textAlign: "center" }}>
                                {item?.IsPerformaInvoiceDone ? (
                                  <span style={{ color: "green" }}>Done</span>
                                ) : (
                                  <span style={{ color: "red" }}>Pending</span>
                                )}
                              </td> */}
                          {/* <td style={{ textAlign: "center" }}>
                                {item?.IsInvoiceDone ? (
                                  <span style={{ color: "green" }}>Done</span>
                                ) : (
                                  <span style={{ color: "red" }}>Pending</span>
                                )}
                              </td> */}
                          {AuthUser?.Permissions?.DispatchReport == 1 && (
                            <td style={{ textAlign: "left" }}>
                              {item?.IsReportDispatchDone ? (
                                <React.Fragment>
                                  <span style={{ color: "green" }}>
                                    Done {" on "}
                                    {item?.ReportDispatchDoneDate}
                                    {" by "} {item?.ReportDispatchDoneBy}
                                  </span>
                                  <br></br>
                                  {item?.CourierName}
                                  <br></br>
                                  {item?.CourierDispatchNo}
                                </React.Fragment>
                              ) : (
                                <span style={{ color: "red" }}>Pending</span>
                              )}
                            </td>
                          )}
                          {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                            <td style={{ textAlign: "center" }}>
                              {item?.IsMaterialDispatch ? (
                                <span style={{ color: "green" }}>
                                  Done {" on "}
                                  {item?.MaterialDispatchDoneDate}
                                  {" by "} {item?.MaterialDispatchDoneBy}
                                </span>
                              ) : (
                                <span style={{ color: "red" }}>Pending</span>
                              )}
                            </td>
                          ) : (
                            ""
                          )}

                          {/* <td style={{ textAlign: "left" }}>
                            {item?.ListOfReTests?.map((t) => (
                              <>
                                {t?.TestName} {" - "}
                                <span className="text-primary">
                                  Retest on {t?.RetestDate} by {t?.RetestBy}
                                </span>
                                <br></br>
                              </>
                            ))}
                            {item?.ListOfAmendmentTests?.map((t) => (
                              <>
                                {t?.TestName} {" - "}
                                <span className="text-primary">
                                  Amendment on {t?.AmendmentDate} by{" "}
                                  {t?.AmendmentBy}
                                </span>
                                <br></br>
                              </>
                            ))}
                            {item?.ListOfRewise?.map((t) => (
                              <>
                                {t?.RewiseNo} {" - "}
                                <span className="text-primary">
                                  Revise on {t?.RewiseDate} by {t?.RewiseBy}
                                </span>
                                <br></br>
                              </>
                            ))}
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={16}
                          style={{
                            textAlign: "left",
                          }}
                        >
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showContactPersonModal}
        onHide={setShowContactPersonModal}
        size="xl"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Contact Persons</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowContactPersonModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive active-projects style-1 shorting">
              <div
                id="ContactPersons-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="ContactPersons-tbl"
                  className="table dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Contact Person</th>
                      <th>Designation</th>
                      <th>Mobile No</th>
                      <th>Telephone No</th>
                      <th style={{ textAlign: "left" }}>Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listOfContactPerson?.length > 0 ? (
                      listOfContactPerson?.map((item, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{item?.ContactPerson}</td>
                          <td>{item?.Designation}</td>
                          <td>{item?.MobileNo}</td>
                          <td>{item?.TelephoneNo}</td>
                          <td style={{ textAlign: "left" }}>{item?.EmailID}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: "left",
                          }}
                        >
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showSendScanCopyModal}
        onHide={setShowSendScanCopyModal}
        size="xl"
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikSendScanCopy}>
            <Form onSubmit={formikSendScanCopy.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Scan Copy Email</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowSendScanCopyModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                {AuthUser?.IsUploadScanCopyEmailSetup == false && (
                  <div className="text-danger mb-2">
                    Note: In Application setup - Upload Scan Copy Mail Setting
                    is pending. So user wan't be able to send emails.
                  </div>
                )}
                <div className="d-flex justify-content-between mb-2">
                  <h5 className="mb-0">Project Contact Person</h5>
                </div>
                <div className="table-responsive active-projects style-1 shorting">
                  <div
                    id="ProjectContactPersons-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="ProjectContactPersons-tbl"
                      className="table dataTable no-footer"
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "3%" }}></th>
                          <th style={{ width: "3%" }}></th>
                          <th style={{ width: "14%" }}>Mode Type</th>
                          <th style={{ width: "15%" }}>Customer Name</th>
                          <th style={{ width: "20%" }}>Contact Person</th>
                          <th style={{ width: "15%" }}>Designation</th>
                          <th style={{ width: "15%" }}>Mobile No</th>
                          <th style={{ width: "15%", textAlign: "left" }}>
                            Email
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {sscListOfProjectContactPerson?.length > 0 ? (
                          sscListOfProjectContactPerson?.map((item, idx) => (
                            <tr key={idx}>
                              <td>{idx + 1}</td>
                              <td>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="checkIsSelectedPCP"
                                  checked={item?.IsSelected}
                                  onChange={() => {
                                    formikSendScanCopy.setFieldValue(
                                      `sscListOfProjectContactPerson[${idx}].IsSelected`,
                                      !item?.IsSelected
                                    );
                                  }}
                                  style={{ cursor: "pointer" }}
                                ></input>
                              </td>
                              <td>{item?.ModeType}</td>
                              <td>{item?.CustomerName}</td>
                              <td>{item?.ContactPerson}</td>
                              <td>{item?.Designation}</td>
                              <td>{item?.MobileNo}</td>
                              <td style={{ textAlign: "left" }}>
                                {item?.EmailID}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={8}
                              style={{
                                textAlign: "left",
                              }}
                            >
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <Row>
                  <Col lg={12}>
                    <hr className="mt-1 mb-1"></hr>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Customer Contact Person</h5>
                    </div>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="CustomerContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="CustomerContactPersons-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "20%" }}>Customer Name</th>
                              <th style={{ width: "24%" }}>Contact Person</th>
                              <th style={{ width: "20%" }}>Designation</th>
                              <th style={{ width: "15%" }}>Mobile No</th>
                              <th style={{ width: "15%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {sscListOfCustomerContactPerson?.length > 0 ? (
                              sscListOfCustomerContactPerson?.map(
                                (item, idx) => (
                                  <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedPCP"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendScanCopy.setFieldValue(
                                            `sscListOfCustomerContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={7}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Customer"
                      name="sscCustomerIDEncrypted"
                      placeholder={"Select Customer"}
                      loadOptionsFn={loadOptionsCustomer_SSC}
                      component={CustomSelectAsync}
                      title={sscCustomerName}
                      labelFieldName="sscCustomerName"
                      menuPosition="fixed"
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Contact Person"
                      name="sscCustomerContactPersonIDEncrypted"
                      placeholder={"Select Contact Person"}
                      options={sscContactPersonOptions}
                      component={CustomSelect}
                      menuPosition="fixed"
                      onChange={(e) => {
                        formikSendScanCopy.setFieldValue(
                          "sscCustomerContactPersonIDEncrypted",
                          e?.value ?? ""
                        );
                        formikSendScanCopy.setFieldValue(
                          "sscContactPerson",
                          e?.label ?? ""
                        );
                        formikSendScanCopy.setFieldValue(
                          "sscDesignation",
                          e?.Designation ?? ""
                        );
                        formikSendScanCopy.setFieldValue(
                          "sscMobileNo",
                          e?.MobileNo ?? ""
                        );
                        formikSendScanCopy.setFieldValue(
                          "sscEmailID",
                          e?.EmailID ?? ""
                        );
                        formikSendScanCopy.setFieldValue(
                          "sscContactPersonID",
                          e?.ContactPersonID ?? ""
                        );
                      }}
                    />
                  </Col>
                  <Col lg={3}>
                    <div className="mb-2">
                      <label className="mb-1">&nbsp;</label>
                      <div>
                        <button
                          type="button"
                          // className="btn btn-primary btn-sm "
                          className="btn btn-outline-primary btn-sm"
                          onClick={(e) => {
                            addAdditionalContactPerson_SSC();
                          }}
                        >
                          + Add
                        </button>
                      </div>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="AdditionalContactPerson-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="AdditionalContactPerson-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "24%" }}>Customer Name</th>
                              <th style={{ width: "20%" }}>Contact Person</th>
                              <th style={{ width: "20%" }}>Designation</th>
                              <th style={{ width: "15%" }}>Mobile No</th>
                              <th style={{ width: "15%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {sscListOfAdditionalContactPerson?.length > 0 ? (
                              sscListOfAdditionalContactPerson?.map(
                                (item, idx) => (
                                  <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedACP"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendScanCopy.setFieldValue(
                                            `sscListOfAdditionalContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={7}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <Field
                      label="Additional Email"
                      name="sscAdditionalEmailID"
                      placeholder={"Enter Additional Email"}
                      component={CustomInput}
                    />
                  </Col>
                  <Col lg={6}>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="LetterRefDoc-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="LetterRefDoc-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "5%" }}></th>
                              <th style={{ width: "5%" }}></th>
                              <th style={{ width: "90%", textAlign: "left" }}>
                                Letter Ref Doc
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {sscListOfLetterRefDoc?.length > 0 ? (
                              sscListOfLetterRefDoc?.map((item, idx) => (
                                <tr key={idx}>
                                  <td>{idx + 1}</td>
                                  <td>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="checkIsSelectedPCP"
                                      checked={item?.IsSelected}
                                      onChange={() => {
                                        formikSendScanCopy.setFieldValue(
                                          `sscListOfLetterRefDoc[${idx}].IsSelected`,
                                          !item?.IsSelected
                                        );
                                      }}
                                      style={{ cursor: "pointer" }}
                                    ></input>
                                  </td>
                                  <td style={{ textAlign: "left" }}>
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="View"
                                      onClick={() => {
                                        window.open(
                                          item?.LetterRefImageFilePath
                                        );
                                      }}
                                    >
                                      <i className="fa fa-eye" />
                                    </Link>
                                    &nbsp;{item.LetterRefImageFileName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={3}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  // variant="primary"
                  variant="primary btn-sm"
                  type="submit"
                >
                  <i className="fa fa-envelope"></i> Send Mail
                </Button>
                <Button
                  // variant="secondary light"
                  variant="danger btn-sm"
                  onClick={() => setShowSendScanCopyModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showSendInvoiceModal}
        onHide={setShowSendInvoiceModal}
        size="xl"
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikSendInvoice}>
            <Form onSubmit={formikSendInvoice.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Invoice Email</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowSendInvoiceModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={9}>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="sInvProjectContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="sInvProjectContactPersons-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th></th>
                              <th></th>
                              <th>Contact Person</th>
                              <th>Designation</th>
                              <th>Mobile No</th>
                              <th style={{ textAlign: "left" }}>Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sInvListOfProjectContactPerson?.length > 0 ? (
                              sInvListOfProjectContactPerson?.map(
                                (item, idx) => (
                                  <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedPCPInv"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendInvoice.setFieldValue(
                                            `sInvListOfProjectContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={6}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="sInvLetterRefDoc-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="sInvLetterRefDoc-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th></th>
                              <th></th>
                              <th style={{ textAlign: "left" }}>
                                Letter Ref Doc
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {sInvListOfLetterRefDoc?.length > 0 ? (
                              sInvListOfLetterRefDoc?.map((item, idx) => (
                                <tr key={idx}>
                                  <td>{idx + 1}</td>
                                  <td>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="checkIsSelectedPCP"
                                      checked={item?.IsSelected}
                                      onChange={() => {
                                        formikSendInvoice.setFieldValue(
                                          `sInvListOfLetterRefDoc[${idx}].IsSelected`,
                                          !item?.IsSelected
                                        );
                                      }}
                                      style={{ cursor: "pointer" }}
                                    ></input>
                                  </td>
                                  <td style={{ textAlign: "left" }}>
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="View"
                                      onClick={() => {
                                        window.open(
                                          item?.LetterRefImageFilePath
                                        );
                                      }}
                                    >
                                      <i className="fa fa-eye" />
                                    </Link>
                                    &nbsp;{item.LetterRefImageFileName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={3}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Customer"
                      name="sInvCustomerIDEncrypted"
                      placeholder={"Select Customer"}
                      loadOptionsFn={loadOptionsCustomer_sInv}
                      component={CustomSelectAsync}
                      title={sInvCustomerName}
                      labelFieldName="sInvCustomerName"
                      menuPosition="fixed"
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Contact Person"
                      name="sInvCustomerContactPersonIDEncrypted"
                      placeholder={"Select Contact Person"}
                      options={sInvContactPersonOptions}
                      component={CustomSelect}
                      menuPosition="fixed"
                      onChange={(e) => {
                        formikSendInvoice.setFieldValue(
                          "sInvCustomerContactPersonIDEncrypted",
                          e?.value ?? ""
                        );
                        formikSendInvoice.setFieldValue(
                          "sInvContactPerson",
                          e?.label ?? ""
                        );
                        formikSendInvoice.setFieldValue(
                          "sInvDesignation",
                          e?.Designation ?? ""
                        );
                        formikSendInvoice.setFieldValue(
                          "sInvMobileNo",
                          e?.MobileNo ?? ""
                        );
                        formikSendInvoice.setFieldValue(
                          "sInvEmailID",
                          e?.EmailID ?? ""
                        );
                        formikSendInvoice.setFieldValue(
                          "sInvContactPersonID",
                          e?.ContactPersonID ?? ""
                        );
                      }}
                    />
                  </Col>
                  <Col lg={3}>
                    <div className="mb-2">
                      <label className="mb-1">&nbsp;</label>
                      <div>
                        <button
                          type="button"
                          // className="btn btn-primary btn-sm "
                          className="btn btn-outline-primary btn-sm "
                          onClick={(e) => {
                            addAdditionalContactPerson_sInv();
                          }}
                        >
                          + Add
                        </button>
                      </div>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="sInvAdditionalContactPerson-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="sInvAdditionalContactPerson-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th></th>
                              <th></th>
                              <th>Customer Name</th>
                              <th>Contact Person</th>
                              <th>Designation</th>
                              <th>Mobile No</th>
                              <th style={{ textAlign: "left" }}>Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sInvListOfAdditionalContactPerson?.length > 0 ? (
                              sInvListOfAdditionalContactPerson?.map(
                                (item, idx) => (
                                  <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedACP"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendInvoice.setFieldValue(
                                            `sInvListOfAdditionalContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={7}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <Field
                      label="Additional Email"
                      name="sInvAdditionalEmailID"
                      placeholder={"Enter Additional Email"}
                      component={CustomInput}
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  // variant="primary"
                  variant="primary btn-sm"
                  type="submit"
                >
                  <i className="fa fa-envelope"></i> Send Mail
                </Button>
                <Button
                  // variant="secondary light"
                  variant="danger btn-sm"
                  onClick={() => setShowSendInvoiceModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showSendMachineCertificateModal}
        onHide={setShowSendMachineCertificateModal}
        size="xl"
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikSendMachineCertificate}>
            <Form onSubmit={formikSendMachineCertificate.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Machine Certificate Email</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowSendMachineCertificateModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Customer Contact Persons</h5>
                    </div>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="smcCustomerContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="smcCustomerContactPersons-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "20%" }}>Customer Name</th>
                              <th style={{ width: "20%" }}>Contact Person</th>
                              <th style={{ width: "20%" }}>Designation</th>
                              <th style={{ width: "14%" }}>Mobile No</th>
                              <th style={{ width: "20%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {smcListOfCustomerContactPerson?.length > 0 ? (
                              smcListOfCustomerContactPerson?.map(
                                (item, idx) => (
                                  <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedPCPsmc"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendMachineCertificate.setFieldValue(
                                            `smcListOfCustomerContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={7}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <Col lg={3}>
                    <Field
                      label="Customer"
                      name="smcCustomerIDEncrypted"
                      placeholder={"Select Customer"}
                      loadOptionsFn={loadOptionsCustomer_smc}
                      component={CustomSelectAsync}
                      title={smcCustomerName}
                      labelFieldName="smcCustomerName"
                      menuPosition="fixed"
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Contact Person"
                      name="smcCustomerContactPersonIDEncrypted"
                      placeholder={"Select Contact Person"}
                      options={smcContactPersonOptions}
                      component={CustomSelect}
                      menuPosition="fixed"
                      onChange={(e) => {
                        formikSendMachineCertificate.setFieldValue(
                          "smcCustomerContactPersonIDEncrypted",
                          e?.value ?? ""
                        );
                        formikSendMachineCertificate.setFieldValue(
                          "smcContactPerson",
                          e?.label ?? ""
                        );
                        formikSendMachineCertificate.setFieldValue(
                          "smcDesignation",
                          e?.Designation ?? ""
                        );
                        formikSendMachineCertificate.setFieldValue(
                          "smcMobileNo",
                          e?.MobileNo ?? ""
                        );
                        formikSendMachineCertificate.setFieldValue(
                          "smcEmailID",
                          e?.EmailID ?? ""
                        );
                        formikSendMachineCertificate.setFieldValue(
                          "smcContactPersonID",
                          e?.ContactPersonID ?? ""
                        );
                      }}
                    />
                  </Col>
                  <Col lg={3}>
                    <div className="mb-2">
                      <label className="mb-1">&nbsp;</label>
                      <div>
                        <button
                          type="button"
                          // className="btn btn-primary btn-sm "
                          className="btn btn-outline-primary btn-sm"
                          onClick={(e) => {
                            addAdditionalContactPerson_smc();
                          }}
                        >
                          + Add
                        </button>
                      </div>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="smcAdditionalContactPerson-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="smcAdditionalContactPerson-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "24%" }}>Customer Name</th>
                              <th style={{ width: "20%" }}>Contact Person</th>
                              <th style={{ width: "20%" }}>Designation</th>
                              <th style={{ width: "15%" }}>Mobile No</th>
                              <th style={{ width: "15%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {smcListOfAdditionalContactPerson?.length > 0 ? (
                              smcListOfAdditionalContactPerson?.map(
                                (item, idx) => (
                                  <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedACPsmc"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendMachineCertificate.setFieldValue(
                                            `smcListOfAdditionalContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={7}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <Field
                      label="Additional Email"
                      name="smcAdditionalEmailID"
                      placeholder={"Enter Additional Email"}
                      component={CustomInput}
                    />
                  </Col>
                  <Col lg={6}>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="smcMachineCertificate-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="smcMachineCertificate-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "5%" }}>Sr No.</th>
                              <th style={{ width: "5%" }}></th>
                              <th style={{ width: "60%" }}>Machine Name</th>
                              <th style={{ width: "30%", textAlign: "left" }}>
                                Certificate
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {smcListOfMachineCertificate?.length > 0 ? (
                              smcListOfMachineCertificate?.map((item, idx) => (
                                <tr key={idx}>
                                  <td style={{ textAlign: "center" }}>
                                    {idx + 1}
                                  </td>
                                  <td>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="checkIsSelectedMCPsmc"
                                      checked={item?.IsSelected}
                                      onChange={() => {
                                        formikSendMachineCertificate.setFieldValue(
                                          `smcListOfMachineCertificate[${idx}].IsSelected`,
                                          !item?.IsSelected
                                        );
                                      }}
                                      style={{ cursor: "pointer" }}
                                    ></input>
                                  </td>
                                  <td>{item?.MachineName}</td>
                                  <td style={{ textAlign: "left" }}>
                                    <Link
                                      to="#"
                                      // className="icon-box icon-box-md bg-primary-light me-1"
                                      className="icon-box icon-box-md me-1"
                                      title="View"
                                      onClick={() => {
                                        window.open(
                                          item?.MachineCertificateFilePath
                                        );
                                      }}
                                    >
                                      <i className="fa fa-eye" />
                                    </Link>
                                    &nbsp;{item.MachineCertificateFileName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={4}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  // variant="primary"
                  variant="primary btn-sm"
                  type="submit"
                >
                  <i className="fa fa-envelope"></i> Send Mail
                </Button>
                <Button
                  // variant="secondary light"
                  variant="danger btn-sm"
                  onClick={() => setShowSendMachineCertificateModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showActionRedirectModal}
        onHide={setShowActionRedirectModal}
        size="xl"
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Go to {RedirectToForm}</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowActionRedirectModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive active-projects style-1 shorting">
              <div
                id="ActionRedirect-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table className="table dataTable no-footer mb-0">
                  <thead>
                    <tr>
                      <th
                        style={{
                          width: "2%",
                        }}
                        className="pt-1 pb-1 newPara"
                      ></th>
                      <th
                        style={{ width: "20%" }}
                        className="pt-1 pb-1 newPara"
                      >
                        TC No
                      </th>
                      <th
                        style={{ width: "38%" }}
                        className="pt-1 pb-1 newPara"
                      >
                        Sample Detail
                      </th>
                      <th
                        style={{ width: "20%" }}
                        className="pt-1 pb-1 newPara"
                      >
                        Condition
                      </th>
                      <th
                        style={{ width: "20%", textAlign: "left" }}
                        className="pt-1 pb-1 newPara"
                      >
                        Size
                      </th>

                      {/* <th
                            style={{ width: "16%" }}
                            className="pt-1 pb-1 newPara"
                          >
                            Department
                          </th> */}
                      {/* <th
                            style={{ width: "20%" }}
                            className="pt-1 pb-1 newPara"
                          >
                            Material Group
                          </th>
                          <th
                            style={{ width: "20%", textAlign: "left" }}
                            className="pt-1 pb-1 newPara"
                          >
                            Material Type
                          </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {ListOfRedirectTC?.length > 0 ? (
                      ListOfRedirectTC?.map((m, mIndex) => (
                        <React.Fragment key={mIndex}>
                          <tr key={mIndex}>
                            <td
                              rowSpan={2}
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                              // className="p-1 ps-0 pe-0"
                            >
                              {RedirectToForm == "Testing" &&
                              m?.tcTestingActionStatus < 0 ? (
                                ""
                              ) : (
                                <Link
                                  to={
                                    m?.IsHold == true
                                      ? "#"
                                      : RedirectToForm == "Testing"
                                      ? `/testing/${window.btoa(
                                          m.InwardMaterialIDEncrypted
                                        )}`
                                      : RedirectToForm == "Reporting"
                                      ? `/add-report-printing/${window.btoa(
                                          m.InwardMaterialIDEncrypted
                                        )}`
                                      : RedirectToForm == "Upload Scan Copy"
                                      ? `/edit-upload-scan-copy/${window.btoa(
                                          m.InwardIDEncrypted
                                        )}`
                                      : RedirectToForm == "Dispatch Report"
                                      ? "#"
                                      : "#"
                                  }
                                  // className="icon-box icon-box-md bg-primary-light ms-1 mb-1"
                                  className="icon-box icon-box-md ms-1 mb-1"
                                  title="Edit"
                                  onClick={() => {
                                    if (RedirectToForm == "Dispatch Report") {
                                      infoMessage("Coming Soon...");
                                    }
                                  }}
                                  disabled={m?.IsHold}
                                >
                                  {SVGICON.EditPrimary}
                                </Link>
                              )}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                              className="border-bottom-0 pb-0"
                            >
                              {m.TCNo}{" "}
                              {m?.IsHold ? (
                                <>
                                  <b>[Hold]</b>
                                  <OverlayTrigger
                                    trigger={["hover", "focus"]}
                                    key={mIndex}
                                    responsive={true}
                                    overlay={
                                      <Tooltip className="toltip-popover">
                                        <strong className="p-1">
                                          {m?.HoldReason}
                                        </strong>
                                      </Tooltip>
                                    }
                                  >
                                    <span>
                                      <i
                                        className="fa fa-info-circle"
                                        style={{
                                          cursor: "pointer",
                                          color: "#9698ab",
                                        }}
                                      ></i>
                                    </span>
                                  </OverlayTrigger>
                                </>
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                              className="border-bottom-0 pb-0"
                            >
                              {m.SampleDetail}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                              className="border-bottom-0 pb-0"
                            >
                              {m.Condition}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                                textAlign: "left",
                              }}
                              className="border-bottom-0 pb-0"
                            >
                              {m.Size}
                            </td>

                            {/* <td
                                  style={{
                                    whiteSpace: "normal",
                                    verticalAlign: "top",
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {m.DepartmentName}
                                </td> */}
                            {/* <td
                                  style={{
                                    whiteSpace: "normal",
                                    verticalAlign: "top",
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {m.ProductGroupName}
                                </td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                    verticalAlign: "top",
                                    textAlign: "left",
                                  }}
                                  className="border-bottom-0 pb-0"
                                >
                                  {m.MaterialTypeName}
                                </td> */}
                          </tr>
                          <tr key={`${mIndex}.1`}>
                            <td
                              colSpan={6}
                              style={{
                                textAlign: "left",
                              }}
                              className="p-0"
                            >
                              <table className="table dataTable no-footer mb-0">
                                <tbody>
                                  <tr>
                                    <td
                                      style={{
                                        whiteSpace: "normal",
                                        verticalAlign: "top",
                                      }}
                                      className="border-bottom-0 pt-2 pb-0"
                                    >
                                      <div className="d-flex">
                                        <label
                                          className="text-secondary"
                                          style={{
                                            textAlign: "left",
                                            minWidth: "70px",
                                          }}
                                        >
                                          Test Name: &nbsp;
                                        </label>
                                        <div
                                          style={{
                                            textAlign: "left",
                                          }}
                                        >
                                          {m.TestNames}
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                  {/* <tr>
                                        <td
                                          style={{
                                            whiteSpace: "normal",
                                            verticalAlign: "top",
                                            textAlign: "left",
                                          }}
                                          className="border-bottom-0 pt-0 pb-0"
                                        >
                                          <div className="d-flex">
                                            <label
                                              className="text-secondary"
                                              style={{
                                                textAlign: "left",
                                                minWidth: "90px",
                                              }}
                                            >
                                              Sample Detail: &nbsp;
                                            </label>
                                            <div
                                              style={{
                                                textAlign: "left",
                                              }}
                                            >
                                              {m.SampleDetail}
                                            </div>
                                          </div>
                                        </td>
                                      </tr> */}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={8}
                          style={{
                            textAlign: "left",
                          }}
                        >
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showTPIVisitModal}
        onHide={setShowTPIVisitModal}
        size="xl"
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikTPIVisit}>
            <Form onSubmit={formikTPIVisit.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Inward TPI Visit Details</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowTPIVisitModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <div className="card mb-2">
                  <div className="card-header ps-3 pt-1 pb-1">
                    Inward Information
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col lg={3}>
                        <label className="mb-1">
                          <span className="text-secondary">Inward No:</span>
                          &nbsp; &nbsp; {tpiVisit?.InwardNo}
                        </label>
                      </Col>
                      <Col lg={3}>
                        <label className="mb-1">
                          <span className="text-secondary">Date:</span>
                          &nbsp; &nbsp; {tpiVisit?.InwardDate}
                        </label>
                      </Col>
                      <Col lg={3}>
                        <label className="mb-1">
                          <span className="text-secondary">
                            Sample Received Via:
                          </span>
                          &nbsp; &nbsp;
                          {tpiVisit?.MaterialReceiveVia}
                        </label>
                      </Col>
                      {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                        <Col lg={3}>
                          <label className="mb-1">
                            <span className="text-secondary">
                              Sample Returnable:
                            </span>
                            &nbsp; &nbsp;
                            {tpiVisit?.IsMaterialReturnable == true
                              ? "Yes"
                              : "No"}
                          </label>
                        </Col>
                      ) : (
                        ""
                      )}
                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">Customer Name:</span>
                          &nbsp; &nbsp; {tpiVisit?.CustomerName}
                        </label>
                      </Col>
                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">
                            Receive Remarks:
                          </span>
                          &nbsp; &nbsp;
                          {tpiVisit?.ReceiveRemarks}
                        </label>
                      </Col>
                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">Work Detail:</span>
                          &nbsp; &nbsp; {tpiVisit?.ProjectDetails}
                        </label>
                      </Col>
                      <Col lg={2}>
                        <label className="mb-1">
                          <span className="text-secondary">TPI Required:</span>
                          &nbsp; &nbsp;
                          {tpiVisit?.IsTPIRequired == true ? "Yes" : "No"}
                        </label>
                      </Col>
                      <Col lg={4}>
                        <label className="mb-1">
                          <span className="text-secondary">Letter Ref No:</span>
                          &nbsp; &nbsp;
                          {tpiVisit?.LetterRefNo}
                        </label>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="card mb-0">
                  <div className="card-header ps-3 pt-1 pb-1">TPI Details</div>
                  <div className="card-body">
                    <Row>
                      <Col lg={3}>
                        <Field
                          label="TPI"
                          name="TPIIDEncrypted"
                          placeholder={"Select TPI"}
                          options={tpiCustomerOptions}
                          component={CustomSelect}
                          required
                          onChange={(e) => {
                            formikTPIVisit.setFieldValue(
                              "TPIIDEncrypted",
                              e?.value ?? ""
                            );
                            formikTPIVisit.setFieldValue(
                              "TPIName",
                              e?.label ?? ""
                            );
                            formikTPIVisit.setFieldValue(
                              "TPIContactPersonIDEncrypted",
                              ""
                            );
                            if (e) {
                              getTPIContactPersonDDL(
                                e?.value,
                                tpiVisit?.CustomerProjectIDEncrypted
                              );
                            } else {
                              setTPIContactPersonOptions([]);
                            }
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="TPI Contact Person"
                          name="TPIContactPersonIDEncrypted"
                          placeholder={"Select Contact Person"}
                          options={tpiContactPersonOptions}
                          component={CustomSelect}
                          required
                          onChange={(e) => {
                            formikTPIVisit.setFieldValue(
                              "TPIContactPersonIDEncrypted",
                              e?.value ?? ""
                            );
                            formikTPIVisit.setFieldValue(
                              "TPIContactPersonName",
                              e?.label ?? ""
                            );
                            formikTPIVisit.setFieldValue(
                              "TPIDesignation",
                              e?.Designation ?? ""
                            );
                            formikTPIVisit.setFieldValue(
                              "TPIMobileNo",
                              e?.MobileNo ?? ""
                            );
                            formikTPIVisit.setFieldValue(
                              "TPIEmailID",
                              e?.EmailID ?? ""
                            );
                          }}
                        />
                      </Col>
                      <Col lg={2}>
                        <Field
                          label="TPI Expected Date"
                          name="TPIExpectedDate"
                          placeholder={"Select Expected Date"}
                          component={CustomFlatpickr}
                          options={{
                            altInput: true,
                            altFormat: "j-M-Y",
                            dateFormat: "d-m-Y",
                            minDate: tpiVisit?.InwardDate
                              ? new Date(tpiVisit?.InwardDate)
                              : new Date(),
                            static: true, //to solve month dropdown not visible inside modal
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <div className="mb-2">
                          <label className="mb-1">&nbsp;</label>
                          <div>
                            <button
                              type="button"
                              // className="btn btn-primary btn-sm "
                              className="btn btn-outline-primary btn-sm"
                              title="Add New TPI"
                              onClick={(e) => {
                                addNewTPI();
                              }}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting mb-2">
                          <div
                            id="TPIdetail-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="TPIdetail-tbl"
                              className="table dataTable no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="2%"></th>
                                  <th width="31%">TPI</th>
                                  <th width="22%">TPI Contact Person</th>
                                  <th width="10%">TPI Expected Date</th>
                                  <th width="12%">Mobile No</th>
                                  <th width="22%" style={{ textAlign: "left" }}>
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfTPIDetails?.filter(
                                  (x) => x.IsDeleted == false
                                )?.length > 0 ? (
                                  ListOfTPIDetails?.map((item, indx) => (
                                    <tr
                                      key={indx}
                                      style={{
                                        display:
                                          item.IsDeleted == true ? "none" : "",
                                      }}
                                    >
                                      <td>
                                        <Link
                                          to="#"
                                          // className="icon-box icon-box-md bg-danger-light"
                                          className="icon-box icon-box-md"
                                          title="Delete"
                                          onClick={() => {
                                            //deleteTPI(indx);
                                            delete_RecordWithoutApi(
                                              deleteTPI,
                                              indx
                                            );
                                          }}
                                        >
                                          {SVGICON.DeleteDanger}
                                        </Link>
                                      </td>
                                      <td>{item.TPIName}</td>
                                      <td>
                                        {item.TPIContactPersonName} {" - "}
                                        {item.Designation}
                                      </td>
                                      <td>{item.displayTPIExpectedDate}</td>
                                      <td>{item?.MobileNo}</td>
                                      <td style={{ textAlign: "left" }}>
                                        {item?.EmailID}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={6}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  // variant="primary"
                  variant="primary btn-sm"
                  type="submit"
                >
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </Button>
                <Button
                  // variant="secondary light"
                  variant="danger btn-sm"
                  onClick={() => setShowTPIVisitModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showReTestTransactionDetailsModel}
        onHide={setShowReTestTransactionDetailsModel}
        size="xl"
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikReTestTransactionDetails}>
            <Form onSubmit={formikReTestTransactionDetails.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Re - Test</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowReTestTransactionDetailsModel(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <div className="card-header ps-3 pt-1 pb-1">
                  Inward Material Information
                  {/* {ListOfReTestHistoryDetails?.length > 0 ? ( */}
                  <div>
                    <Link
                      to="#"
                      className="text-primary"
                      onClick={() => {
                        setShowReTestHistModal(true);
                      }}
                    >
                      View Re-Test History
                    </Link>
                  </div>
                  {/* ) : (
                        ""
                      )} */}
                </div>
                <div className="card mb-2">
                  {/* <div className="card-header ps-3 pt-1 pb-1">
                        Inward Material Detail
                      </div> */}
                  <div className="card-body">
                    <Row>
                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">Inward No :</span>
                          &nbsp;
                          {RetestInwardNo}
                        </label>
                      </Col>
                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">TC No :</span>
                          &nbsp;
                          {RetestTCNo}
                        </label>
                      </Col>

                      {/* <Col lg={6}>
                            <label className="mb-1">
                              <span className="text-secondary">Department :</span>
                              &nbsp;{ListOfReTestDetails[0]?.DepartmentName}
                            </label>
                          </Col> */}
                      {/* <Col lg={6}>
                            <label className="mb-1">
                              <span className="text-secondary">
                                Material Group :
                              </span>
                              &nbsp;{RetestProductGroupName}
                            </label>
                          </Col>
                          <Col lg={6}>
                            <label className="mb-1">
                              <span className="text-secondary">
                                Material Type :
                              </span>
                              &nbsp; {RetestMaterialType}
                            </label>
                          </Col> */}
                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">Condition :</span>
                          &nbsp; {RetestCondition}
                        </label>
                      </Col>
                      {/* </Row>
                        <Row> */}
                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">Size :</span>
                          &nbsp;
                          {RetestSize}
                        </label>
                      </Col>
                      <Col lg={12}>
                        <label className="mb-1">
                          <span className="text-secondary">
                            Sample Detail :
                          </span>
                          &nbsp; {RetestSampleDetail}
                        </label>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="card mb-0">
                  <div className="card-header ps-3 pt-1 pb-1">Test Details</div>
                  <div className="card-body p-0">
                    <Row>
                      <Col lg={12}>
                        <ErrorMessage
                          name="ListOfReTestDetails"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="ReTestTransactionDetails-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="ReTestTransactionDetails-tbl"
                              className="table dataTable no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="2%"></th>
                                  <th width="30%">Test Name</th>
                                  <th width="30%">Department</th>
                                  <th width="40%">Remarks</th>
                                  <th width="5%" style={{ textAlign: "left" }}>
                                    Chargeable
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfReTestDetails?.length > 0 ? (
                                  ListOfReTestDetails?.map((item, idx) => (
                                    <tr key={idx}>
                                      <td className="p-1">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id="checkIsSelectedReTest"
                                          checked={item?.IsSelected}
                                          onChange={() => {
                                            formikReTestTransactionDetails.setFieldValue(
                                              `ListOfReTestDetails[${idx}].IsSelected`,
                                              !item?.IsSelected
                                            );
                                          }}
                                          style={{ cursor: "pointer" }}
                                        ></input>
                                      </td>
                                      <td>{item?.TestName}</td>
                                      <td>{item?.DepartmentName}</td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "100px",
                                        }}
                                      >
                                        <Field
                                          type="text"
                                          name={`ListOfReTestDetails[${idx}].RetestRemarks`}
                                          component={CustomInput}
                                          placeholder="Remarks"
                                          maxLength={500}
                                          noMarginBottom={true}
                                        />
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id="checkIsChargeable"
                                          checked={item?.Chargeable}
                                          onChange={() => {
                                            formikReTestTransactionDetails.setFieldValue(
                                              `ListOfReTestDetails[${idx}].Chargeable`,
                                              !item?.Chargeable
                                            );
                                          }}
                                          style={{ cursor: "pointer" }}
                                        ></input>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={5}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                {showReTestHistModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  // variant="primary"
                  variant="primary btn-sm"
                  type="submit"
                >
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </Button>
                <Button
                  // variant="secondary light"
                  variant="danger btn-sm"
                  onClick={() => setShowReTestTransactionDetailsModel(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showAmendmentModal}
        onHide={setShowAmendmentModal}
        size="xl"
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikAmendment}>
            <Form onSubmit={formikAmendment.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Amendment</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowAmendmentModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <div className="card-header ps-3 pt-1 pb-1">
                  Inward Material Information
                  {/* {ListOfAmendmentTestHistory?.length > 0 ? ( */}
                  <div>
                    <Link
                      to="#"
                      className="text-primary"
                      onClick={() => {
                        setShowAmendmentHistModal(true);
                      }}
                    >
                      View Amendment History
                    </Link>
                  </div>
                  {/* ) : (
                        ""
                      )} */}
                </div>
                <div className="card m-1">
                  {/* <div className="card-header ps-3 pt-1 pb-1">
                        Inward Material Information
                      </div> */}
                  <div className="card-body">
                    <Row>
                      <Col lg={4}>
                        <label className="mb-1">
                          <span className="text-secondary">TC No:</span>
                          &nbsp; &nbsp; {amdTCNo}
                        </label>
                      </Col>
                      <Col lg={4}>
                        <label className="mb-1">
                          <span className="text-secondary">Inward No:</span>
                          &nbsp; &nbsp; {amdInwardNo}
                        </label>
                      </Col>
                      <Col lg={4}>
                        <label className="mb-1">
                          <span className="text-secondary">Inward Date:</span>
                          &nbsp; &nbsp; {amdInwardDate}
                        </label>
                      </Col>
                      <Col lg={8}>
                        <label className="mb-1">
                          <span className="text-secondary">Customer:</span>
                          &nbsp; &nbsp; {amdCustomerName}
                        </label>
                      </Col>
                      <Col lg={4}>
                        <label className="mb-1">
                          <span className="text-secondary">Letter Ref No:</span>
                          &nbsp; &nbsp; {amdLetterRefNo}
                        </label>
                      </Col>
                      <Col lg={12}>
                        <label className="mb-1">
                          <span className="text-secondary">Project:</span>
                          &nbsp; &nbsp; {amdCustomerProjectName}
                        </label>
                      </Col>
                      <Col lg={12}>
                        <label className="mb-1">
                          <span className="text-secondary">
                            Sample Details:
                          </span>
                          &nbsp; &nbsp; {amdSampleDetail}
                        </label>
                      </Col>
                      <Col lg={12}>
                        <label className="mb-1">
                          <span className="text-secondary">Condition:</span>
                          &nbsp; &nbsp; {amdCondition}
                        </label>
                      </Col>
                      <Col lg={12}>
                        <label className="mb-1">
                          <span className="text-secondary">Size:</span>
                          &nbsp; &nbsp; {amdSize}
                        </label>
                      </Col>
                      {/* <Col lg={6}>
                            <label className="mb-1">
                              <span className="text-secondary">Department:</span>
                              &nbsp; &nbsp; {amdDepartmenName}
                            </label>
                          </Col> */}
                      {/* <Col lg={6}>
                            <label className="mb-1">
                              <span className="text-secondary">
                                Material Group:
                              </span>
                              &nbsp; &nbsp; {amdProductGroupName}
                            </label>
                          </Col>
                          <Col lg={6}>
                            <label className="mb-1">
                              <span className="text-secondary">Material Type:</span>
                              &nbsp; &nbsp; {amdMaterialTypeName}
                            </label>
                          </Col> */}
                      <Col lg={12}>
                        <label className="mb-1">
                          <span className="text-secondary">Work Details:</span>
                          &nbsp; &nbsp; {amdProjectDetails}
                        </label>
                      </Col>
                    </Row>
                    {/* <Row>
                          <Col lg={3}>
                            <label>
                              <span className="text-secondary">Amendment No:</span>
                              &nbsp; &nbsp;
                            </label>
                            <Field
                              name="Status"
                              placeholder={"Select"}
                              options={amendmentNoOptions}
                              component={CustomSelect}
                              isClearable={false}
                            />
                          </Col>
                          <Col lg={9}>
                            <Row>
                              <Col lg={4}></Col>
                              <Col lg={8}></Col>
                            </Row>
                          </Col>
                        </Row> */}
                  </div>
                </div>
                <div className="card m-1">
                  <div className="card-header ps-3 pt-1 pb-1">Test Details</div>
                  <div className="card-body p-0">
                    <Row>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="MaterialTestInfo-tbl_wrapper"
                            className="dataTables_wrapper table-responsive no-footer"
                          >
                            <table
                              id="MaterialTestInfo-tbl"
                              className="table table-bordered no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="2%" className="ps-2">
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md bg-primary-light"
                                      title="Add New"
                                      onClick={() => {
                                        AddNewAmendmentMaterialTestInformation();
                                      }}
                                    >
                                      <i className="fa fa-plus"></i>
                                    </Link>
                                  </th>
                                  <th width="15%">Department</th>
                                  <th width="18%">Test</th>
                                  <th></th>
                                  <th width="12%">Material Group</th>
                                  <th width="12%">Material Type</th>
                                  {/* <th width="13%">Test Method</th> */}
                                  <th width="14%">Ref. Standard</th>
                                  <th width="9%">Group</th>
                                  <th></th>
                                  <th width="4%">Test Count</th>
                                  <th width="4%">Billing Qty</th>
                                  {/*<th width="10%">Unit</th>
                                      <th width="10%">Rate</th> */}
                                  {/* <th
                                        width="10%"
                                        style={{
                                          display: "none",
                                        }}
                                      >
                                        Machining
                                      </th> */}
                                  <th
                                    width="10%"
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    Note
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfMaterialTestDetails?.length > 0 &&
                                  ListOfMaterialTestDetails?.map(
                                    (itemTest, indxTest) => (
                                      <tr
                                        key={indxTest}
                                        style={{
                                          display:
                                            itemTest.IsDeleted == true
                                              ? "none"
                                              : "",
                                        }}
                                      >
                                        <td className="p-1"></td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {itemTest?.DepartmentName}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                            borderRight:
                                              "1px solid transparent",
                                          }}
                                        >
                                          {itemTest?.TestName}
                                          {itemTest?.IsCancel ? (
                                            <span
                                              style={{
                                                color: "red",
                                                fontSize: "0.7rem",
                                              }}
                                            >
                                              - Cancelled
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                        <td className="p-1"></td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {itemTest?.ProductGroupName}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {itemTest?.MaterialTypeName}
                                        </td>
                                        {/* <td
                                              className="p-1"
                                              style={{
                                                minWidth: "150px",
                                                whiteSpace: "normal",
                                              }}
                                            >
                                              {itemTest?.TestMethodName}
                                            </td> */}
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {itemTest?.ReferenceStandard}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "100px",
                                            whiteSpace: "normal",
                                            borderRight:
                                              "1px solid transparent",
                                          }}
                                        >
                                          {itemTest?.RefStandardSubGroup}
                                        </td>
                                        <td className="p-1"></td>
                                        <td
                                          className="p-1 pe-2"
                                          style={{
                                            minWidth: "90px",
                                            whiteSpace: "normal",
                                            textAlign: "right",
                                          }}
                                        >
                                          {itemTest?.TestCount}
                                        </td>
                                        <td
                                          className="p-1 pe-2"
                                          style={{
                                            minWidth: "90px",
                                            whiteSpace: "normal",
                                            textAlign: "right",
                                          }}
                                        >
                                          {itemTest?.BillingQty}
                                        </td>
                                        {/*<td
                                              className="p-1"
                                              style={{
                                                minWidth: "130px",
                                                whiteSpace: "normal",
                                              }}
                                            >
                                              {itemTest?.UnitName}
                                            </td>
                                            <td
                                              className="p-1 pe-3"
                                              style={{
                                                minWidth: "110px",
                                                whiteSpace: "normal",
                                                textAlign: "right",
                                              }}
                                            >
                                              {itemTest?.Rate}
                                            </td> */}
                                        <td
                                          className="p-1"
                                          style={{
                                            textAlign: "left",
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {itemTest?.TestNote}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                {ListOfAmendmentMaterialTestDetails?.filter(
                                  (x) => x.IsDeleted == false
                                )?.length > 0 &&
                                  ListOfAmendmentMaterialTestDetails?.map(
                                    (itemTest, indxTest) => (
                                      <tr
                                        key={indxTest}
                                        style={{
                                          display:
                                            itemTest.IsDeleted == true
                                              ? "none"
                                              : "",
                                        }}
                                      >
                                        <td className="p-1">
                                          <Link
                                            to="#"
                                            // className="icon-box icon-box-md bg-danger-light"
                                            className="icon-box icon-box-md"
                                            title="Delete"
                                            onClick={() => {
                                              //deleteAmendmentMaterialTestInformation(indxTest);
                                              delete_RecordWithoutApi(
                                                deleteAmendmentMaterialTestInformation,
                                                indxTest
                                              );
                                            }}
                                            // onClick={() => {
                                            //   deleteAmendmentMaterialTestInformation(
                                            //     indxTest
                                            //   );
                                            // }}
                                          >
                                            {SVGICON.DeleteDanger}
                                          </Link>
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                          }}
                                        >
                                          <Field
                                            name={`ListOfAmendmentMaterialTestDetails[${indxTest}].DepartmentIDEncrypted`}
                                            placeholder={"Department"}
                                            // options={amendmentDepartmentOptions}
                                            options={departmentOptions}
                                            component={CustomSelect}
                                            noMarginBottom={true}
                                            menuPosition="fixed"
                                            isDisabled={
                                              itemTest?.IsMixDesignIncludedTest
                                            }
                                            onChange={(e) => {
                                              let mixDesignTest = false;
                                              if (
                                                itemTest.IsMixDesign == true
                                              ) {
                                                mixDesignTest = true;
                                                setSelectedMixDesignTestID(
                                                  itemTest.TestMasterIDEncrypted
                                                );
                                              }
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].DepartmentIDEncrypted`,
                                                e?.value ?? ""
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].ProductGroupIDEncrypted`,
                                                ""
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].MaterialTypeIDEncrypted`,
                                                ""
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].TestMasterIDEncrypted`,
                                                ""
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].TestMethodIDEncrypted`,
                                                ""
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].ReferenceStandardIDEncrypted`,
                                                ""
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].RefStandardSubGroup`,
                                                ""
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].testOptions`,
                                                []
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].testMethodOptions`,
                                                []
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].referenceStandardOptions`,
                                                []
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].refStandardSubGroupOptions`,
                                                []
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].productGroupOptions`,
                                                []
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].materialTypeOptions`,
                                                []
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].IsMixDesign`,
                                                false
                                              );
                                              formikAmendment.setFieldValue(
                                                `ListOfAmendmentMaterialTestDetails[${indxTest}].TestMixDesignDetail`,
                                                initAmendmentMaterialTestDetail.TestMixDesignDetail
                                              );
                                              // getTestDDLByDepartmentProductGroupMaterialType(
                                              //   e?.value ?? "",
                                              //   amdProductGroupIDEncryted,
                                              //   amdMaterialTypeIDEncrypted,
                                              //   indxTest
                                              // );
                                              getTestDDLByDepartment(
                                                e?.value ?? "",
                                                indxTest
                                              );
                                              if (mixDesignTest == true) {
                                                setDeleteMixDesignIncludedTestActionStatus(
                                                  true
                                                );
                                              }
                                            }}
                                          />
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            borderRight:
                                              "1px solid transparent",
                                          }}
                                        >
                                          <Field
                                            name={`ListOfAmendmentMaterialTestDetails[${indxTest}].TestMasterIDEncrypted`}
                                            placeholder={"Test"}
                                            options={itemTest?.testOptions}
                                            component={CustomSelect}
                                            noMarginBottom={true}
                                            menuPosition="fixed"
                                            isDisabled={
                                              itemTest?.IsMixDesignIncludedTest
                                            }
                                            onChange={(e) => {
                                              handleChangeAmendmentTestMaster(
                                                0,
                                                indxTest,
                                                e,
                                                itemTest
                                              );
                                            }}
                                          />
                                        </td>
                                        <td className="p-1">
                                          {itemTest?.TestMasterIDEncrypted && (
                                            <>
                                              {AuthUser?.Permissions?.Account ==
                                              1 ? (
                                                <Link
                                                  to="#"
                                                  className="icon-box icon-box-md bg-primary-light"
                                                  title="Define More Rates Selection"
                                                  onClick={() => {
                                                    handleOnClickDefineMoreRatesSelection(
                                                      indxTest,
                                                      itemTest,
                                                      itemTest?.TestMasterIDEncrypted,
                                                      itemTest?.InwardMaterialTestDetailIDEncrypted
                                                    );
                                                  }}
                                                >
                                                  {SVGICON.Rates}
                                                </Link>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          )}
                                          {itemTest?.TestMasterIDEncrypted &&
                                            itemTest?.IsMixDesign == true && (
                                              <Link
                                                to="#"
                                                className="icon-box icon-box-md bg-primary-light ms-1"
                                                title="Mix Design Details"
                                                onClick={() => {
                                                  handleOnClickMixDesignDetail(
                                                    0,
                                                    indxTest,
                                                    "",
                                                    itemTest
                                                  );
                                                }}
                                              >
                                                {SVGICON.Setting2}
                                              </Link>
                                            )}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                          }}
                                        >
                                          <Field
                                            name={`ListOfAmendmentMaterialTestDetails[${indxTest}].ProductGroupIDEncrypted`}
                                            placeholder={"Material Group"}
                                            options={
                                              itemTest?.productGroupOptions
                                            }
                                            component={CustomSelect}
                                            noMarginBottom={true}
                                            menuPosition="fixed"
                                          />
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                          }}
                                        >
                                          <Field
                                            name={`ListOfAmendmentMaterialTestDetails[${indxTest}].MaterialTypeIDEncrypted`}
                                            placeholder={"Material Type"}
                                            options={
                                              itemTest?.materialTypeOptions
                                            }
                                            component={CustomSelect}
                                            noMarginBottom={true}
                                            menuPosition="fixed"
                                          />
                                        </td>
                                        {/* <td
                                              className="p-1"
                                              style={{
                                                minWidth: "150px",
                                              }}
                                            >
                                              <Field
                                                name={`ListOfAmendmentMaterialTestDetails[${indxTest}].TestMethodIDEncrypted`}
                                                placeholder={"Test Method"}
                                                options={itemTest.testMethodOptions}
                                                component={CustomSelect}
                                                noMarginBottom={true}
                                                menuPosition="fixed"
                                                onChange={(e) => {
                                                  if (
                                                    e?.IsExpiredTestMethod == true
                                                  ) {
                                                    warningMessage(
                                                      "Test Method is Expired..!"
                                                    );
                                                  } else {
                                                    formikAmendment.setFieldValue(
                                                      `ListOfAmendmentMaterialTestDetails[${indxTest}].TestMethodIDEncrypted`,
                                                      e?.value ?? ""
                                                    );
                                                  }
                                                }}
                                              />
                                            </td> */}
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                          }}
                                        >
                                          <Field
                                            name={`ListOfAmendmentMaterialTestDetails[${indxTest}].ReferenceStandardIDEncrypted`}
                                            placeholder={"Ref. Standard"}
                                            options={
                                              itemTest.referenceStandardOptions
                                            }
                                            component={CustomSelect}
                                            noMarginBottom={true}
                                            menuPosition="fixed"
                                            onChange={(e) => {
                                              handleChangeAmendmentReferenceStandard(
                                                itemTest?.TestMasterIDEncrypted,
                                                indxTest,
                                                e
                                              );
                                            }}
                                          />
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "100px",
                                            borderRight:
                                              "1px solid transparent",
                                          }}
                                        >
                                          <Field
                                            name={`ListOfAmendmentMaterialTestDetails[${indxTest}].RefStandardSubGroup`}
                                            placeholder={"Group"}
                                            options={
                                              itemTest.refStandardSubGroupOptions
                                            }
                                            component={CustomSelect}
                                            noMarginBottom={true}
                                            menuPosition="fixed"
                                            onChange={(e) => {
                                              handleChangeAmendmentRefStandardSubGroup(
                                                itemTest?.ReferenceStandardIDEncrypted,
                                                itemTest?.TestMasterIDEncrypted,
                                                indxTest,
                                                e
                                              );
                                            }}
                                          />
                                        </td>
                                        <td className="p-1">
                                          {itemTest?.TestMasterIDEncrypted && (
                                            <Link
                                              to="#"
                                              className="icon-box icon-box-md bg-primary-light"
                                              title="Parameters Selection"
                                              onClick={() => {
                                                formikTestPrameters.setFieldValue(
                                                  "ParametersTestName",
                                                  itemTest?.testOptions?.filter(
                                                    (x) =>
                                                      x?.value ==
                                                      itemTest?.TestMasterIDEncrypted
                                                  )[0]?.label
                                                );
                                                formikTestPrameters.setFieldValue(
                                                  "ParametersList",
                                                  itemTest?.ListOfTestParameters
                                                );
                                                formikTestPrameters.setFieldValue(
                                                  "testIndexPara",
                                                  indxTest
                                                );
                                                setShowTestParametersModal(
                                                  true
                                                );
                                              }}
                                            >
                                              <i className="fa fa-tags"></i>
                                            </Link>
                                          )}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "90px",
                                          }}
                                        >
                                          <Field
                                            name={`ListOfAmendmentMaterialTestDetails[${indxTest}].TestCount`}
                                            placeholder={"Test Count"}
                                            component={CustomInput}
                                            type="number"
                                            numberTypeWithoutDot={true}
                                            noMarginBottom={true}
                                            style={{ textAlign: "right" }}
                                            onChange={(e) => {
                                              if (e?.target?.value < 1000) {
                                                formikAmendment.setFieldValue(
                                                  `ListOfAmendmentMaterialTestDetails[${indxTest}].TestCount`,
                                                  e?.target?.value ?? ""
                                                );
                                              }
                                            }}
                                          />
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "90px",
                                          }}
                                        >
                                          <Field
                                            name={`ListOfAmendmentMaterialTestDetails[${indxTest}].BillingQty`}
                                            placeholder={"Billing Qty"}
                                            component={CustomInput}
                                            type="number"
                                            noMarginBottom={true}
                                            style={{ textAlign: "right" }}
                                          />
                                        </td>
                                        {/*
                                            <td
                                              className="p-1"
                                              style={{
                                                minWidth: "130px",
                                              }}
                                            >
                                              <Field
                                                name={`ListOfAmendmentMaterialTestDetails[${indxTest}].UnitID`}
                                                placeholder={"Unit"}
                                                options={unitOptions}
                                                component={CustomSelect}
                                                noMarginBottom={true}
                                                menuPosition="fixed"
                                              />
                                            </td>
                                            <td
                                              className="p-1"
                                              style={{
                                                minWidth: "110px",
                                              }}
                                            >
                                              <Field
                                                name={`ListOfAmendmentMaterialTestDetails[${indxTest}].Rate`}
                                                placeholder={"Rate"}
                                                component={CustomInput}
                                                type="number"
                                                noMarginBottom={true}
                                              />
                                            </td> */}
                                        <td
                                          className="p-1"
                                          style={{
                                            textAlign: "left",
                                            minWidth: "150px",
                                          }}
                                        >
                                          <Field
                                            name={`ListOfAmendmentMaterialTestDetails[${indxTest}].TestNote`}
                                            placeholder={"Note"}
                                            component={CustomInput}
                                            maxLength={100}
                                            noMarginBottom={true}
                                          />
                                        </td>
                                      </tr>
                                    )
                                  )}
                                {ListOfMaterialTestDetails?.length == 0 &&
                                  ListOfAmendmentMaterialTestDetails?.filter(
                                    (x) => x.IsDeleted == false
                                  )?.length == 0 && (
                                    <tr>
                                      <td
                                        colSpan={10}
                                        style={{
                                          textAlign: "left",
                                        }}
                                      >
                                        <div>{"No Record Found..."}</div>
                                      </td>
                                    </tr>
                                  )}
                              </tbody>
                            </table>
                            <ErrorMessage
                              name="ListOfAmendmentMaterialTestDetails"
                              component="div"
                              className="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <Row className="ps-2 pe-2">
                  <Col lg={12}>
                    <Field
                      label="Amendment Remarks"
                      name="AmendmentRemarks"
                      placeholder={"Remarks"}
                      component={CustomInput}
                      maxLength={500}
                      required
                    />
                  </Col>
                </Row>
                {(showAmendmentHistModal == true ||
                  showTestParametersModal == true ||
                  showMixDesignTestDetailModal == true ||
                  showDefineMoreRatesModal == true) && (
                  <div className="fade modal-backdrop show"></div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary btn-sm" type="submit">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </Button>
                <Button
                  variant="danger btn-sm"
                  onClick={() => setShowAmendmentModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showCancelTestModal}
        onHide={setShowCancelTestModal}
        size="xl"
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikCancelTest}>
            <Form onSubmit={formikCancelTest.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Cancel Test</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowCancelTestModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <div className="card m-1">
                  <div className="card-header ps-3 pt-1 pb-1">
                    Inward Material Information
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col lg={3}>
                        <label className="mb-1">
                          <span className="text-secondary">Inward Date:</span>
                          &nbsp; &nbsp; {cancelTestInwardDate}
                        </label>
                      </Col>
                      <Col lg={3}>
                        <label className="mb-1">
                          <span className="text-secondary">Inward No:</span>
                          &nbsp; &nbsp; {cancelTestInwardNo}
                        </label>
                      </Col>
                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">TC No:</span>
                          &nbsp; &nbsp; {cancelTestTCNo}
                        </label>
                      </Col>
                      <Col lg={3}>
                        <label className="mb-1">
                          <span className="text-secondary">Letter Ref No:</span>
                          &nbsp; &nbsp; {cancelTestLetterRefNo}
                        </label>
                      </Col>
                      <Col lg={3}>
                        <label className="mb-1">
                          <span className="text-secondary">Size:</span>
                          &nbsp; &nbsp; {cancelTestSize}
                        </label>
                      </Col>
                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">Customer:</span>
                          &nbsp; &nbsp; {cancelTestCustomerName}
                        </label>
                      </Col>

                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">Project:</span>
                          &nbsp; &nbsp; {cancelTestCustomerProjectName}
                        </label>
                      </Col>
                      {/* <Col lg={6}>
                            <label className="mb-1">
                              <span className="text-secondary">Department:</span>
                              &nbsp; &nbsp; {cancelTestDepartmenName}
                            </label>
                          </Col> */}
                      {/* <Col lg={6}>
                            <label className="mb-1">
                              <span className="text-secondary">
                                Material Group:
                              </span>
                              &nbsp; &nbsp; {cancelTestProductGroupName}
                            </label>
                          </Col>
                          <Col lg={6}>
                            <label className="mb-1">
                              <span className="text-secondary">Material Type:</span>
                              &nbsp; &nbsp; {cancelTestMaterialTypeName}
                            </label>
                          </Col> */}

                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">Condition:</span>
                          &nbsp; &nbsp; {cancelTestCondition}
                        </label>
                      </Col>
                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">
                            Sample Details:
                          </span>
                          &nbsp; &nbsp; {cancelTestSampleDetail}
                        </label>
                      </Col>
                      <Col lg={6}>
                        <label className="mb-1">
                          <span className="text-secondary">Work Details:</span>
                          &nbsp; &nbsp; {cancelTestProjectDetails}
                        </label>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="card m-1">
                  <div className="card-header ps-3 pt-1 pb-1">Test Details</div>
                  <div className="card-body p-0">
                    <Row>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="CancelTestMaterialTestInfo-tbl_wrapper"
                            className="dataTables_wrapper table-responsive no-footer"
                          >
                            <table
                              id="CancelTestMaterialTestInfo-tbl"
                              className="table table-bordered no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="2%" className="ps-2"></th>
                                  <th width="16%">Department</th>
                                  <th width="20%">Test</th>
                                  <th width="14%">Material Group</th>
                                  <th width="14%">Material Type</th>
                                  {/* <th width="13%">Test Method</th> */}
                                  <th width="14%">Ref. Standard</th>
                                  <th width="5%">Test Count</th>
                                  <th width="5%">Billing Qty</th>
                                  {/*<th width="10%">Unit</th>
                                      <th width="10%">Rate</th> */}
                                  {/* <th
                                        width="10%"
                                        style={{
                                          display: "none",
                                        }}
                                      >
                                        Machining
                                      </th> */}
                                  <th
                                    width="10%"
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    Note
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfCancelTestMaterialTestDetails?.length >
                                  0 &&
                                  ListOfCancelTestMaterialTestDetails?.map(
                                    (itemTest, indxTest) => (
                                      <tr key={indxTest}>
                                        <td className="p-1">
                                          {itemTest?.IsCancel == false ? (
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="checkIsSelectedCancelTest"
                                              checked={itemTest?.IsSelected}
                                              onChange={() => {
                                                formikCancelTest.setFieldValue(
                                                  `ListOfCancelTestMaterialTestDetails[${indxTest}].IsSelected`,
                                                  !itemTest?.IsSelected
                                                );
                                              }}
                                              style={{ cursor: "pointer" }}
                                              disabled={itemTest?.IsCancel}
                                            ></input>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {itemTest?.DepartmentName}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {itemTest?.TestName}{" "}
                                          {itemTest?.IsCancel ? (
                                            <span
                                              style={{
                                                color: "red",
                                                fontSize: "0.7rem",
                                              }}
                                            >
                                              - Cancelled
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {itemTest?.ProductGroupName}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {itemTest?.MaterialTypeName}
                                        </td>
                                        {/* <td
                                              className="p-1"
                                              style={{
                                                minWidth: "150px",
                                                whiteSpace: "normal",
                                              }}
                                            >
                                              {itemTest?.TestMethodName}
                                            </td> */}
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {itemTest?.ReferenceStandard}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "10px",
                                            whiteSpace: "normal",
                                            textAlign: "center",
                                          }}
                                        >
                                          {itemTest?.TestCount}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "100px",
                                            whiteSpace: "normal",
                                            textAlign: "center",
                                          }}
                                        >
                                          {itemTest?.BillingQty}
                                        </td>
                                        {/*<td
                                              className="p-1"
                                              style={{
                                                minWidth: "130px",
                                                whiteSpace: "normal",
                                              }}
                                            >
                                              {itemTest?.UnitName}
                                            </td>
                                            <td
                                              className="p-1 pe-3"
                                              style={{
                                                minWidth: "110px",
                                                whiteSpace: "normal",
                                                textAlign: "right",
                                              }}
                                            >
                                              {itemTest?.Rate}
                                            </td> */}
                                        <td
                                          className="p-1"
                                          style={{
                                            textAlign: "left",
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {itemTest?.TestNote}
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </tbody>
                            </table>
                            <ErrorMessage
                              name="ListOfCancelTestMaterialTestDetails"
                              component="div"
                              className="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <Row className="ps-2 pe-2">
                  <Col lg={12}>
                    <Field
                      label="Cancel Remarks"
                      name="CancelRemarks"
                      placeholder={"Cancel Remarks"}
                      component={CustomInput}
                      maxLength={500}
                      required
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary btn-sm" type="submit">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </Button>
                <Button
                  variant="danger btn-sm"
                  onClick={() => setShowCancelTestModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showInwardMaterialRewiseModal}
        onHide={setShowInwardMaterialRewiseModal}
        size="xl"
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikInwardMaterialRewise}>
            <Form onSubmit={formikInwardMaterialRewise.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Revise</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowInwardMaterialRewiseModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <div className="card-header ps-3 pt-1 pb-1">
                  Inward Material Information
                  {/* {RewiseCount > 0 ? ( */}
                  <div>
                    <Link
                      to="#"
                      className="text-primary"
                      onClick={() => {
                        setShowRewiseHistModal(true);
                      }}
                    >
                      View Revise History
                    </Link>
                  </div>
                  {/* ) : (
                        ""
                      )} */}
                </div>

                <div className="card m-1">
                  <div className="card-body">
                    <Row>
                      <Col lg={4}>
                        <label className="mb-1">
                          <span className="text-secondary">TC No :</span>
                          &nbsp; &nbsp; {RewiseTCNo}
                        </label>
                      </Col>

                      <Col lg={4}>
                        <label className="mb-1">
                          <span className="text-secondary">Inward No :</span>
                          &nbsp; &nbsp; {RewiseInwardNo}
                        </label>
                      </Col>
                      <Col lg={4}>
                        <label className="mb-1">
                          <span className="text-secondary">Inward Date :</span>
                          &nbsp; &nbsp; {RewiseInwardDate}
                        </label>
                      </Col>

                      <Col lg={12}>
                        <label className="mb-1">
                          <span className="text-secondary">Customer :</span>
                          &nbsp; &nbsp; {RewiseCustomerName}
                        </label>
                      </Col>

                      {/* <Col lg={3}>
                            <label className="mb-1">
                              <span className="text-secondary">
                                Letter Ref No :
                              </span>
                              &nbsp; &nbsp; {RewiseLetterRefNo}
                            </label>
                          </Col> */}
                      <Col lg={12}>
                        <label className="mb-1">
                          <span className="text-secondary">Project :</span>
                          &nbsp; &nbsp; {RewiseCustomerProjectName}
                        </label>
                      </Col>
                      {/* <Col lg={3}>
                            <label className="mb-1">
                              <span className="text-secondary">Size :</span>
                              &nbsp; &nbsp; {RewiseSize}
                            </label>
                          </Col> */}

                      {/* <Col lg={6}>
                            <label className="mb-1">
                              <span className="text-secondary">
                                Material Group :
                              </span>
                              &nbsp; &nbsp; {RewiseProductGroupName}
                            </label>
                          </Col>
                          <Col lg={6}>
                            <label className="mb-1">
                              <span className="text-secondary">
                                Material Type :
                              </span>
                              &nbsp; &nbsp; {RewiseMaterialTypeName}
                            </label>
                          </Col> */}

                      {/* <Col lg={12}>
                            <label className="mb-1">
                              <span className="text-secondary">Condition :</span>
                              &nbsp; &nbsp; {RewiseCondition}
                            </label>
                          </Col> */}
                    </Row>
                  </div>
                </div>
                <Row className="ps-2 pe-2">
                  <Col lg={3}>
                    <Field
                      label="Revise No"
                      name="RewiseNo"
                      placeholder={"Select Revise No"}
                      options={rewiseNoOptions}
                      component={CustomSelect}
                      required
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Revise Remarks"
                      name="RewiseRemarks"
                      placeholder={"Revise Remarks"}
                      component={CustomInput}
                      maxLength={1000}
                      required
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Revise Date"
                      name="RewiseDate"
                      placeholder={"Revise Date"}
                      component={CustomFlatpickr}
                      options={{
                        altInput: true,
                        altFormat: "j-M-Y",
                        dateFormat: "d-m-Y",
                      }}
                      required
                    />
                  </Col>
                  <Col lg={3}>
                    <div className="d-flex justify-content-between">
                      <label className="mb-1">Revise File </label>
                    </div>
                    <input
                      type="file"
                      id="fileUpload"
                      className="form-control form-control-sm"
                      onChange={uploadRewiseFile}
                    />
                    <label htmlFor="fileUpload" name=""></label>
                  </Col>
                </Row>
                <div className="card m-1">
                  <div className="card-header ps-3 pt-1 pb-1">
                    Revise Type Details
                  </div>
                  <div className="card-body p-0">
                    <Row>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="CancelTestMaterialTestInfo-tbl_wrapper"
                            className="dataTables_wrapper table-responsive no-footer"
                          >
                            <table
                              id="CancelTestMaterialTestInfo-tbl"
                              className="table table-bordered no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="3%" className="ps-2"></th>
                                  <th width="12%">Revise Type</th>
                                  <th width="45%">Old Value</th>
                                  <th
                                    width="40%"
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    New Value
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {RewiseTypeList?.length > 0 &&
                                  RewiseTypeList?.map(
                                    (itemRewise, indxRewise) => (
                                      <tr key={indxRewise}>
                                        <td className="p-1">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="checkIsSelectedRewise"
                                            checked={itemRewise?.IsSelected}
                                            onChange={() => {
                                              formikInwardMaterialRewise.setFieldValue(
                                                `RewiseTypeList[${indxRewise}].IsSelected`,
                                                !itemRewise?.IsSelected
                                              );
                                            }}
                                            style={{ cursor: "pointer" }}
                                          ></input>
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{ minWidth: "100px" }}
                                        >
                                          {itemRewise?.RewiseType}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            whiteSpace: "normal",
                                          }}
                                        >
                                          {itemRewise?.OldValues}
                                        </td>
                                        <td
                                          className="p-1"
                                          style={{
                                            minWidth: "150px",
                                            textAlign: "left",
                                          }}
                                        >
                                          <Field
                                            type="text"
                                            name={`RewiseTypeList[${indxRewise}].NewValues`}
                                            component={CustomInput}
                                            placeholder="New Values"
                                            maxLength={2000}
                                            noMarginBottom={true}
                                            disabled={!itemRewise?.IsSelected}
                                          />
                                          &nbsp;
                                          {itemRewise?.RewiseTypeID == 5 ? (
                                            <Link
                                              to="#"
                                              className="icon-box icon-box-md"
                                              title="Letter Ref Images"
                                              onClick={() => {
                                                if (itemRewise?.IsSelected) {
                                                  setShowRewiseLetterRefDocModal(
                                                    true
                                                  );
                                                }
                                              }}
                                              disabled={!itemRewise?.IsSelected}
                                            >
                                              <i className="fa fa-cloud-upload"></i>
                                            </Link>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <ErrorMessage
                          name="RewiseTypeList"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
                {(showRewiseHistModal == true ||
                  showRewiseLetterRefDocModal == true) && (
                  <div className="fade modal-backdrop show"></div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary btn-sm" type="submit">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </Button>
                <Button
                  variant="danger btn-sm"
                  onClick={() => setShowInwardMaterialRewiseModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showRewiseLetterRefDocModal}
        onHide={setShowRewiseLetterRefDocModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Letter Ref Doc</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowRewiseLetterRefDocModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className="mb-2">
                  <label></label>
                  <div className="avatar-file">
                    <input
                      type="file"
                      id="LetterRefUpload2"
                      //accept="image/png, image/gif, image/jpeg"
                      onChange={uploadRewiseLetterRefDoc}
                      //key={fileKeyMaterialPhoto || ""}
                    />
                    <label htmlFor="LetterRefUpload2" name=""></label>
                  </div>
                  <div
                    id="webCam"
                    className="avatar-camera"
                    onClick={() => {
                      setOpenWebCamModalLetterRefDocImage(true);
                    }}
                    style={{ marginLeft: "50px" }}
                  >
                    <input type="hidden" />
                    <label htmlFor="webCam" name=""></label>
                  </div>
                </div>
                {/* <div style={{ float: "right", marginRight: "2rem" }}>
                      + Add
                      <div
                        className="open-file mt-2"
                        style={{ marginLeft: "2rem" }}
                      >
                        <input
                          type="file"
                          id="LetterRefUpload2"
                          onChange={uploadRewiseLetterRefDoc}
                        />
                        <label htmlFor="LetterRefUpload2" name=""></label>
                      </div>
                    </div> */}
              </Col>
              {letterRefDocPhoto && (
                <Col lg={12}>
                  <div className="d-flex">
                    <div className="image-placeholder companyLogo-placeholder mt-0 ms-0">
                      <div className="avatar-preview">
                        <div id="imagePreview">
                          <img
                            id="saveImageFile"
                            src={letterRefDocPhoto ? letterRefDocPhoto : img200}
                            alt={"Material Image"}
                            style={{
                              maxHeight: "100px",
                              maxWidth: "100px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        className="btn btn-sm btn-primary me-1"
                        onClick={() => {
                          addLetterRefDocFile();
                        }}
                      >
                        <i className="fa fa-cloud-upload"></i> Upload
                      </button>
                      <button
                        // className="btn btn-sm btn-danger light"
                        className="btn btn-sm btn-danger"
                        onClick={() => {
                          setLetterRefDocPhoto(null);
                          setLetterRefDocPhotoFile(null);
                        }}
                      >
                        <i className="fa fa-cancel"></i> Cancel
                      </button>
                    </div>
                  </div>
                </Col>
              )}
              <Col lg={12}>
                <div className="table-responsive active-projects style-1 shorting mb-2">
                  <div
                    id="LetterRefDoc-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="LetterRefDoc-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="4%"></th>
                          <th width="96%" style={{ textAlign: "left" }}>
                            File Name
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {RewiseLetterRefImagesList?.filter(
                          (x) => x.IsDeleted == false
                        )?.length > 0 ? (
                          RewiseLetterRefImagesList?.map((item, indx) => (
                            <tr
                              key={indx}
                              style={{
                                display: item.IsDeleted == true ? "none" : "",
                              }}
                            >
                              <td>
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="View"
                                  onClick={() => {
                                    window.open(
                                      item.LetterRefImageFilePath
                                        ? item.LetterRefImageFilePath
                                        : item.viewFile
                                    );
                                  }}
                                >
                                  <i className="fa fa-eye" />
                                </Link>
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="Delete"
                                  onClick={() => {
                                    //deleteRewiseLetterRefDoc(indx);
                                    delete_RecordWithoutApi(
                                      deleteRewiseLetterRefDoc,
                                      indx
                                    );
                                  }}
                                >
                                  {SVGICON.DeleteDanger}
                                </Link>
                              </td>
                              <td style={{ textAlign: "left" }}>
                                {item.LetterRefImageFileName}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={2} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
            {openWebCamModalLetterRefDocImage == true && (
              <div className="fade modal-backdrop show"></div>
            )}
          </Modal.Body>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={openWebCamModalLetterRefDocImage}
        onHide={setOpenWebCamModalLetterRefDocImage}
      >
        <Modal.Header>
          <Modal.Title>Letter Ref Doc</Modal.Title>
          <Button
            type="button"
            variant=""
            className="btn-close"
            onClick={() => setOpenWebCamModalLetterRefDocImage(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12">
              <Webcam
                ref={webcamRef}
                audio={false}
                mirrored={true}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
                onUserMedia={onUserMedia}
                className="webCam"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            // className="btn btn-primary "
            variant="primary btn-sm"
            onClick={captureLetterRefDocPhoto}
          >
            <i className="fa fa-camera"></i> Capture
          </Button>

          <Button
            // className="btn btn-danger light"
            variant="danger btn-sm"
            onClick={() => {
              setOpenWebCamModalLetterRefDocImage(false);
            }}
          >
            <i className="fa fa-cancel"></i> Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        className="fade"
        show={showRewiseHistModal}
        onHide={setShowRewiseHistModal}
        size="xl"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Revise History</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowRewiseHistModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className="table-responsive active-projects style-1 shorting mb-2">
                  <div
                    id="RewiseHist-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="RewiseHist-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="5%">View</th>
                          <th width="15%">Revise Date</th>
                          <th width="20%">Revise No</th>
                          <th width="37%">Remarks</th>
                          <th width="23%" style={{ textAlign: "left" }}>
                            File
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ListOfRewiseHist?.length > 0 ? (
                          ListOfRewiseHist?.map((item, indx) => (
                            <tr key={indx}>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="View Revise Detail"
                                  onClick={() => {
                                    setShowRewiseHistDetailModal(true);
                                    formikInwardMaterialRewise.setFieldValue(
                                      "ListOfRewiseHistDetails",
                                      item?.ListOfRewiseDetails
                                    );
                                  }}
                                >
                                  {SVGICON.NoteText}
                                </Link>
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item.RewiseDate}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item.RewiseNo}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item.Remarks}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                  textAlign: "left",
                                }}
                              >
                                {item.ReferenceFileImage ? (
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="View"
                                    onClick={() => {
                                      window.open(
                                        item.ReferenceFileImage
                                          ? item.ReferenceFileImage
                                          : ""
                                      );
                                    }}
                                  >
                                    <i className="fa fa-eye" />
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {item?.ReferenceFileImage
                                  ? (item?.ReferenceFileImage?.split("/"))[
                                      item?.ReferenceFileImage?.split("/")
                                        .length - 1
                                    ]
                                  : ""}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={6} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
            {showRewiseHistDetailModal == true && (
              <div className="fade modal-backdrop show"></div>
            )}
          </Modal.Body>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showRewiseHistDetailModal}
        onHide={setShowRewiseHistDetailModal}
        size="xl"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Revise History</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowRewiseHistDetailModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className="table-responsive active-projects style-1 shorting mb-2">
                  <div
                    id="RewiseHist-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="RewiseHist-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <th width="25%">Revise Type</th>
                          <th width="35%">Old Value</th>
                          <th width="35%" style={{ textAlign: "left" }}>
                            New Value
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ListOfRewiseHistDetails?.length > 0 ? (
                          ListOfRewiseHistDetails?.filter(
                            (x) => x.RewiseTypeID !== 6
                          ).map((item, indx) => (
                            <tr key={indx}>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {indx + 1}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item?.RewiseType}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item?.OldValue}
                                <br />
                                {item?.RewiseTypeID == 5
                                  ? ListOfRewiseHistDetails?.filter(
                                      (x) =>
                                        x.RewiseTypeID == 6 && x.OldValue != ""
                                    ).map((itemsub, indxsub) => (
                                      <>
                                        <span>
                                          {itemsub?.OldValue ? (
                                            <>
                                              <Link
                                                to="#"
                                                className="icon-box icon-box-md me-1"
                                                title="View"
                                                onClick={() => {
                                                  window.open(
                                                    itemsub?.OldValue
                                                      ? itemsub?.OldValue
                                                      : ""
                                                  );
                                                }}
                                              >
                                                <i className="fa fa-eye" />
                                              </Link>

                                              {itemsub?.OldValue
                                                ? (itemsub?.OldValue?.split(
                                                    "/"
                                                  ))[
                                                    itemsub?.OldValue?.split(
                                                      "/"
                                                    ).length - 1
                                                  ]
                                                : ""}
                                              <br />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                      </>
                                    ))
                                  : ""}
                              </td>

                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                  textAlign: "left",
                                }}
                              >
                                {item?.NewValue}
                                <br />
                                {item?.RewiseTypeID == 5
                                  ? ListOfRewiseHistDetails?.filter(
                                      (x) =>
                                        x.RewiseTypeID == 6 && x?.NewValue != ""
                                    ).map((itemsub, indxsub) => (
                                      <>
                                        <span>
                                          {itemsub?.NewValue ? (
                                            <>
                                              <Link
                                                to="#"
                                                className="icon-box icon-box-md me-1"
                                                title="View"
                                                onClick={() => {
                                                  window.open(
                                                    itemsub?.NewValue
                                                      ? itemsub?.NewValue
                                                      : ""
                                                  );
                                                }}
                                              >
                                                <i className="fa fa-eye" />
                                              </Link>

                                              {itemsub?.NewValue
                                                ? (itemsub?.NewValue?.split(
                                                    "/"
                                                  ))[
                                                    itemsub?.NewValue?.split(
                                                      "/"
                                                    ).length - 1
                                                  ]
                                                : ""}
                                              <br />
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                      </>
                                    ))
                                  : ""}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={4} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showReTestHistModal}
        onHide={setShowReTestHistModal}
        size="xl"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Re-Test History</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowReTestHistModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className="table-responsive active-projects style-1 shorting mb-2">
                  <div
                    id="ReTestHist-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="ReTestHist-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <th width="20%">Test Name</th>
                          <th width="15%">ReTest Date</th>
                          <th width="27%">ReTest Status</th>
                          <th width="10%">Chargeable</th>
                          <th width="23%" style={{ textAlign: "left" }}>
                            Remarks
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ListOfReTestHistoryDetails?.length > 0 ? (
                          ListOfReTestHistoryDetails?.map((item, indx) => (
                            <tr key={indx}>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {indx + 1}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item?.TestName}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item?.ReTestDate}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item?.RetestStatus}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item?.Chargeable}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                  textAlign: "left",
                                }}
                              >
                                {item?.RetestRemarks}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={6} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showAmendmentHistModal}
        onHide={setShowAmendmentHistModal}
        size="xl"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Amendment History</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowAmendmentHistModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className="table-responsive active-projects style-1 shorting mb-2">
                  <div
                    id="AmendmentHist-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="AmendmentHist-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <th width="15%">Amendment Date</th>
                          <th width="30%">Amendment Remarks</th>
                          <th width="50%" style={{ textAlign: "left" }}>
                            Test Name
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ListOfAmendmentTestHistory?.length > 0 ? (
                          ListOfAmendmentTestHistory?.map((item, indx) => (
                            <tr key={indx}>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {indx + 1}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item?.AmendmentDate}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item?.AmendmentRemarks}
                              </td>
                              <td
                                style={{
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                  textAlign: "left",
                                }}
                              >
                                {item?.TestName}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={6} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showTestParametersModal}
        onHide={setShowTestParametersModal}
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikTestPrameters}>
            <Form onSubmit={formikTestPrameters.handleSubmit}>
              <Modal.Header>
                <Modal.Title>{ParametersTestName}</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowTestParametersModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <div
                      className="table-responsive active-projects style-1 shorting"
                      style={{ maxHeight: "450px" }}
                    >
                      <div
                        id="TestParameters-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="TestParameters-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead className="fixedheader">
                            <tr>
                              <th width="3%"></th>
                              <th width="97%" style={{ textAlign: "left" }}>
                                Parameters
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ParametersList?.length > 0 ? (
                              ParametersList?.map((para, iPara) => (
                                <tr key={iPara}>
                                  <td className="p-1">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkIsSelected${iPara}`}
                                      name={`chkIsSelected${iPara}`}
                                      checked={para.IsSelected}
                                      onChange={(e) => {
                                        formikTestPrameters.setFieldValue(
                                          `ParametersList[${iPara}].IsSelected`,
                                          e?.target?.checked
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    className="p-1"
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    {para?.ParameterName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={2}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  // className="btn btn-primary"
                  variant="primary btn-sm"
                  type="submit"
                >
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </Button>

                <Button
                  // className="btn btn-danger light"
                  variant="danger btn-sm"
                  onClick={() => {
                    setShowTestParametersModal(false);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showLetterRefDocModal}
        onHide={setShowLetterRefDocModal}
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Letter Ref Doc</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowLetterRefDocModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className="table-responsive active-projects style-1 shorting mb-2">
                  <div
                    id="MaterialPhotos-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="MaterialPhotos-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="2%"></th>
                          <th width="98%" style={{ textAlign: "left" }}>
                            File Name
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {listOfLetterRefDoc?.length > 0 ? (
                          listOfLetterRefDoc?.map((item, indx) => (
                            <tr key={indx}>
                              <td style={{ textAlign: "left" }}>
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="View"
                                  onClick={() => {
                                    window.open(
                                      item.LetterRefImageFilePath
                                        ? item.LetterRefImageFilePath
                                        : item.viewFile
                                    );
                                  }}
                                >
                                  <i className="fa fa-eye" />
                                </Link>
                              </td>
                              <td style={{ textAlign: "left" }}>
                                {item?.LetterRefImageFileName
                                  ? item?.LetterRefImageFileName
                                  : ""}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={2} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showMixDesignTestDetailModal}
        onHide={setShowMixDesignTestDetailModal}
        backdrop="static"
        size="xl"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikMixDesignTestDetails}>
            <Form onSubmit={formikMixDesignTestDetails.handleSubmit}>
              <Modal.Header>
                <Modal.Title>
                  {MixDesignTestName} (STIPULATIONS FOR PROPORTIONING)
                </Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowMixDesignTestDetailModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={4}>
                    <Field
                      name={"GradeDesignation"}
                      label={"Grade Designation"}
                      placeholder={"Grade Designation"}
                      component={CustomInput}
                      maxLength={200}
                      required
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      label="Type of Cement"
                      name="TypeofCementIDEncrypted"
                      placeholder={"Select Type of Cement"}
                      options={optionsTypeOfCement}
                      component={CustomSelect}
                    />
                  </Col>
                  <Col lg={4}>
                    <div className="mb-2">
                      <label className="mb-1">
                        Method of Concrete Placing &nbsp;
                      </label>
                      <div className="form-control form-control-sm">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`chkMethodofConcretePlacingIsChute_NonPumpable`}
                          name={`chkMethodofConcretePlacingIsChute_NonPumpable`}
                          checked={MethodofConcretePlacingIsChute_NonPumpable}
                          onChange={(e) => {
                            formikMixDesignTestDetails.setFieldValue(
                              "MethodofConcretePlacingIsChute_NonPumpable",
                              !MethodofConcretePlacingIsChute_NonPumpable
                            );
                          }}
                        />
                        <label className="mb-1 ms-1 me-2 mt-1">
                          Chute (Non pumpable) &nbsp;
                        </label>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`chkMethodofConcretePlacingIsPumping`}
                          name={`chkMethodofConcretePlacingIsPumping`}
                          checked={MethodofConcretePlacingIsPumping}
                          onChange={(e) => {
                            formikMixDesignTestDetails.setFieldValue(
                              "MethodofConcretePlacingIsPumping",
                              !MethodofConcretePlacingIsPumping
                            );
                          }}
                        />
                        <label className="mb-1 ms-1 mt-1">Pumping &nbsp;</label>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <Field
                      label="Type of Mineral Admixture"
                      name="TypeofMineralAdmixtureIDEncrypted"
                      placeholder={"Select Type of Mineral Admixture"}
                      options={optionsTypeOfMineralAdmixture}
                      component={CustomSelect}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      name={"DegreeofSiteControl"}
                      label={"Degree of Site Control"}
                      placeholder={"Degree of Site Control"}
                      component={CustomInput}
                      maxLength={200}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      label="Maximum Nominal Size of Aggregate"
                      name="MaximumNominalSizeofAggregateIDEncrypted"
                      placeholder={"Select Maximum Nominal Size of Aggregate"}
                      options={optionsMaximumNominalSizeofAggregate}
                      component={CustomSelect}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      name={"TypeofAggregateFineCoarse"}
                      label={"Type of Aggregate Fine Coarse"}
                      placeholder={"Type of Aggregate Fine Coarse"}
                      component={CustomInput}
                      maxLength={200}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      label="Type of Aggregate Fine"
                      name="TypeofAggregateFineIDEncrypted"
                      placeholder={"Select Type of Aggregate Fine"}
                      options={optionsTypeOfAggregateFine}
                      component={CustomSelect}
                    />
                  </Col>

                  <Col lg={4}>
                    <Field
                      label="Environmental Exposure Conditions"
                      name="EnvironmentalExposureConditionsIDEncrypted"
                      placeholder={"Select Environmental Exposure Conditions"}
                      options={optionsEnvironmentralExposureConditions}
                      component={CustomSelect}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      type="number"
                      name={"MaximumCementContent"}
                      label={"Maximum Cement Content (kg/m3)"}
                      placeholder={"Maximum Cement Content (kg/m3)"}
                      component={CustomInput}
                      maxLength={200}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      type="number"
                      name={"MinimumCementContent"}
                      label={"Minimum Cement Content (kg/m3)"}
                      placeholder={"Minimum Cement Content (kg/m3)"}
                      component={CustomInput}
                      maxLength={200}
                    />
                  </Col>

                  <Col lg={4}>
                    <Field
                      type="number"
                      name={"MaximumWaterCementRatio"}
                      label={"Maximum Water Cement Ratio"}
                      placeholder={"Maximum Water Cement Ratio"}
                      component={CustomInput}
                      maxLength={200}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      name={"Workability"}
                      label={"Workability"}
                      placeholder={"Workability"}
                      component={CustomInput}
                      maxLength={200}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      label="Chemical Admixture Type"
                      name="ChemicalAdmixtureTypeIDEncrypted"
                      placeholder={"Select Chemical Admixture Type"}
                      options={optionsChemicalAdmixtureType}
                      component={CustomSelect}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      label="Chemical Admixture Brand/Batch/ID Mark"
                      name="ChemicalAdmixtureBrandBatchandMarkIDEncrypted"
                      placeholder={"Chemical Admixture Brand/Batch/ID Mark"}
                      options={optionsChemicalAdmixtureBrandBatchMarkId}
                      component={CustomSelect}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      name="TransportationTime"
                      label={"Transportation Time"}
                      placeholder={"hh:mm"}
                      component={CustomFlatpickr}
                      options={{
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: "H:i", // Use 24-hour format (H: 0-23)
                        time_24hr: true, // Enforces 24-hour format
                        //allowInput: true, // Allows typing
                        minuteIncrement: 1, // Allows setting minutes with up/down arrows
                        static: true, //to solve up-down key not working in modal
                      }}
                    />
                  </Col>
                  <Col lg={4}>
                    <Field
                      name="RetentionTime"
                      label={"Retention Time"}
                      placeholder={"hh:mm"}
                      component={CustomFlatpickr}
                      options={{
                        enableTime: true,
                        noCalendar: true,
                        dateFormat: "H:i", // Use 24-hour format (H: 0-23)
                        time_24hr: true, // Enforces 24-hour format
                        //allowInput: true, // Allows typing
                        minuteIncrement: 1, // Allows setting minutes with up/down arrows
                        static: true, //to solve up-down key not working in modal
                      }}
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  // className="btn btn-primary"
                  variant="primary btn-sm"
                  type="submit"
                >
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </Button>

                <Button
                  // className="btn btn-danger light"
                  variant="danger btn-sm"
                  onClick={() => {
                    setShowMixDesignTestDetailModal(false);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showDefineMoreRatesModal}
        onHide={setShowDefineMoreRatesModal}
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikDefineMoreRates}>
            <Form onSubmit={formikDefineMoreRates.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Define More Rates</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowDefineMoreRatesModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="DefineMoreRates-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="DefineMoreRates-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead className="fixedheader">
                            <tr>
                              <th width="5%" className="ps-1"></th>
                              <th width="95%" style={{ textAlign: "left" }}>
                                Rate Type
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {MoreTestRatesList?.length > 0 ? (
                              MoreTestRatesList?.map((tRate, tRateindx) => (
                                <tr key={`para_${tRateindx}`}>
                                  <td className="p-1">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkIsSelected${tRateindx}`}
                                      name={`chkIsSelected${tRateindx}`}
                                      checked={tRate.IsSelected}
                                      onChange={(e) => {
                                        formikDefineMoreRates.setFieldValue(
                                          `MoreTestRatesList[${tRateindx}].IsSelected`,
                                          e?.target?.checked
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    {tRate.RateTypeName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={2}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                {MoreTestRatesList?.length > 0 ? (
                  <Button variant="primary btn-sm" type="submit">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                ) : (
                  ""
                )}
                <Button
                  variant="danger btn-sm"
                  onClick={() => setShowDefineMoreRatesModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showInwardTestDefineMoreRateModal}
        onHide={setShowInwardTestDefineMoreRateModal}
        backdrop="static"
        size="lg"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikInwardTestDefineMoreRates}>
            <Form onSubmit={formikInwardTestDefineMoreRates.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Define More Rates</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowInwardTestDefineMoreRateModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={6}>
                    <label>Inward No: </label>{" "}
                    {formikInwardTestDefineMoreRates?.values?.InwardNo}
                  </Col>
                  <Col lg={6}>
                    <label>Inward Date: </label>{" "}
                    {formikInwardTestDefineMoreRates?.values?.InwardDate}
                  </Col>
                  <Col lg={12}>
                    <label>Customer: </label>{" "}
                    {formikInwardTestDefineMoreRates?.values?.CustomerName}
                  </Col>
                  <Col lg={12}>
                    <label>Project: </label>{" "}
                    {
                      formikInwardTestDefineMoreRates?.values
                        ?.CustomerProjectName
                    }
                  </Col>
                  <Col lg={12}>
                    <Accordion
                      className="accordion accordion-solid-bg"
                      defaultActiveKey="0"
                    >
                      {formikInwardTestDefineMoreRates?.values?.InwardMaterialList?.map(
                        (item, indx) => (
                          <Accordion.Item
                            className="accordion-item m-0"
                            key={indx}
                            eventKey={indx.toString()}
                          >
                            <Accordion.Header className="accordion-header rounded-lg">
                              {item?.TCNo}
                            </Accordion.Header>
                            <Accordion.Collapse eventKey={indx.toString()}>
                              <div className="accordion-body p-0">
                                <div className="table-responsive active-projects style-1 shorting">
                                  <div
                                    id="MaterialTestInfo-tbl_wrapper"
                                    className="dataTables_wrapper table-responsive no-footer"
                                  >
                                    <table
                                      id="MaterialTestInfo-tbl"
                                      className="table table-bordered no-footer mb-0"
                                    >
                                      <thead>
                                        <tr>
                                          <th className="newPara"></th>
                                          <th width="60%" className="newPara">
                                            Test
                                          </th>
                                          <th
                                            width="40%"
                                            className="newPara"
                                            style={{
                                              textAlign: "left",
                                            }}
                                          >
                                            Department
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item?.TestDetailList?.map(
                                          (test, tIndx) => (
                                            <tr key={tIndx}>
                                              <td className="p-1">
                                                <Link
                                                  to="#"
                                                  className="icon-box icon-box-md bg-primary-light"
                                                  title="Define More Rates Selection"
                                                  onClick={() => {
                                                    handleOnClickInwardTestDefineMoreRatesSelection(
                                                      indx,
                                                      tIndx,
                                                      test?.DefineMoreRateList,
                                                      test?.TestMasterIDEncrypted,
                                                      test?.InwardMaterialTestDetailIDEncrypted,
                                                      test?.TestName
                                                    );
                                                  }}
                                                >
                                                  {SVGICON.Rates}
                                                </Link>
                                              </td>
                                              <td>{test?.TestName}</td>
                                              <td style={{ textAlign: "left" }}>
                                                {test?.DepartmentName}
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Collapse>
                          </Accordion.Item>
                        )
                      )}
                    </Accordion>
                  </Col>
                </Row>
                {showInwardTestDefineMoreRateSelectionModal == true && (
                  <div className="fade modal-backdrop show"></div>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary btn-sm" type="submit">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </Button>
                <Button
                  variant="danger btn-sm"
                  onClick={() => setShowInwardTestDefineMoreRateModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
      <Modal
        className="fade"
        show={showInwardTestDefineMoreRateSelectionModal}
        onHide={setShowInwardTestDefineMoreRateSelectionModal}
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikInwardTestDefineMoreRateSelection}>
            <Form
              onSubmit={formikInwardTestDefineMoreRateSelection.handleSubmit}
            >
              <Modal.Header>
                <Modal.Title>
                  {formikInwardTestDefineMoreRateSelection?.values?.TestName}
                </Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() =>
                    setShowInwardTestDefineMoreRateSelectionModal(false)
                  }
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="DefineMoreRateSelection-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="DefineMoreRateSelection-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead className="fixedheader">
                            <tr>
                              <th width="5%" className="ps-1"></th>
                              <th width="95%" style={{ textAlign: "left" }}>
                                Rate Type
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {MoreTestRateSelectionList?.length > 0 ? (
                              MoreTestRateSelectionList?.map(
                                (tRate, tRateindx) => (
                                  <tr key={`para_${tRateindx}`}>
                                    <td className="p-1">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`chkIsSelected${tRateindx}`}
                                        name={`chkIsSelected${tRateindx}`}
                                        checked={tRate.IsSelected}
                                        onChange={(e) => {
                                          formikInwardTestDefineMoreRateSelection.setFieldValue(
                                            `MoreTestRateSelectionList[${tRateindx}].IsSelected`,
                                            e?.target?.checked
                                          );
                                        }}
                                      />
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      {tRate.RateTypeName}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={2}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                  {MoreTestRateSelectionList?.filter(
                    (e) => e.IsSelected == true && e.RateType == 4 //Based On Measurement
                  )?.length > 0 ? (
                    <Col lg={6}>
                      <Field
                        type="number"
                        label={"Based On Measurement Value"}
                        name="BasedOnMeasurementValue"
                        placeholder={"Enter Based On Measurement Value"}
                        component={CustomInput}
                        maxLength={20}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                  {MoreTestRateSelectionList?.filter(
                    (e) => e.IsSelected == true && e.RateType == 7 //Based On Hrs
                  )?.length > 0 ? (
                    <Col lg={6}>
                      <Field
                        type="number"
                        label={"Based On Hrs Value"}
                        name="BasedOnHrsValue"
                        placeholder={"Enter Based On Hrs Value"}
                        component={CustomInput}
                        maxLength={20}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              </Modal.Body>
              <Modal.Footer>
                {MoreTestRateSelectionList?.length > 0 ? (
                  <Button variant="primary btn-sm" type="submit">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                ) : (
                  ""
                )}
                <Button
                  variant="danger btn-sm"
                  onClick={() =>
                    setShowInwardTestDefineMoreRateSelectionModal(false)
                  }
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
    </>
  );
};

export default SamplePreparationAndTesting;
